/* tslint:disable */
/* This is generated by ts_routes-rails */

export type ScalarType = string | number | boolean;

function $buildOptions(options: any, names: string[]): string {
  if (options) {
    let anchor = "";
    const q = [] as string[];
    for (const key of Object.keys(options)) {
      if (names.indexOf(key) !== -1) {
        // the key is already consumed
        continue;
      }

      const value = options[key];

      if (key === "anchor") {
        anchor = `#${$encode(value)}`;
      } else {
        $buildQuery(q, key, value);
      }
    }
    return (q.length > 0 ? "?" + q.join("&") : "") + anchor;
  } else {
    return "";
  }
}

function $buildQuery(q: string[], key: string, value: any) {
  if ($isScalarType(value)) {
    q.push(`${$encode(key)}=${$encode(value)}`);
  } else if (Array.isArray(value)) {
    for (const v of value) {
      $buildQuery(q, `${key}[]`, v);
    }
  } else if (value != null) {
    // i.e. non-null, non-scalar, non-array type
    for (const k of Object.keys(value)) {
      $buildQuery(q, `${key}[${k}]`, value[k]);
    }
  }
}

function $encode(value: any): string {
  return encodeURIComponent(value);
}

function $isScalarType(value: any): value is ScalarType {
  return (
    typeof value === "string" ||
    typeof value === "number" ||
    typeof value === "boolean"
  );
}

function $isPresent(value: any): boolean {
  return value != null && ("" + value).length > 0;
}

function $hasPresentOwnProperty(options: any, key: string): boolean {
  return options && options.hasOwnProperty(key) && $isPresent(options[key]);
}

/** /rails/info/properties(.:format) */
export function railsInfoPropertiesPath(options?: object): string {
  return "/" + "rails" + "/" + "info" + "/" + "properties" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /rails/info/routes(.:format) */
export function railsInfoRoutesPath(options?: object): string {
  return "/" + "rails" + "/" + "info" + "/" + "routes" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /rails/info(.:format) */
export function railsInfoPath(options?: object): string {
  return "/" + "rails" + "/" + "info" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /rails/mailers(.:format) */
export function railsMailersPath(options?: object): string {
  return "/" + "rails" + "/" + "mailers" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /healthcheck(.:format) */
export function healthcheckPath(options?: object): string {
  return "/" + "healthcheck" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /email/inbound(.:format) */
export function emailInboundEmailsPath(options?: object): string {
  return "/" + "email" + "/" + "inbound" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /email/events(.:format) */
export function emailEventsPath(options?: object): string {
  return "/" + "email" + "/" + "events" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /integrations/e_signatures/events(.:format) */
export function integrationsESignaturesEventsPath(options?: object): string {
  return "/" + "integrations" + "/" + "e_signatures" + "/" + "events" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /integrations/bryq_completed_assessments/completed_assessments(.:format) */
export function integrationsBryqCompletedAssessmentsCompletedAssessmentsPath(options?: object): string {
  return "/" + "integrations" + "/" + "bryq_completed_assessments" + "/" + "completed_assessments" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /integrations/cappfinity_assessment_complete/events(.:format) */
export function integrationsCappfinityAssessmentCompleteEventsPath(options?: object): string {
  return "/" + "integrations" + "/" + "cappfinity_assessment_complete" + "/" + "events" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /integrations/cappfinity_event_complete/events(.:format) */
export function integrationsCappfinityEventCompleteEventsPath(options?: object): string {
  return "/" + "integrations" + "/" + "cappfinity_event_complete" + "/" + "events" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /integrations/certn_background_check/events(.:format) */
export function integrationsCertnBackgroundCheckEventsPath(options?: object): string {
  return "/" + "integrations" + "/" + "certn_background_check" + "/" + "events" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /integrations/checkr_background_check/events(.:format) */
export function integrationsCheckrBackgroundCheckEventsPath(options?: object): string {
  return "/" + "integrations" + "/" + "checkr_background_check" + "/" + "events" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /integrations/codility_assessment_complete/events(.:format) */
export function integrationsCodilityAssessmentCompleteEventsPath(options?: object): string {
  return "/" + "integrations" + "/" + "codility_assessment_complete" + "/" + "events" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /integrations/creative_services_inc_background_check_complete/events(.:format) */
export function integrationsCreativeServicesIncBackgroundCheckCompleteEventsPath(options?: object): string {
  return "/" + "integrations" + "/" + "creative_services_inc_background_check_complete" + "/" + "events" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /integrations/cronofy/push_notifications(.:format) */
export function integrationsCronofyPushNotificationsPath(options?: object): string {
  return "/" + "integrations" + "/" + "cronofy" + "/" + "push_notifications" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /integrations/cronofy/authorizations(.:format) */
export function integrationsCronofyAuthorizationsPath(options?: object): string {
  return "/" + "integrations" + "/" + "cronofy" + "/" + "authorizations" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /integrations/docu_sign_envelope_complete/events(.:format) */
export function integrationsDocuSignEnvelopeCompleteEventsPath(options?: object): string {
  return "/" + "integrations" + "/" + "docu_sign_envelope_complete" + "/" + "events" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /integrations/google/sitemap_index(.:format) */
export function integrationsGoogleSitemapIndexPath(options?: object): string {
  return "/" + "integrations" + "/" + "google" + "/" + "sitemap_index" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /integrations/hacker_rank_assessment_complete/events(.:format) */
export function integrationsHackerRankAssessmentCompleteEventsPath(options?: object): string {
  return "/" + "integrations" + "/" + "hacker_rank_assessment_complete" + "/" + "events" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /integrations/jot_form_completed_forms/events(.:format) */
export function integrationsJotFormCompletedFormsEventsPath(options?: object): string {
  return "/" + "integrations" + "/" + "jot_form_completed_forms" + "/" + "events" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /integrations/pinpoint/webhooks(.:format) */
export function integrationsPinpointWebhooksPath(options?: object): string {
  return "/" + "integrations" + "/" + "pinpoint" + "/" + "webhooks" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /integrations/indeed_apply/events(.:format) */
export function integrationsIndeedApplyEventsPath(options?: object): string {
  return "/" + "integrations" + "/" + "indeed_apply" + "/" + "events" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /integrations/providers/affinda/events(.:format) */
export function integrationsProvidersAffindaEventsPath(options?: object): string {
  return "/" + "integrations" + "/" + "providers" + "/" + "affinda" + "/" + "events" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /integrations/providers/alva_labs/events(.:format) */
export function integrationsProvidersAlvaLabsEventsPath(options?: object): string {
  return "/" + "integrations" + "/" + "providers" + "/" + "alva_labs" + "/" + "events" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /integrations/providers/shl/events(.:format) */
export function integrationsProvidersShlEventsPath(options?: object): string {
  return "/" + "integrations" + "/" + "providers" + "/" + "shl" + "/" + "events" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /integrations/providers/bizimply/sessions(.:format) */
export function integrationsProvidersBizimplySessionsPath(options?: object): string {
  return "/" + "integrations" + "/" + "providers" + "/" + "bizimply" + "/" + "sessions" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /integrations/providers/canditech/events(.:format) */
export function integrationsProvidersCanditechEventsPath(options?: object): string {
  return "/" + "integrations" + "/" + "providers" + "/" + "canditech" + "/" + "events" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /integrations/providers/certn_centric/events(.:format) */
export function integrationsProvidersCertnCentricEventsPath(options?: object): string {
  return "/" + "integrations" + "/" + "providers" + "/" + "certn_centric" + "/" + "events" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /integrations/providers/criteria/events(.:format) */
export function integrationsProvidersCriteriaEventsPath(options?: object): string {
  return "/" + "integrations" + "/" + "providers" + "/" + "criteria" + "/" + "events" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /integrations/providers/cv_library/events(.:format) */
export function integrationsProvidersCvLibraryEventsPath(options?: object): string {
  return "/" + "integrations" + "/" + "providers" + "/" + "cv_library" + "/" + "events" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /integrations/providers/docu_seal/events(.:format) */
export function integrationsProvidersDocuSealEventsPath(options?: object): string {
  return "/" + "integrations" + "/" + "providers" + "/" + "docu_seal" + "/" + "events" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /integrations/providers/first_advantage/events(.:format) */
export function integrationsProvidersFirstAdvantageEventsPath(options?: object): string {
  return "/" + "integrations" + "/" + "providers" + "/" + "first_advantage" + "/" + "events" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /integrations/providers/first_advantage_kyp/events(.:format) */
export function integrationsProvidersFirstAdvantageKypEventsPath(options?: object): string {
  return "/" + "integrations" + "/" + "providers" + "/" + "first_advantage_kyp" + "/" + "events" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /integrations/providers/hireflix/events(.:format) */
export function integrationsProvidersHireflixEventsPath(options?: object): string {
  return "/" + "integrations" + "/" + "providers" + "/" + "hireflix" + "/" + "events" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /integrations/providers/hire_right/events(.:format) */
export function integrationsProvidersHireRightEventsPath(options?: object): string {
  return "/" + "integrations" + "/" + "providers" + "/" + "hire_right" + "/" + "events" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /integrations/providers/hubspot/new_deals/events(.:format) */
export function integrationsProvidersHubspotNewDealsEventsPath(options?: object): string {
  return "/" + "integrations" + "/" + "providers" + "/" + "hubspot" + "/" + "new_deals" + "/" + "events" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /integrations/providers/mevitae/events(.:format) */
export function integrationsProvidersMevitaeEventsPath(options?: object): string {
  return "/" + "integrations" + "/" + "providers" + "/" + "mevitae" + "/" + "events" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /integrations/providers/outmatch/events(.:format) */
export function integrationsProvidersOutmatchEventsPath(options?: object): string {
  return "/" + "integrations" + "/" + "providers" + "/" + "outmatch" + "/" + "events" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /integrations/providers/predictive_index/events(.:format) */
export function integrationsProvidersPredictiveIndexEventsPath(options?: object): string {
  return "/" + "integrations" + "/" + "providers" + "/" + "predictive_index" + "/" + "events" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /integrations/providers/rippling/install(.:format) */
export function integrationsProvidersRipplingInstallPath(options?: object): string {
  return "/" + "integrations" + "/" + "providers" + "/" + "rippling" + "/" + "install" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /integrations/providers/seek/events(.:format) */
export function integrationsProvidersSeekEventsPath(options?: object): string {
  return "/" + "integrations" + "/" + "providers" + "/" + "seek" + "/" + "events" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /integrations/providers/sterling/events(.:format) */
export function integrationsProvidersSterlingEventsPath(options?: object): string {
  return "/" + "integrations" + "/" + "providers" + "/" + "sterling" + "/" + "events" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /integrations/providers/trust_id/events(.:format) */
export function integrationsProvidersTrustIdEventsPath(options?: object): string {
  return "/" + "integrations" + "/" + "providers" + "/" + "trust_id" + "/" + "events" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /integrations/providers/twilio/inbound_messages(.:format) */
export function integrationsProvidersTwilioInboundMessagesPath(options?: object): string {
  return "/" + "integrations" + "/" + "providers" + "/" + "twilio" + "/" + "inbound_messages" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /integrations/providers/twilio/events(.:format) */
export function integrationsProvidersTwilioEventsPath(options?: object): string {
  return "/" + "integrations" + "/" + "providers" + "/" + "twilio" + "/" + "events" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /integrations/providers/interns_programme/events(.:format) */
export function integrationsProvidersInternsProgrammeEventsPath(options?: object): string {
  return "/" + "integrations" + "/" + "providers" + "/" + "interns_programme" + "/" + "events" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /integrations/providers/itrent/events(.:format) */
export function integrationsProvidersItrentEventsPath(options?: object): string {
  return "/" + "integrations" + "/" + "providers" + "/" + "itrent" + "/" + "events" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /integrations/providers/willo/events(.:format) */
export function integrationsProvidersWilloEventsPath(options?: object): string {
  return "/" + "integrations" + "/" + "providers" + "/" + "willo" + "/" + "events" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /integrations/providers/yoti/events(.:format) */
export function integrationsProvidersYotiEventsPath(options?: object): string {
  return "/" + "integrations" + "/" + "providers" + "/" + "yoti" + "/" + "events" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /integrations/providers/zinc/events(.:format) */
export function integrationsProvidersZincEventsPath(options?: object): string {
  return "/" + "integrations" + "/" + "providers" + "/" + "zinc" + "/" + "events" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /integrations/ref_now_completed_references/events(.:format) */
export function integrationsRefNowCompletedReferencesEventsPath(options?: object): string {
  return "/" + "integrations" + "/" + "ref_now_completed_references" + "/" + "events" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /integrations/talent_dot_com_quick_apply/events(.:format) */
export function integrationsTalentDotComQuickApplyEventsPath(options?: object): string {
  return "/" + "integrations" + "/" + "talent_dot_com_quick_apply" + "/" + "events" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /integrations/total_jobs_quick_apply/events/apply(.:format) */
export function applyIntegrationsTotalJobsQuickApplyEventsPath(options?: object): string {
  return "/" + "integrations" + "/" + "total_jobs_quick_apply" + "/" + "events" + "/" + "apply" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /integrations/total_jobs_quick_apply/events/inquiry(.:format) */
export function inquiryIntegrationsTotalJobsQuickApplyEventsPath(options?: object): string {
  return "/" + "integrations" + "/" + "total_jobs_quick_apply" + "/" + "events" + "/" + "inquiry" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /integrations/zip_recruiter_apply/events(.:format) */
export function integrationsZipRecruiterApplyEventsPath(options?: object): string {
  return "/" + "integrations" + "/" + "zip_recruiter_apply" + "/" + "events" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /integrations/zip_recruiter_premium_apply/events(.:format) */
export function integrationsZipRecruiterPremiumApplyEventsPath(options?: object): string {
  return "/" + "integrations" + "/" + "zip_recruiter_premium_apply" + "/" + "events" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /integration_plugins/candidate_assessments/redirect/:uuid(.:format) */
export function integrationPluginsCandidateAssessmentsRedirectPath(uuid: ScalarType, options?: object): string {
  return "/" + "integration_plugins" + "/" + "candidate_assessments" + "/" + "redirect" + "/" + uuid + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["uuid","format"]);
}

/** /integration_plugins/webhooks/events/:integration_plugin_uuid(.:format) */
export function integrationPluginsWebhooksPath(integration_plugin_uuid: ScalarType, options?: object): string {
  return "/" + "integration_plugins" + "/" + "webhooks" + "/" + "events" + "/" + integration_plugin_uuid + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["integration_plugin_uuid","format"]);
}

/** /external_messages/sms/events(.:format) */
export function externalMessagesSmsEventsPath(options?: object): string {
  return "/" + "external_messages" + "/" + "sms" + "/" + "events" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /mydata(.:format) */
export function mydataPath(options?: object): string {
  return "/" + "mydata" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /mydata/gdpr_access_tokens(.:format) */
export function mydataGdprAccessTokensPath(options?: object): string {
  return "/" + "mydata" + "/" + "gdpr_access_tokens" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /mydata/gdpr_access_tokens/new(.:format) */
export function newMydataGdprAccessTokenPath(options?: object): string {
  return "/" + "mydata" + "/" + "gdpr_access_tokens" + "/" + "new" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /mydata/applications/purge(.:format) */
export function purgeMydataApplicationsPath(options?: object): string {
  return "/" + "mydata" + "/" + "applications" + "/" + "purge" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /mydata/applications(.:format) */
export function mydataApplicationsPath(options?: object): string {
  return "/" + "mydata" + "/" + "applications" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /mydata/job_seekers/purge(.:format) */
export function purgeMydataJobSeekersPath(options?: object): string {
  return "/" + "mydata" + "/" + "job_seekers" + "/" + "purge" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /mydata/job_seekers(.:format) */
export function mydataJobSeekersPath(options?: object): string {
  return "/" + "mydata" + "/" + "job_seekers" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /mydata/job_seekers/reconsent/confirm(.:format) */
export function mydataJobSeekersReconsentConfirmPath(options?: object): string {
  return "/" + "mydata" + "/" + "job_seekers" + "/" + "reconsent" + "/" + "confirm" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /platform(.:format) */
export function platformRootPath(options?: object): string {
  return "/" + "platform" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /platform/sidekiq */
export function platformSidekiqWebPath(options?: object): string {
  return "/" + "platform" + "/" + "sidekiq" + $buildOptions(options, []);
}

/** /platform/admins/sign_in(.:format) */
export function newPlatformAdminSessionPath(options?: object): string {
  return "/" + "platform" + "/" + "admins" + "/" + "sign_in" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /platform/admins/sign_in(.:format) */
export function platformAdminSessionPath(options?: object): string {
  return "/" + "platform" + "/" + "admins" + "/" + "sign_in" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /platform/admins/sign_out(.:format) */
export function destroyPlatformAdminSessionPath(options?: object): string {
  return "/" + "platform" + "/" + "admins" + "/" + "sign_out" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /platform/login(.:format) */
export function platformLoginPath(options?: object): string {
  return "/" + "platform" + "/" + "login" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /platform/companies/:company_id/automation_executions(.:format) */
export function platformCompanyAutomationExecutionsPath(company_id: ScalarType, options?: object): string {
  return "/" + "platform" + "/" + "companies" + "/" + company_id + "/" + "automation_executions" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["company_id","format"]);
}

/** /platform/companies/:company_id/workflow_automations(.:format) */
export function platformCompanyWorkflowAutomationsPath(company_id: ScalarType, options?: object): string {
  return "/" + "platform" + "/" + "companies" + "/" + company_id + "/" + "workflow_automations" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["company_id","format"]);
}

/** /platform/companies/:company_id/webhook_endpoints(.:format) */
export function platformCompanyWebhookEndpointsPath(company_id: ScalarType, options?: object): string {
  return "/" + "platform" + "/" + "companies" + "/" + company_id + "/" + "webhook_endpoints" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["company_id","format"]);
}

/** /platform/companies/:company_id/ad_hoc_tooling_sign_off_workflows/select_workflow(.:format) */
export function selectWorkflowPlatformCompanyAdHocToolingSignOffWorkflowsPath(company_id: ScalarType, options?: object): string {
  return "/" + "platform" + "/" + "companies" + "/" + company_id + "/" + "ad_hoc_tooling_sign_off_workflows" + "/" + "select_workflow" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["company_id","format"]);
}

/** /platform/companies/:company_id/ad_hoc_tooling_sign_off_workflows(.:format) */
export function platformCompanyAdHocToolingSignOffWorkflowsPath(company_id: ScalarType, options?: object): string {
  return "/" + "platform" + "/" + "companies" + "/" + company_id + "/" + "ad_hoc_tooling_sign_off_workflows" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["company_id","format"]);
}

/** /platform/companies/:company_id/ad_hoc_tooling_workflow_automations_copilot/capability_search(.:format) */
export function capabilitySearchPlatformCompanyAdHocToolingWorkflowAutomationsCopilotIndexPath(company_id: ScalarType, options?: object): string {
  return "/" + "platform" + "/" + "companies" + "/" + company_id + "/" + "ad_hoc_tooling_workflow_automations_copilot" + "/" + "capability_search" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["company_id","format"]);
}

/** /platform/companies/:company_id/ad_hoc_tooling_workflow_automations_copilot(.:format) */
export function platformCompanyAdHocToolingWorkflowAutomationsCopilotIndexPath(company_id: ScalarType, options?: object): string {
  return "/" + "platform" + "/" + "companies" + "/" + company_id + "/" + "ad_hoc_tooling_workflow_automations_copilot" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["company_id","format"]);
}

/** /platform/companies/:company_id/ad_hoc_tooling_cache_purges/purge_soft(.:format) */
export function purgeSoftPlatformCompanyAdHocToolingCachePurgesPath(company_id: ScalarType, options?: object): string {
  return "/" + "platform" + "/" + "companies" + "/" + company_id + "/" + "ad_hoc_tooling_cache_purges" + "/" + "purge_soft" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["company_id","format"]);
}

/** /platform/companies/:company_id/ad_hoc_tooling_cache_purges/purge_hard(.:format) */
export function purgeHardPlatformCompanyAdHocToolingCachePurgesPath(company_id: ScalarType, options?: object): string {
  return "/" + "platform" + "/" + "companies" + "/" + company_id + "/" + "ad_hoc_tooling_cache_purges" + "/" + "purge_hard" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["company_id","format"]);
}

/** /platform/companies/:company_id/ad_hoc_tooling_cache_purges(.:format) */
export function platformCompanyAdHocToolingCachePurgesPath(company_id: ScalarType, options?: object): string {
  return "/" + "platform" + "/" + "companies" + "/" + company_id + "/" + "ad_hoc_tooling_cache_purges" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["company_id","format"]);
}

/** /platform/companies/:company_id/ad_hoc_tooling_fastly_status(.:format) */
export function platformCompanyAdHocToolingFastlyStatusIndexPath(company_id: ScalarType, options?: object): string {
  return "/" + "platform" + "/" + "companies" + "/" + company_id + "/" + "ad_hoc_tooling_fastly_status" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["company_id","format"]);
}

/** /platform/companies/:company_id/talent_pipeline/talent_pools(.:format) */
export function platformCompanyTalentPipelineTalentPoolsPath(company_id: ScalarType, options?: object): string {
  return "/" + "platform" + "/" + "companies" + "/" + company_id + "/" + "talent_pipeline" + "/" + "talent_pools" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["company_id","format"]);
}

/** /platform/companies/:company_id/careers_sites(.:format) */
export function platformCompanyCareersSitesPath(company_id: ScalarType, options?: object): string {
  return "/" + "platform" + "/" + "companies" + "/" + company_id + "/" + "careers_sites" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["company_id","format"]);
}

/** /platform/companies/:company_id/careers_sites/:id(.:format) */
export function platformCompanyCareersSitePath(company_id: ScalarType, id: ScalarType, options?: object): string {
  return "/" + "platform" + "/" + "companies" + "/" + company_id + "/" + "careers_sites" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["company_id","id","format"]);
}

/** /platform/companies/:company_id/themes/fetch_brand(.:format) */
export function fetchBrandPlatformCompanyThemesPath(company_id: ScalarType, options?: object): string {
  return "/" + "platform" + "/" + "companies" + "/" + company_id + "/" + "themes" + "/" + "fetch_brand" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["company_id","format"]);
}

/** /platform/companies/:company_id/themes(.:format) */
export function platformCompanyThemesPath(company_id: ScalarType, options?: object): string {
  return "/" + "platform" + "/" + "companies" + "/" + company_id + "/" + "themes" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["company_id","format"]);
}

/** /platform/companies/:company_id/onboarding_portals(.:format) */
export function platformCompanyOnboardingPortalsPath(company_id: ScalarType, options?: object): string {
  return "/" + "platform" + "/" + "companies" + "/" + company_id + "/" + "onboarding_portals" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["company_id","format"]);
}

/** /platform/companies/:company_id/onboarding_portals/:id(.:format) */
export function platformCompanyOnboardingPortalPath(company_id: ScalarType, id: ScalarType, options?: object): string {
  return "/" + "platform" + "/" + "companies" + "/" + company_id + "/" + "onboarding_portals" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["company_id","id","format"]);
}

/** /platform/companies/:company_id/demo_applications(.:format) */
export function platformCompanyDemoApplicationsPath(company_id: ScalarType, options?: object): string {
  return "/" + "platform" + "/" + "companies" + "/" + company_id + "/" + "demo_applications" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["company_id","format"]);
}

/** /platform/companies/:company_id/demo_job_seekers(.:format) */
export function platformCompanyDemoJobSeekersPath(company_id: ScalarType, options?: object): string {
  return "/" + "platform" + "/" + "companies" + "/" + company_id + "/" + "demo_job_seekers" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["company_id","format"]);
}

/** /platform/companies/:company_id/integration_plugins(.:format) */
export function platformCompanyIntegrationPluginsPath(company_id: ScalarType, options?: object): string {
  return "/" + "platform" + "/" + "companies" + "/" + company_id + "/" + "integration_plugins" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["company_id","format"]);
}

/** /platform/companies/:company_id/job_seekers(.:format) */
export function platformCompanyJobSeekersPath(company_id: ScalarType, options?: object): string {
  return "/" + "platform" + "/" + "companies" + "/" + company_id + "/" + "job_seekers" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["company_id","format"]);
}

/** /platform/companies/:company_id/job_seekers/new(.:format) */
export function newPlatformCompanyJobSeekerPath(company_id: ScalarType, options?: object): string {
  return "/" + "platform" + "/" + "companies" + "/" + company_id + "/" + "job_seekers" + "/" + "new" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["company_id","format"]);
}

/** /platform/companies/:company_id/jobs/deleted(.:format) */
export function deletedPlatformCompanyJobsPath(company_id: ScalarType, options?: object): string {
  return "/" + "platform" + "/" + "companies" + "/" + company_id + "/" + "jobs" + "/" + "deleted" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["company_id","format"]);
}

/** /platform/companies/:company_id/jobs/normalise_stage_lane_positions(.:format) */
export function normaliseStageLanePositionsPlatformCompanyJobsPath(company_id: ScalarType, options?: object): string {
  return "/" + "platform" + "/" + "companies" + "/" + company_id + "/" + "jobs" + "/" + "normalise_stage_lane_positions" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["company_id","format"]);
}

/** /platform/companies/:company_id/jobs(.:format) */
export function platformCompanyJobsPath(company_id: ScalarType, options?: object): string {
  return "/" + "platform" + "/" + "companies" + "/" + company_id + "/" + "jobs" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["company_id","format"]);
}

/** /platform/companies/:company_id/job_postings(.:format) */
export function platformCompanyJobPostingsPath(company_id: ScalarType, options?: object): string {
  return "/" + "platform" + "/" + "companies" + "/" + company_id + "/" + "job_postings" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["company_id","format"]);
}

/** /platform/companies/:company_id/legacy/sign_off_workflows(.:format) */
export function platformCompanyLegacySignOffWorkflowsPath(company_id: ScalarType, options?: object): string {
  return "/" + "platform" + "/" + "companies" + "/" + company_id + "/" + "legacy" + "/" + "sign_off_workflows" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["company_id","format"]);
}

/** /platform/companies/:company_id/jobs_widget(.:format) */
export function platformCompanyJobsWidgetIndexPath(company_id: ScalarType, options?: object): string {
  return "/" + "platform" + "/" + "companies" + "/" + company_id + "/" + "jobs_widget" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["company_id","format"]);
}

/** /platform/companies/:company_id/indeed_feed_jobs(.:format) */
export function platformCompanyIndeedFeedJobsPath(company_id: ScalarType, options?: object): string {
  return "/" + "platform" + "/" + "companies" + "/" + company_id + "/" + "indeed_feed_jobs" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["company_id","format"]);
}

/** /platform/companies/:company_id/indeed_feed_jobs/export(.:format) */
export function exportPlatformCompanyIndeedFeedJobsPath(company_id: ScalarType, options?: object): string {
  return "/" + "platform" + "/" + "companies" + "/" + company_id + "/" + "indeed_feed_jobs" + "/" + "export" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["company_id","format"]);
}

/** /platform/companies/:company_id/limited_access_grants/grant_careers_editor(.:format) */
export function grantCareersEditorPlatformCompanyLimitedAccessGrantsPath(company_id: ScalarType, options?: object): string {
  return "/" + "platform" + "/" + "companies" + "/" + company_id + "/" + "limited_access_grants" + "/" + "grant_careers_editor" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["company_id","format"]);
}

/** /platform/companies/:company_id/limited_access_grants(.:format) */
export function platformCompanyLimitedAccessGrantsPath(company_id: ScalarType, options?: object): string {
  return "/" + "platform" + "/" + "companies" + "/" + company_id + "/" + "limited_access_grants" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["company_id","format"]);
}

/** /platform/companies/:company_id/linked_in_postings(.:format) */
export function platformCompanyLinkedInPostingsPath(company_id: ScalarType, options?: object): string {
  return "/" + "platform" + "/" + "companies" + "/" + company_id + "/" + "linked_in_postings" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["company_id","format"]);
}

/** /platform/companies/:company_id/inbound_requests(.:format) */
export function platformCompanyInboundRequestsPath(company_id: ScalarType, options?: object): string {
  return "/" + "platform" + "/" + "companies" + "/" + company_id + "/" + "inbound_requests" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["company_id","format"]);
}

/** /platform/companies/:company_id/outbound_requests(.:format) */
export function platformCompanyOutboundRequestsPath(company_id: ScalarType, options?: object): string {
  return "/" + "platform" + "/" + "companies" + "/" + company_id + "/" + "outbound_requests" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["company_id","format"]);
}

/** /platform/companies/:company_id/onboarding_applications(.:format) */
export function platformCompanyOnboardingApplicationsPath(company_id: ScalarType, options?: object): string {
  return "/" + "platform" + "/" + "companies" + "/" + company_id + "/" + "onboarding_applications" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["company_id","format"]);
}

/** /platform/companies/:company_id/package(.:format) */
export function platformCompanyPackagePath(company_id: ScalarType, options?: object): string {
  return "/" + "platform" + "/" + "companies" + "/" + company_id + "/" + "package" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["company_id","format"]);
}

/** /platform/companies/:company_id/preference(.:format) */
export function platformCompanyPreferencePath(company_id: ScalarType, options?: object): string {
  return "/" + "platform" + "/" + "companies" + "/" + company_id + "/" + "preference" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["company_id","format"]);
}

/** /platform/companies/:company_id/release_lifecycle(.:format) */
export function platformCompanyReleaseLifecyclePath(company_id: ScalarType, options?: object): string {
  return "/" + "platform" + "/" + "companies" + "/" + company_id + "/" + "release_lifecycle" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["company_id","format"]);
}

/** /platform/companies/:company_id/credit_based_add_ons(.:format) */
export function platformCompanyCreditBasedAddOnsPath(company_id: ScalarType, options?: object): string {
  return "/" + "platform" + "/" + "companies" + "/" + company_id + "/" + "credit_based_add_ons" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["company_id","format"]);
}

/** /platform/companies/:company_id/organisation/structure_custom_group_ones(.:format) */
export function platformCompanyOrganisationStructureCustomGroupOnesPath(company_id: ScalarType, options?: object): string {
  return "/" + "platform" + "/" + "companies" + "/" + company_id + "/" + "organisation" + "/" + "structure_custom_group_ones" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["company_id","format"]);
}

/** /platform/companies/:company_id/organisation/locations(.:format) */
export function platformCompanyOrganisationLocationsPath(company_id: ScalarType, options?: object): string {
  return "/" + "platform" + "/" + "companies" + "/" + company_id + "/" + "organisation" + "/" + "locations" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["company_id","format"]);
}

/** /platform/companies/:company_id/organisation/departments(.:format) */
export function platformCompanyOrganisationDepartmentsPath(company_id: ScalarType, options?: object): string {
  return "/" + "platform" + "/" + "companies" + "/" + company_id + "/" + "organisation" + "/" + "departments" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["company_id","format"]);
}

/** /platform/companies/:company_id/organisation/divisions(.:format) */
export function platformCompanyOrganisationDivisionsPath(company_id: ScalarType, options?: object): string {
  return "/" + "platform" + "/" + "companies" + "/" + company_id + "/" + "organisation" + "/" + "divisions" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["company_id","format"]);
}

/** /platform/companies/:company_id/organisation/structure_links(.:format) */
export function platformCompanyOrganisationStructureLinksPath(company_id: ScalarType, options?: object): string {
  return "/" + "platform" + "/" + "companies" + "/" + company_id + "/" + "organisation" + "/" + "structure_links" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["company_id","format"]);
}

/** /platform/companies/:company_id/reports(.:format) */
export function platformCompanyReportsPath(company_id: ScalarType, options?: object): string {
  return "/" + "platform" + "/" + "companies" + "/" + company_id + "/" + "reports" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["company_id","format"]);
}

/** /platform/companies/:company_id/referrals/referrals_users/bulk_update(.:format) */
export function bulkUpdatePlatformCompanyReferralsReferralsUsersPath(company_id: ScalarType, options?: object): string {
  return "/" + "platform" + "/" + "companies" + "/" + company_id + "/" + "referrals" + "/" + "referrals_users" + "/" + "bulk_update" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["company_id","format"]);
}

/** /platform/companies/:company_id/referrals/referrals_users(.:format) */
export function platformCompanyReferralsReferralsUsersPath(company_id: ScalarType, options?: object): string {
  return "/" + "platform" + "/" + "companies" + "/" + company_id + "/" + "referrals" + "/" + "referrals_users" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["company_id","format"]);
}

/** /platform/companies/:company_id/requisitions/deleted(.:format) */
export function deletedPlatformCompanyRequisitionsPath(company_id: ScalarType, options?: object): string {
  return "/" + "platform" + "/" + "companies" + "/" + company_id + "/" + "requisitions" + "/" + "deleted" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["company_id","format"]);
}

/** /platform/companies/:company_id/requisitions(.:format) */
export function platformCompanyRequisitionsPath(company_id: ScalarType, options?: object): string {
  return "/" + "platform" + "/" + "companies" + "/" + company_id + "/" + "requisitions" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["company_id","format"]);
}

/** /platform/companies/:company_id/scim/users(.:format) */
export function platformCompanyScimUsersPath(company_id: ScalarType, options?: object): string {
  return "/" + "platform" + "/" + "companies" + "/" + company_id + "/" + "scim" + "/" + "users" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["company_id","format"]);
}

/** /platform/companies/:company_id/scim/groups(.:format) */
export function platformCompanyScimGroupsPath(company_id: ScalarType, options?: object): string {
  return "/" + "platform" + "/" + "companies" + "/" + company_id + "/" + "scim" + "/" + "groups" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["company_id","format"]);
}

/** /platform/companies/:company_id/seeding/email_templates(.:format) */
export function emailTemplatesPlatformCompanySeedingIndexPath(company_id: ScalarType, options?: object): string {
  return "/" + "platform" + "/" + "companies" + "/" + company_id + "/" + "seeding" + "/" + "email_templates" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["company_id","format"]);
}

/** /platform/companies/:company_id/seeding/scorecards(.:format) */
export function scorecardsPlatformCompanySeedingIndexPath(company_id: ScalarType, options?: object): string {
  return "/" + "platform" + "/" + "companies" + "/" + company_id + "/" + "seeding" + "/" + "scorecards" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["company_id","format"]);
}

/** /platform/companies/:company_id/seeding/interview_types(.:format) */
export function interviewTypesPlatformCompanySeedingIndexPath(company_id: ScalarType, options?: object): string {
  return "/" + "platform" + "/" + "companies" + "/" + company_id + "/" + "seeding" + "/" + "interview_types" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["company_id","format"]);
}

/** /platform/companies/:company_id/seeding/departments(.:format) */
export function departmentsPlatformCompanySeedingIndexPath(company_id: ScalarType, options?: object): string {
  return "/" + "platform" + "/" + "companies" + "/" + company_id + "/" + "seeding" + "/" + "departments" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["company_id","format"]);
}

/** /platform/companies/:company_id/seeding/jobs(.:format) */
export function jobsPlatformCompanySeedingIndexPath(company_id: ScalarType, options?: object): string {
  return "/" + "platform" + "/" + "companies" + "/" + company_id + "/" + "seeding" + "/" + "jobs" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["company_id","format"]);
}

/** /platform/companies/:company_id/seeding/tag_categories(.:format) */
export function tagCategoriesPlatformCompanySeedingIndexPath(company_id: ScalarType, options?: object): string {
  return "/" + "platform" + "/" + "companies" + "/" + company_id + "/" + "seeding" + "/" + "tag_categories" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["company_id","format"]);
}

/** /platform/companies/:company_id/seeding/profiles(.:format) */
export function profilesPlatformCompanySeedingIndexPath(company_id: ScalarType, options?: object): string {
  return "/" + "platform" + "/" + "companies" + "/" + company_id + "/" + "seeding" + "/" + "profiles" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["company_id","format"]);
}

/** /platform/companies/:company_id/seeding/refresh(.:format) */
export function refreshPlatformCompanySeedingIndexPath(company_id: ScalarType, options?: object): string {
  return "/" + "platform" + "/" + "companies" + "/" + company_id + "/" + "seeding" + "/" + "refresh" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["company_id","format"]);
}

/** /platform/companies/:company_id/seeding(.:format) */
export function platformCompanySeedingIndexPath(company_id: ScalarType, options?: object): string {
  return "/" + "platform" + "/" + "companies" + "/" + company_id + "/" + "seeding" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["company_id","format"]);
}

/** /platform/companies/:company_id/seeding/candidate_surveys/delete_all(.:format) */
export function deleteAllPlatformCompanySeedingCandidateSurveysPath(company_id: ScalarType, options?: object): string {
  return "/" + "platform" + "/" + "companies" + "/" + company_id + "/" + "seeding" + "/" + "candidate_surveys" + "/" + "delete_all" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["company_id","format"]);
}

/** /platform/companies/:company_id/seeding/candidate_surveys(.:format) */
export function platformCompanySeedingCandidateSurveysPath(company_id: ScalarType, options?: object): string {
  return "/" + "platform" + "/" + "companies" + "/" + company_id + "/" + "seeding" + "/" + "candidate_surveys" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["company_id","format"]);
}

/** /platform/companies/:company_id/seeding/onboarding_processes/delete_demo_onboarding_applications(.:format) */
export function deleteDemoOnboardingApplicationsPlatformCompanySeedingOnboardingProcessesPath(company_id: ScalarType, options?: object): string {
  return "/" + "platform" + "/" + "companies" + "/" + company_id + "/" + "seeding" + "/" + "onboarding_processes" + "/" + "delete_demo_onboarding_applications" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["company_id","format"]);
}

/** /platform/companies/:company_id/seeding/onboarding_processes(.:format) */
export function platformCompanySeedingOnboardingProcessesPath(company_id: ScalarType, options?: object): string {
  return "/" + "platform" + "/" + "companies" + "/" + company_id + "/" + "seeding" + "/" + "onboarding_processes" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["company_id","format"]);
}

/** /platform/companies/:company_id/seeding/job_seekers(.:format) */
export function platformCompanySeedingJobSeekersPath(company_id: ScalarType, options?: object): string {
  return "/" + "platform" + "/" + "companies" + "/" + company_id + "/" + "seeding" + "/" + "job_seekers" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["company_id","format"]);
}

/** /platform/companies/:company_id/seeding/job_seekers/new(.:format) */
export function newPlatformCompanySeedingJobSeekerPath(company_id: ScalarType, options?: object): string {
  return "/" + "platform" + "/" + "companies" + "/" + company_id + "/" + "seeding" + "/" + "job_seekers" + "/" + "new" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["company_id","format"]);
}

/** /platform/companies/:company_id/seeding/equality_monitoring_traits(.:format) */
export function platformCompanySeedingEqualityMonitoringTraitsPath(company_id: ScalarType, options?: object): string {
  return "/" + "platform" + "/" + "companies" + "/" + company_id + "/" + "seeding" + "/" + "equality_monitoring_traits" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["company_id","format"]);
}

/** /platform/companies/:company_id/settings(.:format) */
export function platformCompanySettingsPath(company_id: ScalarType, options?: object): string {
  return "/" + "platform" + "/" + "companies" + "/" + company_id + "/" + "settings" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["company_id","format"]);
}

/** /platform/companies/:company_id/stages/bulk_update(.:format) */
export function bulkUpdatePlatformCompanyStagesPath(company_id: ScalarType, options?: object): string {
  return "/" + "platform" + "/" + "companies" + "/" + company_id + "/" + "stages" + "/" + "bulk_update" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["company_id","format"]);
}

/** /platform/companies/:company_id/stages(.:format) */
export function platformCompanyStagesPath(company_id: ScalarType, options?: object): string {
  return "/" + "platform" + "/" + "companies" + "/" + company_id + "/" + "stages" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["company_id","format"]);
}

/** /platform/companies/:company_id/usage_limits(.:format) */
export function platformCompanyUsageLimitsPath(company_id: ScalarType, options?: object): string {
  return "/" + "platform" + "/" + "companies" + "/" + company_id + "/" + "usage_limits" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["company_id","format"]);
}

/** /platform/companies/:company_id/users/copy_roles(.:format) */
export function copyRolesPlatformCompanyUsersPath(company_id: ScalarType, options?: object): string {
  return "/" + "platform" + "/" + "companies" + "/" + company_id + "/" + "users" + "/" + "copy_roles" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["company_id","format"]);
}

/** /platform/companies/:company_id/users(.:format) */
export function platformCompanyUsersPath(company_id: ScalarType, options?: object): string {
  return "/" + "platform" + "/" + "companies" + "/" + company_id + "/" + "users" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["company_id","format"]);
}

/** /platform/companies/:company_id/users/:id(.:format) */
export function platformCompanyUserPath(company_id: ScalarType, id: ScalarType, options?: object): string {
  return "/" + "platform" + "/" + "companies" + "/" + company_id + "/" + "users" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["company_id","id","format"]);
}

/** /platform/companies/:company_id/insights_pages/copy(.:format) */
export function copyPlatformCompanyInsightsPagesPath(company_id: ScalarType, options?: object): string {
  return "/" + "platform" + "/" + "companies" + "/" + company_id + "/" + "insights_pages" + "/" + "copy" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["company_id","format"]);
}

/** /platform/companies/:company_id/video_interviews(.:format) */
export function platformCompanyVideoInterviewsPath(company_id: ScalarType, options?: object): string {
  return "/" + "platform" + "/" + "companies" + "/" + company_id + "/" + "video_interviews" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["company_id","format"]);
}

/** /platform/companies/:company_id/vonq_campaigns(.:format) */
export function platformCompanyVonqCampaignsPath(company_id: ScalarType, options?: object): string {
  return "/" + "platform" + "/" + "companies" + "/" + company_id + "/" + "vonq_campaigns" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["company_id","format"]);
}

/** /platform/companies/:company_id/templates/interview_types(.:format) */
export function platformCompanyTemplatesInterviewTypesPath(company_id: ScalarType, options?: object): string {
  return "/" + "platform" + "/" + "companies" + "/" + company_id + "/" + "templates" + "/" + "interview_types" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["company_id","format"]);
}

/** /platform/companies/:company_id/templates/report_templates(.:format) */
export function platformCompanyTemplatesReportTemplatesPath(company_id: ScalarType, options?: object): string {
  return "/" + "platform" + "/" + "companies" + "/" + company_id + "/" + "templates" + "/" + "report_templates" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["company_id","format"]);
}

/** /platform/companies/:company_id/templates/offer_templates(.:format) */
export function platformCompanyTemplatesOfferTemplatesPath(company_id: ScalarType, options?: object): string {
  return "/" + "platform" + "/" + "companies" + "/" + company_id + "/" + "templates" + "/" + "offer_templates" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["company_id","format"]);
}

/** /platform/companies/:company_id/templates/questions/unassign(.:format) */
export function unassignPlatformCompanyTemplatesQuestionsPath(company_id: ScalarType, options?: object): string {
  return "/" + "platform" + "/" + "companies" + "/" + company_id + "/" + "templates" + "/" + "questions" + "/" + "unassign" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["company_id","format"]);
}

/** /platform/companies/:company_id/templates/questions(.:format) */
export function platformCompanyTemplatesQuestionsPath(company_id: ScalarType, options?: object): string {
  return "/" + "platform" + "/" + "companies" + "/" + company_id + "/" + "templates" + "/" + "questions" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["company_id","format"]);
}

/** /platform/companies/:company_id/background_checks/integrations/certn_centric/create_group(.:format) */
export function createGroupPlatformCompanyBackgroundChecksIntegrationsCertnCentricPath(company_id: ScalarType, options?: object): string {
  return "/" + "platform" + "/" + "companies" + "/" + company_id + "/" + "background_checks" + "/" + "integrations" + "/" + "certn_centric" + "/" + "create_group" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["company_id","format"]);
}

/** /platform/companies/:company_id/background_checks/integrations/certn_centric/test_api(.:format) */
export function testApiPlatformCompanyBackgroundChecksIntegrationsCertnCentricPath(company_id: ScalarType, options?: object): string {
  return "/" + "platform" + "/" + "companies" + "/" + company_id + "/" + "background_checks" + "/" + "integrations" + "/" + "certn_centric" + "/" + "test_api" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["company_id","format"]);
}

/** /platform/companies/:company_id/background_checks/integrations/certn_centric/list_groups(.:format) */
export function listGroupsPlatformCompanyBackgroundChecksIntegrationsCertnCentricPath(company_id: ScalarType, options?: object): string {
  return "/" + "platform" + "/" + "companies" + "/" + company_id + "/" + "background_checks" + "/" + "integrations" + "/" + "certn_centric" + "/" + "list_groups" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["company_id","format"]);
}

/** /platform/companies/:company_id/background_checks/integrations/certn_centric(.:format) */
export function platformCompanyBackgroundChecksIntegrationsCertnCentricPath(company_id: ScalarType, options?: object): string {
  return "/" + "platform" + "/" + "companies" + "/" + company_id + "/" + "background_checks" + "/" + "integrations" + "/" + "certn_centric" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["company_id","format"]);
}

/** /platform/companies(.:format) */
export function platformCompaniesPath(options?: object): string {
  return "/" + "platform" + "/" + "companies" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /platform/companies/new(.:format) */
export function newPlatformCompanyPath(options?: object): string {
  return "/" + "platform" + "/" + "companies" + "/" + "new" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /platform/companies/:id(.:format) */
export function platformCompanyPath(id: ScalarType, options?: object): string {
  return "/" + "platform" + "/" + "companies" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /platform/ai_assistant_conversations(.:format) */
export function platformAiAssistantConversationsPath(options?: object): string {
  return "/" + "platform" + "/" + "ai_assistant_conversations" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /platform/ai_chatbot_conversations(.:format) */
export function platformAiChatbotConversationsPath(options?: object): string {
  return "/" + "platform" + "/" + "ai_chatbot_conversations" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /platform/deals(.:format) */
export function platformDealsPath(options?: object): string {
  return "/" + "platform" + "/" + "deals" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /platform/database_info(.:format) */
export function platformDatabaseInfoPath(options?: object): string {
  return "/" + "platform" + "/" + "database_info" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /platform/delayed_jobs(.:format) */
export function platformDelayedJobsPath(options?: object): string {
  return "/" + "platform" + "/" + "delayed_jobs" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /platform/inbound_emails(.:format) */
export function platformInboundEmailsPath(options?: object): string {
  return "/" + "platform" + "/" + "inbound_emails" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /platform/integration_descriptions(.:format) */
export function platformIntegrationDescriptionsPath(options?: object): string {
  return "/" + "platform" + "/" + "integration_descriptions" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /platform/integration_plugins(.:format) */
export function platformIntegrationPluginsPath(options?: object): string {
  return "/" + "platform" + "/" + "integration_plugins" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /platform/integrations_whitelabelled(.:format) */
export function platformIntegrationsWhitelabelledIndexPath(options?: object): string {
  return "/" + "platform" + "/" + "integrations_whitelabelled" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /platform/integrations_whitelabelled/certn_centrics(.:format) */
export function platformIntegrationsWhitelabelledCertnCentricsPath(options?: object): string {
  return "/" + "platform" + "/" + "integrations_whitelabelled" + "/" + "certn_centrics" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /platform/model_explorer(.:format) */
export function platformModelExplorerPath(options?: object): string {
  return "/" + "platform" + "/" + "model_explorer" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /platform/referrals_users(.:format) */
export function platformReferralsUsersPath(options?: object): string {
  return "/" + "platform" + "/" + "referrals_users" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /platform/facebook/targeting_searches(.:format) */
export function platformFacebookTargetingSearchesPath(options?: object): string {
  return "/" + "platform" + "/" + "facebook" + "/" + "targeting_searches" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /platform/facebook/adsets/:id(.:format) */
export function platformFacebookAdsetPath(id: ScalarType, options?: object): string {
  return "/" + "platform" + "/" + "facebook" + "/" + "adsets" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /platform/facebook/completed_adverts(.:format) */
export function platformFacebookCompletedAdvertsPath(options?: object): string {
  return "/" + "platform" + "/" + "facebook" + "/" + "completed_adverts" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /platform/facebook/live_adverts(.:format) */
export function platformFacebookLiveAdvertsPath(options?: object): string {
  return "/" + "platform" + "/" + "facebook" + "/" + "live_adverts" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /platform/facebook/adverts/:advert_id/previews(.:format) */
export function platformFacebookAdvertPreviewsPath(advert_id: ScalarType, options?: object): string {
  return "/" + "platform" + "/" + "facebook" + "/" + "adverts" + "/" + advert_id + "/" + "previews" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["advert_id","format"]);
}

/** /platform/facebook/adverts/:advert_id/statuses(.:format) */
export function platformFacebookAdvertStatusesPath(advert_id: ScalarType, options?: object): string {
  return "/" + "platform" + "/" + "facebook" + "/" + "adverts" + "/" + advert_id + "/" + "statuses" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["advert_id","format"]);
}

/** /platform/facebook/adverts/:advert_id/reach(.:format) */
export function platformFacebookAdvertReachPath(advert_id: ScalarType, options?: object): string {
  return "/" + "platform" + "/" + "facebook" + "/" + "adverts" + "/" + advert_id + "/" + "reach" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["advert_id","format"]);
}

/** /platform/facebook/adverts(.:format) */
export function platformFacebookAdvertsPath(options?: object): string {
  return "/" + "platform" + "/" + "facebook" + "/" + "adverts" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /platform/facebook/adverts/:id(.:format) */
export function platformFacebookAdvertPath(id: ScalarType, options?: object): string {
  return "/" + "platform" + "/" + "facebook" + "/" + "adverts" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /platform/facebook/targeting_templates(.:format) */
export function platformFacebookTargetingTemplatesPath(options?: object): string {
  return "/" + "platform" + "/" + "facebook" + "/" + "targeting_templates" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /platform/facebook/targeting_templates/new(.:format) */
export function newPlatformFacebookTargetingTemplatePath(options?: object): string {
  return "/" + "platform" + "/" + "facebook" + "/" + "targeting_templates" + "/" + "new" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /platform/facebook/targeting_templates/:id/edit(.:format) */
export function editPlatformFacebookTargetingTemplatePath(id: ScalarType, options?: object): string {
  return "/" + "platform" + "/" + "facebook" + "/" + "targeting_templates" + "/" + id + "/" + "edit" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /platform/facebook/targeting_templates/:id(.:format) */
export function platformFacebookTargetingTemplatePath(id: ScalarType, options?: object): string {
  return "/" + "platform" + "/" + "facebook" + "/" + "targeting_templates" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /platform/adverts/job_boards(.:format) */
export function platformAdvertsJobBoardsPath(options?: object): string {
  return "/" + "platform" + "/" + "adverts" + "/" + "job_boards" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /platform/limited_access_grant(.:format) */
export function platformLimitedAccessGrantPath(options?: object): string {
  return "/" + "platform" + "/" + "limited_access_grant" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /platform/insights/twilio_integrations(.:format) */
export function platformInsightsTwilioIntegrationsPath(options?: object): string {
  return "/" + "platform" + "/" + "insights" + "/" + "twilio_integrations" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /platform/insights/twilio_integrations/new(.:format) */
export function newPlatformInsightsTwilioIntegrationPath(options?: object): string {
  return "/" + "platform" + "/" + "insights" + "/" + "twilio_integrations" + "/" + "new" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /platform/insights/twilio_integrations/:id/edit(.:format) */
export function editPlatformInsightsTwilioIntegrationPath(id: ScalarType, options?: object): string {
  return "/" + "platform" + "/" + "insights" + "/" + "twilio_integrations" + "/" + id + "/" + "edit" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /platform/insights/twilio_integrations/:id(.:format) */
export function platformInsightsTwilioIntegrationPath(id: ScalarType, options?: object): string {
  return "/" + "platform" + "/" + "insights" + "/" + "twilio_integrations" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /platform/security/two_factor_recovery_requests/reset(.:format) */
export function resetPlatformSecurityTwoFactorRecoveryRequestsPath(options?: object): string {
  return "/" + "platform" + "/" + "security" + "/" + "two_factor_recovery_requests" + "/" + "reset" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /platform/security/two_factor_recovery_requests(.:format) */
export function platformSecurityTwoFactorRecoveryRequestsPath(options?: object): string {
  return "/" + "platform" + "/" + "security" + "/" + "two_factor_recovery_requests" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /platform/companies/:company_id/job_automations(.:format) */
export function platformCompaniesJobAutomationsPath(company_id: ScalarType, options?: object): string {
  return "/" + "platform" + "/" + "companies" + "/" + company_id + "/" + "job_automations" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["company_id","format"]);
}

/** /platform/data_subject_access_requests(.:format) */
export function platformDataSubjectAccessRequestsPath(options?: object): string {
  return "/" + "platform" + "/" + "data_subject_access_requests" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /platform/platform_admins(.:format) */
export function platformPlatformAdminsPath(options?: object): string {
  return "/" + "platform" + "/" + "platform_admins" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /platform/roadmap_items(.:format) */
export function platformRoadmapItemsPath(options?: object): string {
  return "/" + "platform" + "/" + "roadmap_items" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /platform/error_testing(.:format) */
export function platformErrorTestingPath(options?: object): string {
  return "/" + "platform" + "/" + "error_testing" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /platform/sleeper(.:format) */
export function platformSleeperPath(options?: object): string {
  return "/" + "platform" + "/" + "sleeper" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /two_factor_authentication/recovery(.:format) */
export function twoFactorAuthenticationRecoveryPath(options?: object): string {
  return "/" + "two_factor_authentication" + "/" + "recovery" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /two_factor_authentication/recovery/verify(.:format) */
export function twoFactorAuthenticationRecoveryVerifyPath(options?: object): string {
  return "/" + "two_factor_authentication" + "/" + "recovery" + "/" + "verify" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /companies(.:format) */
export function companiesPath(options?: object): string {
  return "/" + "companies" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /companies/:id(.:format) */
export function companyPath(id: ScalarType, options?: object): string {
  return "/" + "companies" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /url_validations(.:format) */
export function urlValidationsPath(options?: object): string {
  return "/" + "url_validations" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /indeed_feed(.:format) */
export function indeedFeedPath(options?: object): string {
  return "/" + "indeed_feed" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /linkedin_feed(.:format) */
export function linkedinFeedPath(options?: object): string {
  return "/" + "linkedin_feed" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /talent_feed(.:format) */
export function talentFeedPath(options?: object): string {
  return "/" + "talent_feed" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /product(.:format) */
export function productPath(options?: object): string {
  return "/" + "product" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /users/password/new(.:format) */
export function newUserPasswordPath(options?: object): string {
  return "/" + "users" + "/" + "password" + "/" + "new" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /users/password/edit(.:format) */
export function editUserPasswordPath(options?: object): string {
  return "/" + "users" + "/" + "password" + "/" + "edit" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /users/password(.:format) */
export function userPasswordPath(options?: object): string {
  return "/" + "users" + "/" + "password" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /users/confirmation/new(.:format) */
export function newUserConfirmationPath(options?: object): string {
  return "/" + "users" + "/" + "confirmation" + "/" + "new" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /users/confirmation(.:format) */
export function userConfirmationPath(options?: object): string {
  return "/" + "users" + "/" + "confirmation" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /users/invitation/accept(.:format) */
export function acceptUserInvitationPath(options?: object): string {
  return "/" + "users" + "/" + "invitation" + "/" + "accept" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /users/invitation/remove(.:format) */
export function removeUserInvitationPath(options?: object): string {
  return "/" + "users" + "/" + "invitation" + "/" + "remove" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /users/invitation/new(.:format) */
export function newUserInvitationPath(options?: object): string {
  return "/" + "users" + "/" + "invitation" + "/" + "new" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /users/invitation(.:format) */
export function userInvitationPath(options?: object): string {
  return "/" + "users" + "/" + "invitation" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /users/sign_in(.:format) */
export function newUserSessionPath(options?: object): string {
  return "/" + "users" + "/" + "sign_in" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /users/sign_in(.:format) */
export function userSessionPath(options?: object): string {
  return "/" + "users" + "/" + "sign_in" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /users/sign_out(.:format) */
export function destroyUserSessionPath(options?: object): string {
  return "/" + "users" + "/" + "sign_out" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /login(.:format) */
export function loginPath(options?: object): string {
  return "/" + "login" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /logged_out(.:format) */
export function loggedOutPath(options?: object): string {
  return "/" + "logged_out" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /extensions/chrome/admin/companies(.:format) */
export function extensionsChromeAdminCompaniesPath(options?: object): string {
  return "/" + "extensions" + "/" + "chrome" + "/" + "admin" + "/" + "companies" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /extensions/chrome/login(.:format) */
export function extensionsChromeLoginPath(options?: object): string {
  return "/" + "extensions" + "/" + "chrome" + "/" + "login" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /extensions/chrome/signout(.:format) */
export function extensionsChromeSignoutPath(options?: object): string {
  return "/" + "extensions" + "/" + "chrome" + "/" + "signout" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /referrals/users/password/new(.:format) */
export function newReferralsUserPasswordPath(options?: object): string {
  return "/" + "referrals" + "/" + "users" + "/" + "password" + "/" + "new" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /referrals/users/password/edit(.:format) */
export function editReferralsUserPasswordPath(options?: object): string {
  return "/" + "referrals" + "/" + "users" + "/" + "password" + "/" + "edit" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /referrals/users/password(.:format) */
export function referralsUserPasswordPath(options?: object): string {
  return "/" + "referrals" + "/" + "users" + "/" + "password" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /referrals/users/cancel(.:format) */
export function cancelReferralsUserRegistrationPath(options?: object): string {
  return "/" + "referrals" + "/" + "users" + "/" + "cancel" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /referrals/users/sign_up(.:format) */
export function newReferralsUserRegistrationPath(options?: object): string {
  return "/" + "referrals" + "/" + "users" + "/" + "sign_up" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /referrals/users/edit(.:format) */
export function editReferralsUserRegistrationPath(options?: object): string {
  return "/" + "referrals" + "/" + "users" + "/" + "edit" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /referrals/users(.:format) */
export function referralsUserRegistrationPath(options?: object): string {
  return "/" + "referrals" + "/" + "users" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /referrals/users/invitation/accept(.:format) */
export function acceptReferralsUserInvitationPath(options?: object): string {
  return "/" + "referrals" + "/" + "users" + "/" + "invitation" + "/" + "accept" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /referrals/users/invitation/remove(.:format) */
export function removeReferralsUserInvitationPath(options?: object): string {
  return "/" + "referrals" + "/" + "users" + "/" + "invitation" + "/" + "remove" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /referrals/users/invitation/new(.:format) */
export function newReferralsUserInvitationPath(options?: object): string {
  return "/" + "referrals" + "/" + "users" + "/" + "invitation" + "/" + "new" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /referrals/users/invitation(.:format) */
export function referralsUserInvitationPath(options?: object): string {
  return "/" + "referrals" + "/" + "users" + "/" + "invitation" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /auth/failure(.:format) */
export function authFailurePath(options?: object): string {
  return "/" + "auth" + "/" + "failure" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /auth/linkedin(.:format) */
export function authLinkedinPath(options?: object): string {
  return "/" + "auth" + "/" + "linkedin" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /auth/linkedin/new(.:format) */
export function authLinkedinNewPath(options?: object): string {
  return "/" + "auth" + "/" + "linkedin" + "/" + "new" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /auth/linkedin/callback(.:format) */
export function authLinkedinCallbackPath(options?: object): string {
  return "/" + "auth" + "/" + "linkedin" + "/" + "callback" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /auth/checkr/callback(.:format) */
export function authCheckrCallbackPath(options?: object): string {
  return "/" + "auth" + "/" + "checkr" + "/" + "callback" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /auth/cronofy(.:format) */
export function authCronofyPath(options?: object): string {
  return "/" + "auth" + "/" + "cronofy" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /auth/cronofy/new(.:format) */
export function authCronofyNewPath(options?: object): string {
  return "/" + "auth" + "/" + "cronofy" + "/" + "new" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /auth/cronofy/callback(.:format) */
export function authCronofyCallbackPath(options?: object): string {
  return "/" + "auth" + "/" + "cronofy" + "/" + "callback" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /auth/cronofy/conferencing/new/:cronofy_access_token_id(.:format) */
export function authCronofyConferencingPath(cronofy_access_token_id: ScalarType, options?: object): string {
  return "/" + "auth" + "/" + "cronofy" + "/" + "conferencing" + "/" + "new" + "/" + cronofy_access_token_id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["cronofy_access_token_id","format"]);
}

/** /auth/cronofy/conferencing/callback(.:format) */
export function authCronofyConferencingCallbackPath(options?: object): string {
  return "/" + "auth" + "/" + "cronofy" + "/" + "conferencing" + "/" + "callback" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /auth/cronofy/enterprise_connect/new(.:format) */
export function authCronofyEnterpriseConnectNewPath(options?: object): string {
  return "/" + "auth" + "/" + "cronofy" + "/" + "enterprise_connect" + "/" + "new" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /auth/cronofy/enterprise_connect/callback(.:format) */
export function authCronofyEnterpriseConnectCallbackPath(options?: object): string {
  return "/" + "auth" + "/" + "cronofy" + "/" + "enterprise_connect" + "/" + "callback" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /auth/cronofy/enterprise_connect/users(.:format) */
export function authCronofyEnterpriseConnectUsersPath(options?: object): string {
  return "/" + "auth" + "/" + "cronofy" + "/" + "enterprise_connect" + "/" + "users" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /auth/azure_oauth2(.:format) */
export function authAzureOauth2Path(options?: object): string {
  return "/" + "auth" + "/" + "azure_oauth2" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /auth/google_oauth2(.:format) */
export function authGoogleOauth2Path(options?: object): string {
  return "/" + "auth" + "/" + "google_oauth2" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /auth/saml/metadata(.:format) */
export function metadataAuthSamlPath(options?: object): string {
  return "/" + "auth" + "/" + "saml" + "/" + "metadata" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /auth/saml/consume(.:format) */
export function consumeAuthSamlPath(options?: object): string {
  return "/" + "auth" + "/" + "saml" + "/" + "consume" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /auth/saml(.:format) */
export function authSamlPath(options?: object): string {
  return "/" + "auth" + "/" + "saml" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /auth/adp(.:format) */
export function authAdpPath(options?: object): string {
  return "/" + "auth" + "/" + "adp" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /auth/adp/callback(.:format) */
export function authAdpCallbackPath(options?: object): string {
  return "/" + "auth" + "/" + "adp" + "/" + "callback" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /auth/docu_sign/callback(.:format) */
export function authDocuSignCallbackPath(options?: object): string {
  return "/" + "auth" + "/" + "docu_sign" + "/" + "callback" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /auth/gusto/redirect(.:format) */
export function authGustoRedirectPath(options?: object): string {
  return "/" + "auth" + "/" + "gusto" + "/" + "redirect" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /auth/gusto/callback(.:format) */
export function authGustoCallbackPath(options?: object): string {
  return "/" + "auth" + "/" + "gusto" + "/" + "callback" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /auth/oidc/callback(.:format) */
export function callbackAuthOidcPath(options?: object): string {
  return "/" + "auth" + "/" + "oidc" + "/" + "callback" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /auth/oidc(.:format) */
export function authOidcPath(options?: object): string {
  return "/" + "auth" + "/" + "oidc" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /auth/deel/callback(.:format) */
export function authDeelCallbackPath(options?: object): string {
  return "/" + "auth" + "/" + "deel" + "/" + "callback" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /auth/rippling/callback(.:format) */
export function authRipplingCallbackPath(options?: object): string {
  return "/" + "auth" + "/" + "rippling" + "/" + "callback" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /auth/slack/callback(.:format) */
export function authSlackCallbackPath(options?: object): string {
  return "/" + "auth" + "/" + "slack" + "/" + "callback" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /auth/slack/new(.:format) */
export function authSlackNewPath(options?: object): string {
  return "/" + "auth" + "/" + "slack" + "/" + "new" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /auth/azure_oauth2/callback(.:format) */
export function authAzureOauth2CallbackPath(options?: object): string {
  return "/" + "auth" + "/" + "azure_oauth2" + "/" + "callback" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /auth/google_oauth2/callback(.:format) */
export function authGoogleOauth2CallbackPath(options?: object): string {
  return "/" + "auth" + "/" + "google_oauth2" + "/" + "callback" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /employee-dashboard(.:format) */
export function referralsRootPath(options?: object): string {
  return "/" + "employee-dashboard" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /cloudinary_uploads(.:format) */
export function cloudinaryUploadsPath(options?: object): string {
  return "/" + "cloudinary_uploads" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /csp_violation_reports(.:format) */
export function cspViolationReportsPath(options?: object): string {
  return "/" + "csp_violation_reports" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /(:locale)(.:format) */
export function externalCareersSitePath(options?: object): string {
  return "/" + ($hasPresentOwnProperty(options, "locale") ? (options as any).locale : "") + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["locale","format"]);
}

/** (/:locale)/:careers_page_slug(.:format) */
export function externalCareersSitePagePath(careers_page_slug: ScalarType, options?: object): string {
  return ($hasPresentOwnProperty(options, "locale") ? "/" + (options as any).locale : "") + "/" + careers_page_slug + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["locale","careers_page_slug","format"]);
}

/** (/:locale)/draft(.:format) */
export function externalDraftCareersSitePath(options?: object): string {
  return ($hasPresentOwnProperty(options, "locale") ? "/" + (options as any).locale : "") + "/" + "draft" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["locale","format"]);
}

/** (/:locale)/draft/:careers_page_slug(.:format) */
export function externalDraftCareersSitePagePath(careers_page_slug: ScalarType, options?: object): string {
  return ($hasPresentOwnProperty(options, "locale") ? "/" + (options as any).locale : "") + "/" + "draft" + "/" + careers_page_slug + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["locale","careers_page_slug","format"]);
}

/** (/:locale)/onboarding/:onboarding_page_slug(.:format) */
export function onboardingPortalPath(onboarding_page_slug: ScalarType, options?: object): string {
  return ($hasPresentOwnProperty(options, "locale") ? "/" + (options as any).locale : "") + "/" + "onboarding" + "/" + onboarding_page_slug + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["locale","onboarding_page_slug","format"]);
}

/** (/:locale)/onboarding(.:format) */
export function onboardingPath(options?: object): string {
  return ($hasPresentOwnProperty(options, "locale") ? "/" + (options as any).locale : "") + "/" + "onboarding" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["locale","format"]);
}

/** (/:locale)/onboarding/process(.:format) */
export function onboardingProcessPath(options?: object): string {
  return ($hasPresentOwnProperty(options, "locale") ? "/" + (options as any).locale : "") + "/" + "onboarding" + "/" + "process" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["locale","format"]);
}

/** (/:locale)/cookie-policy(.:format) */
export function cookiePolicyPath(options?: object): string {
  return ($hasPresentOwnProperty(options, "locale") ? "/" + (options as any).locale : "") + "/" + "cookie-policy" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["locale","format"]);
}

/** (/:locale)/candidates/additional-information/thanks(.:format) */
export function thanksCandidatesAdditionalInformationPath(options?: object): string {
  return ($hasPresentOwnProperty(options, "locale") ? "/" + (options as any).locale : "") + "/" + "candidates" + "/" + "additional-information" + "/" + "thanks" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["locale","format"]);
}

/** (/:locale)/candidates/additional-information/new(.:format) */
export function newCandidatesAdditionalInformationPath(options?: object): string {
  return ($hasPresentOwnProperty(options, "locale") ? "/" + (options as any).locale : "") + "/" + "candidates" + "/" + "additional-information" + "/" + "new" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["locale","format"]);
}

/** (/:locale)/candidates/additional-information(.:format) */
export function candidatesAdditionalInformationPath(options?: object): string {
  return ($hasPresentOwnProperty(options, "locale") ? "/" + (options as any).locale : "") + "/" + "candidates" + "/" + "additional-information" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["locale","format"]);
}

/** (/:locale)/candidates/additional-application-questions/thanks(.:format) */
export function thanksCandidatesQuestionCollectionsPath(options?: object): string {
  return ($hasPresentOwnProperty(options, "locale") ? "/" + (options as any).locale : "") + "/" + "candidates" + "/" + "additional-application-questions" + "/" + "thanks" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["locale","format"]);
}

/** (/:locale)/candidates/additional-application-questions/new(.:format) */
export function newCandidatesQuestionCollectionsPath(options?: object): string {
  return ($hasPresentOwnProperty(options, "locale") ? "/" + (options as any).locale : "") + "/" + "candidates" + "/" + "additional-application-questions" + "/" + "new" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["locale","format"]);
}

/** (/:locale)/candidates/additional-application-questions(.:format) */
export function candidatesQuestionCollectionsPath(options?: object): string {
  return ($hasPresentOwnProperty(options, "locale") ? "/" + (options as any).locale : "") + "/" + "candidates" + "/" + "additional-application-questions" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["locale","format"]);
}

/** (/:locale)/candidates/national-identifiers/thanks(.:format) */
export function thanksCandidatesNationalIdentifiersPath(options?: object): string {
  return ($hasPresentOwnProperty(options, "locale") ? "/" + (options as any).locale : "") + "/" + "candidates" + "/" + "national-identifiers" + "/" + "thanks" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["locale","format"]);
}

/** (/:locale)/candidates/national-identifiers/new(.:format) */
export function newCandidatesNationalIdentifiersPath(options?: object): string {
  return ($hasPresentOwnProperty(options, "locale") ? "/" + (options as any).locale : "") + "/" + "candidates" + "/" + "national-identifiers" + "/" + "new" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["locale","format"]);
}

/** (/:locale)/candidates/national-identifiers(.:format) */
export function candidatesNationalIdentifiersPath(options?: object): string {
  return ($hasPresentOwnProperty(options, "locale") ? "/" + (options as any).locale : "") + "/" + "candidates" + "/" + "national-identifiers" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["locale","format"]);
}

/** (/:locale)/candidates/interview_parts/:token/join(.:format) */
export function joinCandidatesInterviewPartPath(token: ScalarType, options?: object): string {
  return ($hasPresentOwnProperty(options, "locale") ? "/" + (options as any).locale : "") + "/" + "candidates" + "/" + "interview_parts" + "/" + token + "/" + "join" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["locale","token","format"]);
}

/** (/:locale)/candidates/communication_preferences/:token(.:format) */
export function candidatesCommunicationPreferencePath(token: ScalarType, options?: object): string {
  return ($hasPresentOwnProperty(options, "locale") ? "/" + (options as any).locale : "") + "/" + "candidates" + "/" + "communication_preferences" + "/" + token + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["locale","token","format"]);
}

/** (/:locale)/reference_checks/submit-referee-details/thanks(.:format) */
export function thanksReferenceChecksReferenceCheckRequestsPath(options?: object): string {
  return ($hasPresentOwnProperty(options, "locale") ? "/" + (options as any).locale : "") + "/" + "reference_checks" + "/" + "submit-referee-details" + "/" + "thanks" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["locale","format"]);
}

/** (/:locale)/reference_checks/submit-referee-details/status(.:format) */
export function statusReferenceChecksReferenceCheckRequestsPath(options?: object): string {
  return ($hasPresentOwnProperty(options, "locale") ? "/" + (options as any).locale : "") + "/" + "reference_checks" + "/" + "submit-referee-details" + "/" + "status" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["locale","format"]);
}

/** (/:locale)/reference_checks/submit-referee-details/new(.:format) */
export function newReferenceChecksReferenceCheckRequestsPath(options?: object): string {
  return ($hasPresentOwnProperty(options, "locale") ? "/" + (options as any).locale : "") + "/" + "reference_checks" + "/" + "submit-referee-details" + "/" + "new" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["locale","format"]);
}

/** (/:locale)/reference_checks/submit-referee-details(.:format) */
export function referenceChecksReferenceCheckRequestsPath(options?: object): string {
  return ($hasPresentOwnProperty(options, "locale") ? "/" + (options as any).locale : "") + "/" + "reference_checks" + "/" + "submit-referee-details" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["locale","format"]);
}

/** (/:locale)/reference_checks/submit-reference/thanks(.:format) */
export function thanksReferenceChecksReferenceCheckSubmissionsPath(options?: object): string {
  return ($hasPresentOwnProperty(options, "locale") ? "/" + (options as any).locale : "") + "/" + "reference_checks" + "/" + "submit-reference" + "/" + "thanks" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["locale","format"]);
}

/** (/:locale)/reference_checks/submit-reference/decline(.:format) */
export function declineReferenceChecksReferenceCheckSubmissionsPath(options?: object): string {
  return ($hasPresentOwnProperty(options, "locale") ? "/" + (options as any).locale : "") + "/" + "reference_checks" + "/" + "submit-reference" + "/" + "decline" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["locale","format"]);
}

/** (/:locale)/reference_checks/submit-reference/decline_success(.:format) */
export function declineSuccessReferenceChecksReferenceCheckSubmissionsPath(options?: object): string {
  return ($hasPresentOwnProperty(options, "locale") ? "/" + (options as any).locale : "") + "/" + "reference_checks" + "/" + "submit-reference" + "/" + "decline_success" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["locale","format"]);
}

/** (/:locale)/reference_checks/submit-reference/new(.:format) */
export function newReferenceChecksReferenceCheckSubmissionsPath(options?: object): string {
  return ($hasPresentOwnProperty(options, "locale") ? "/" + (options as any).locale : "") + "/" + "reference_checks" + "/" + "submit-reference" + "/" + "new" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["locale","format"]);
}

/** (/:locale)/reference_checks/submit-reference(.:format) */
export function referenceChecksReferenceCheckSubmissionsPath(options?: object): string {
  return ($hasPresentOwnProperty(options, "locale") ? "/" + (options as any).locale : "") + "/" + "reference_checks" + "/" + "submit-reference" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["locale","format"]);
}

/** (/:locale)/calendar_feed_subscriptions(.:format) */
export function calendarFeedSubscriptionsPath(options?: object): string {
  return ($hasPresentOwnProperty(options, "locale") ? "/" + (options as any).locale : "") + "/" + "calendar_feed_subscriptions" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["locale","format"]);
}

/** (/:locale)/e_signatures/hello_sign_sign_urls(.:format) */
export function eSignaturesHelloSignSignUrlsPath(options?: object): string {
  return ($hasPresentOwnProperty(options, "locale") ? "/" + (options as any).locale : "") + "/" + "e_signatures" + "/" + "hello_sign_sign_urls" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["locale","format"]);
}

/** (/:locale)/document_requests/:token/accept(.:format) */
export function acceptDocumentRequestPath(token: ScalarType, options?: object): string {
  return ($hasPresentOwnProperty(options, "locale") ? "/" + (options as any).locale : "") + "/" + "document_requests" + "/" + token + "/" + "accept" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["locale","token","format"]);
}

/** (/:locale)/document_requests/:token/reject(.:format) */
export function rejectDocumentRequestPath(token: ScalarType, options?: object): string {
  return ($hasPresentOwnProperty(options, "locale") ? "/" + (options as any).locale : "") + "/" + "document_requests" + "/" + token + "/" + "reject" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["locale","token","format"]);
}

/** (/:locale)/document_requests/:token/sign(.:format) */
export function signDocumentRequestPath(token: ScalarType, options?: object): string {
  return ($hasPresentOwnProperty(options, "locale") ? "/" + (options as any).locale : "") + "/" + "document_requests" + "/" + token + "/" + "sign" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["locale","token","format"]);
}

/** (/:locale)/document_requests/:document_request_token/hello_sign_sign_urls(.:format) */
export function documentRequestHelloSignSignUrlsPath(document_request_token: ScalarType, options?: object): string {
  return ($hasPresentOwnProperty(options, "locale") ? "/" + (options as any).locale : "") + "/" + "document_requests" + "/" + document_request_token + "/" + "hello_sign_sign_urls" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["locale","document_request_token","format"]);
}

/** (/:locale)/document_requests/:document_request_token/docu_seal_sign_urls(.:format) */
export function documentRequestDocuSealSignUrlsPath(document_request_token: ScalarType, options?: object): string {
  return ($hasPresentOwnProperty(options, "locale") ? "/" + (options as any).locale : "") + "/" + "document_requests" + "/" + document_request_token + "/" + "docu_seal_sign_urls" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["locale","document_request_token","format"]);
}

/** (/:locale)/document_requests/:token(.:format) */
export function documentRequestPath(token: ScalarType, options?: object): string {
  return ($hasPresentOwnProperty(options, "locale") ? "/" + (options as any).locale : "") + "/" + "document_requests" + "/" + token + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["locale","token","format"]);
}

/** (/:locale)/profile/:id(.:format) */
export function profilePath(id: ScalarType, options?: object): string {
  return ($hasPresentOwnProperty(options, "locale") ? "/" + (options as any).locale : "") + "/" + "profile" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["locale","id","format"]);
}

/** (/:locale)/privacy-policy(.:format) */
export function gdprPath(options?: object): string {
  return ($hasPresentOwnProperty(options, "locale") ? "/" + (options as any).locale : "") + "/" + "privacy-policy" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["locale","format"]);
}

/** (/:locale)/privacy_policy(.:format) */
export function privacyPolicyPath(options?: object): string {
  return ($hasPresentOwnProperty(options, "locale") ? "/" + (options as any).locale : "") + "/" + "privacy_policy" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["locale","format"]);
}

/** (/:locale)/privacy(.:format) */
export function privacyPath(options?: object): string {
  return ($hasPresentOwnProperty(options, "locale") ? "/" + (options as any).locale : "") + "/" + "privacy" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["locale","format"]);
}

/** (/:locale)/group_assessment_attendees/:id/download(.:format) */
export function downloadGroupAssessmentAttendeePath(id: ScalarType, options?: object): string {
  return ($hasPresentOwnProperty(options, "locale") ? "/" + (options as any).locale : "") + "/" + "group_assessment_attendees" + "/" + id + "/" + "download" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["locale","id","format"]);
}

/** (/:locale)/group_assessment_attendees/:id/reschedule(.:format) */
export function rescheduleGroupAssessmentAttendeePath(id: ScalarType, options?: object): string {
  return ($hasPresentOwnProperty(options, "locale") ? "/" + (options as any).locale : "") + "/" + "group_assessment_attendees" + "/" + id + "/" + "reschedule" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["locale","id","format"]);
}

/** (/:locale)/group_assessment_attendees(.:format) */
export function groupAssessmentAttendeesPath(options?: object): string {
  return ($hasPresentOwnProperty(options, "locale") ? "/" + (options as any).locale : "") + "/" + "group_assessment_attendees" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["locale","format"]);
}

/** (/:locale)/group_assessment_attendees/new(.:format) */
export function newGroupAssessmentAttendeePath(options?: object): string {
  return ($hasPresentOwnProperty(options, "locale") ? "/" + (options as any).locale : "") + "/" + "group_assessment_attendees" + "/" + "new" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["locale","format"]);
}

/** (/:locale)/group_assessment_attendees/:id(.:format) */
export function groupAssessmentAttendeePath(id: ScalarType, options?: object): string {
  return ($hasPresentOwnProperty(options, "locale") ? "/" + (options as any).locale : "") + "/" + "group_assessment_attendees" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["locale","id","format"]);
}

/** (/:locale)/group_interview_attendees/:id/download(.:format) */
export function downloadGroupInterviewAttendeePath(id: ScalarType, options?: object): string {
  return ($hasPresentOwnProperty(options, "locale") ? "/" + (options as any).locale : "") + "/" + "group_interview_attendees" + "/" + id + "/" + "download" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["locale","id","format"]);
}

/** (/:locale)/group_interview_attendees(.:format) */
export function groupInterviewAttendeesPath(options?: object): string {
  return ($hasPresentOwnProperty(options, "locale") ? "/" + (options as any).locale : "") + "/" + "group_interview_attendees" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["locale","format"]);
}

/** (/:locale)/group_interview_attendees/new(.:format) */
export function newGroupInterviewAttendeePath(options?: object): string {
  return ($hasPresentOwnProperty(options, "locale") ? "/" + (options as any).locale : "") + "/" + "group_interview_attendees" + "/" + "new" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["locale","format"]);
}

/** (/:locale)/group_interview_attendees/:id(.:format) */
export function groupInterviewAttendeePath(id: ScalarType, options?: object): string {
  return ($hasPresentOwnProperty(options, "locale") ? "/" + (options as any).locale : "") + "/" + "group_interview_attendees" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["locale","id","format"]);
}

/** (/:locale)/interviews/:token/download(.:format) */
export function downloadInterviewPath(token: ScalarType, options?: object): string {
  return ($hasPresentOwnProperty(options, "locale") ? "/" + (options as any).locale : "") + "/" + "interviews" + "/" + token + "/" + "download" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["locale","token","format"]);
}

/** (/:locale)/interviews(.:format) */
export function interviewsPath(options?: object): string {
  return ($hasPresentOwnProperty(options, "locale") ? "/" + (options as any).locale : "") + "/" + "interviews" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["locale","format"]);
}

/** (/:locale)/interviews/new(.:format) */
export function newInterviewPath(options?: object): string {
  return ($hasPresentOwnProperty(options, "locale") ? "/" + (options as any).locale : "") + "/" + "interviews" + "/" + "new" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["locale","format"]);
}

/** (/:locale)/interviews/:token(.:format) */
export function interviewPath(token: ScalarType, options?: object): string {
  return ($hasPresentOwnProperty(options, "locale") ? "/" + (options as any).locale : "") + "/" + "interviews" + "/" + token + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["locale","token","format"]);
}

/** (/:locale)/interview_invites/interview_slots(.:format) */
export function interviewInvitesInterviewSlotsPath(options?: object): string {
  return ($hasPresentOwnProperty(options, "locale") ? "/" + (options as any).locale : "") + "/" + "interview_invites" + "/" + "interview_slots" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["locale","format"]);
}

/** (/:locale)/diversity-and-inclusion/surveys(.:format) */
export function equalityMonitoringsSurveysPath(options?: object): string {
  return ($hasPresentOwnProperty(options, "locale") ? "/" + (options as any).locale : "") + "/" + "diversity-and-inclusion" + "/" + "surveys" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["locale","format"]);
}

/** (/:locale)/diversity-and-inclusion/surveys/new(.:format) */
export function newEqualityMonitoringsSurveyPath(options?: object): string {
  return ($hasPresentOwnProperty(options, "locale") ? "/" + (options as any).locale : "") + "/" + "diversity-and-inclusion" + "/" + "surveys" + "/" + "new" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["locale","format"]);
}

/** (/:locale)/diversity-and-inclusion/surveys/:token(.:format) */
export function equalityMonitoringsSurveyPath(token: ScalarType, options?: object): string {
  return ($hasPresentOwnProperty(options, "locale") ? "/" + (options as any).locale : "") + "/" + "diversity-and-inclusion" + "/" + "surveys" + "/" + token + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["locale","token","format"]);
}

/** (/:locale)/talent-pipeline/interviews/:token/download(.:format) */
export function downloadTalentPipelinesInterviewPath(token: ScalarType, options?: object): string {
  return ($hasPresentOwnProperty(options, "locale") ? "/" + (options as any).locale : "") + "/" + "talent-pipeline" + "/" + "interviews" + "/" + token + "/" + "download" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["locale","token","format"]);
}

/** (/:locale)/talent-pipeline/interviews(.:format) */
export function talentPipelinesInterviewsPath(options?: object): string {
  return ($hasPresentOwnProperty(options, "locale") ? "/" + (options as any).locale : "") + "/" + "talent-pipeline" + "/" + "interviews" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["locale","format"]);
}

/** (/:locale)/talent-pipeline/interviews/new(.:format) */
export function newTalentPipelinesInterviewPath(options?: object): string {
  return ($hasPresentOwnProperty(options, "locale") ? "/" + (options as any).locale : "") + "/" + "talent-pipeline" + "/" + "interviews" + "/" + "new" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["locale","format"]);
}

/** (/:locale)/talent-pipeline/interviews/:token(.:format) */
export function talentPipelinesInterviewPath(token: ScalarType, options?: object): string {
  return ($hasPresentOwnProperty(options, "locale") ? "/" + (options as any).locale : "") + "/" + "talent-pipeline" + "/" + "interviews" + "/" + token + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["locale","token","format"]);
}

/** (/:locale)/postings/:uuid/embed(.:format) */
export function embedJobPostingPath(uuid: ScalarType, options?: object): string {
  return ($hasPresentOwnProperty(options, "locale") ? "/" + (options as any).locale : "") + "/" + "postings" + "/" + uuid + "/" + "embed" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["locale","uuid","format"]);
}

/** (/:locale)/postings/:job_posting_uuid/applications/thanks(.:format) */
export function thanksJobPostingApplicationsPath(job_posting_uuid: ScalarType, options?: object): string {
  return ($hasPresentOwnProperty(options, "locale") ? "/" + (options as any).locale : "") + "/" + "postings" + "/" + job_posting_uuid + "/" + "applications" + "/" + "thanks" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["locale","job_posting_uuid","format"]);
}

/** (/:locale)/postings/:job_posting_uuid/applications/resume/:uuid(.:format) */
export function resumeJobPostingApplicationsPath(job_posting_uuid: ScalarType, uuid: ScalarType, options?: object): string {
  return ($hasPresentOwnProperty(options, "locale") ? "/" + (options as any).locale : "") + "/" + "postings" + "/" + job_posting_uuid + "/" + "applications" + "/" + "resume" + "/" + uuid + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["locale","job_posting_uuid","uuid","format"]);
}

/** (/:locale)/postings/:job_posting_uuid/applications(.:format) */
export function jobPostingApplicationsPath(job_posting_uuid: ScalarType, options?: object): string {
  return ($hasPresentOwnProperty(options, "locale") ? "/" + (options as any).locale : "") + "/" + "postings" + "/" + job_posting_uuid + "/" + "applications" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["locale","job_posting_uuid","format"]);
}

/** (/:locale)/postings/:job_posting_uuid/applications/new(.:format) */
export function newJobPostingApplicationPath(job_posting_uuid: ScalarType, options?: object): string {
  return ($hasPresentOwnProperty(options, "locale") ? "/" + (options as any).locale : "") + "/" + "postings" + "/" + job_posting_uuid + "/" + "applications" + "/" + "new" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["locale","job_posting_uuid","format"]);
}

/** (/:locale)/postings/:job_posting_uuid/application_form_draft_submissions(.:format) */
export function jobPostingApplicationFormDraftSubmissionsPath(job_posting_uuid: ScalarType, options?: object): string {
  return ($hasPresentOwnProperty(options, "locale") ? "/" + (options as any).locale : "") + "/" + "postings" + "/" + job_posting_uuid + "/" + "application_form_draft_submissions" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["locale","job_posting_uuid","format"]);
}

/** (/:locale)/postings(.:format) */
export function jobPostingsPath(options?: object): string {
  return ($hasPresentOwnProperty(options, "locale") ? "/" + (options as any).locale : "") + "/" + "postings" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["locale","format"]);
}

/** (/:locale)/postings/:uuid(.:format) */
export function jobPostingPath(uuid: ScalarType, options?: object): string {
  return ($hasPresentOwnProperty(options, "locale") ? "/" + (options as any).locale : "") + "/" + "postings" + "/" + uuid + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["locale","uuid","format"]);
}

/** (/:locale)/internal_job_postings(.:format) */
export function internalJobPostingsPath(options?: object): string {
  return ($hasPresentOwnProperty(options, "locale") ? "/" + (options as any).locale : "") + "/" + "internal_job_postings" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["locale","format"]);
}

/** (/:locale)/jobs/appcast_feed(.:format) */
export function appcastFeedJobsPath(options?: object): string {
  return ($hasPresentOwnProperty(options, "locale") ? "/" + (options as any).locale : "") + "/" + "jobs" + "/" + "appcast_feed" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["locale","format"]);
}

/** (/:locale)/jobs/internal(.:format) */
export function internalJobsPath(options?: object): string {
  return ($hasPresentOwnProperty(options, "locale") ? "/" + (options as any).locale : "") + "/" + "jobs" + "/" + "internal" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["locale","format"]);
}

/** (/:locale)/jobs/indeed_feed(.:format) */
export function indeedFeedJobsPath(options?: object): string {
  return ($hasPresentOwnProperty(options, "locale") ? "/" + (options as any).locale : "") + "/" + "jobs" + "/" + "indeed_feed" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["locale","format"]);
}

/** (/:locale)/jobs/linkedin(.:format) */
export function linkedinJobsPath(options?: object): string {
  return ($hasPresentOwnProperty(options, "locale") ? "/" + (options as any).locale : "") + "/" + "jobs" + "/" + "linkedin" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["locale","format"]);
}

/** (/:locale)/jobs/recruit_military(.:format) */
export function recruitMilitaryJobsPath(options?: object): string {
  return ($hasPresentOwnProperty(options, "locale") ? "/" + (options as any).locale : "") + "/" + "jobs" + "/" + "recruit_military" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["locale","format"]);
}

/** (/:locale)/jobs/talent_feed(.:format) */
export function talentFeedJobsPath(options?: object): string {
  return ($hasPresentOwnProperty(options, "locale") ? "/" + (options as any).locale : "") + "/" + "jobs" + "/" + "talent_feed" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["locale","format"]);
}

/** (/:locale)/jobs/zip_recruiter_feed(.:format) */
export function zipRecruiterFeedJobsPath(options?: object): string {
  return ($hasPresentOwnProperty(options, "locale") ? "/" + (options as any).locale : "") + "/" + "jobs" + "/" + "zip_recruiter_feed" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["locale","format"]);
}

/** (/:locale)/jobs/cambridge_network_feed(.:format) */
export function cambridgeNetworkFeedJobsPath(options?: object): string {
  return ($hasPresentOwnProperty(options, "locale") ? "/" + (options as any).locale : "") + "/" + "jobs" + "/" + "cambridge_network_feed" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["locale","format"]);
}

/** (/:locale)/jobs/:id/embed(.:format) */
export function embedJobPath(id: ScalarType, options?: object): string {
  return ($hasPresentOwnProperty(options, "locale") ? "/" + (options as any).locale : "") + "/" + "jobs" + "/" + id + "/" + "embed" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["locale","id","format"]);
}

/** (/:locale)/jobs/:job_id/hiring-process(.:format) */
export function jobHiringProcessIndexPath(job_id: ScalarType, options?: object): string {
  return ($hasPresentOwnProperty(options, "locale") ? "/" + (options as any).locale : "") + "/" + "jobs" + "/" + job_id + "/" + "hiring-process" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["locale","job_id","format"]);
}

/** (/:locale)/jobs/:job_id/applications/thanks(.:format) */
export function thanksJobApplicationsPath(job_id: ScalarType, options?: object): string {
  return ($hasPresentOwnProperty(options, "locale") ? "/" + (options as any).locale : "") + "/" + "jobs" + "/" + job_id + "/" + "applications" + "/" + "thanks" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["locale","job_id","format"]);
}

/** (/:locale)/jobs/:job_id/applications/resume/:uuid(.:format) */
export function resumeJobApplicationsPath(job_id: ScalarType, uuid: ScalarType, options?: object): string {
  return ($hasPresentOwnProperty(options, "locale") ? "/" + (options as any).locale : "") + "/" + "jobs" + "/" + job_id + "/" + "applications" + "/" + "resume" + "/" + uuid + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["locale","job_id","uuid","format"]);
}

/** (/:locale)/jobs/:job_id/applications(.:format) */
export function jobApplicationsPath(job_id: ScalarType, options?: object): string {
  return ($hasPresentOwnProperty(options, "locale") ? "/" + (options as any).locale : "") + "/" + "jobs" + "/" + job_id + "/" + "applications" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["locale","job_id","format"]);
}

/** (/:locale)/jobs/:job_id/applications/new(.:format) */
export function newJobApplicationPath(job_id: ScalarType, options?: object): string {
  return ($hasPresentOwnProperty(options, "locale") ? "/" + (options as any).locale : "") + "/" + "jobs" + "/" + job_id + "/" + "applications" + "/" + "new" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["locale","job_id","format"]);
}

/** (/:locale)/jobs/:job_id/application_form_draft_submissions(.:format) */
export function jobApplicationFormDraftSubmissionsPath(job_id: ScalarType, options?: object): string {
  return ($hasPresentOwnProperty(options, "locale") ? "/" + (options as any).locale : "") + "/" + "jobs" + "/" + job_id + "/" + "application_form_draft_submissions" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["locale","job_id","format"]);
}

/** (/:locale)/jobs/:job_id/questions(.:format) */
export function jobQuestionsPath(job_id: ScalarType, options?: object): string {
  return ($hasPresentOwnProperty(options, "locale") ? "/" + (options as any).locale : "") + "/" + "jobs" + "/" + job_id + "/" + "questions" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["locale","job_id","format"]);
}

/** (/:locale)/jobs/:job_id/talent_dot_com_questions(.:format) */
export function jobTalentDotComQuestionsPath(job_id: ScalarType, options?: object): string {
  return ($hasPresentOwnProperty(options, "locale") ? "/" + (options as any).locale : "") + "/" + "jobs" + "/" + job_id + "/" + "talent_dot_com_questions" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["locale","job_id","format"]);
}

/** (/:locale)/jobs(.:format) */
export function jobsPath(options?: object): string {
  return ($hasPresentOwnProperty(options, "locale") ? "/" + (options as any).locale : "") + "/" + "jobs" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["locale","format"]);
}

/** (/:locale)/jobs/:id(.:format) */
export function jobPath(id: ScalarType, options?: object): string {
  return ($hasPresentOwnProperty(options, "locale") ? "/" + (options as any).locale : "") + "/" + "jobs" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["locale","id","format"]);
}

/** (/:locale)/register-your-interest/thanks(.:format) */
export function thanksJobSeekersPath(options?: object): string {
  return ($hasPresentOwnProperty(options, "locale") ? "/" + (options as any).locale : "") + "/" + "register-your-interest" + "/" + "thanks" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["locale","format"]);
}

/** (/:locale)/register-your-interest(.:format) */
export function jobSeekersPath(options?: object): string {
  return ($hasPresentOwnProperty(options, "locale") ? "/" + (options as any).locale : "") + "/" + "register-your-interest" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["locale","format"]);
}

/** (/:locale)/register-your-interest/new(.:format) */
export function newJobSeekerPath(options?: object): string {
  return ($hasPresentOwnProperty(options, "locale") ? "/" + (options as any).locale : "") + "/" + "register-your-interest" + "/" + "new" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["locale","format"]);
}

/** (/:locale)/candidate-assessments/thanks(.:format) */
export function thanksCandidateAssessmentsPath(options?: object): string {
  return ($hasPresentOwnProperty(options, "locale") ? "/" + (options as any).locale : "") + "/" + "candidate-assessments" + "/" + "thanks" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["locale","format"]);
}

/** (/:locale)/candidate-assessments(.:format) */
export function candidateAssessmentsPath(options?: object): string {
  return ($hasPresentOwnProperty(options, "locale") ? "/" + (options as any).locale : "") + "/" + "candidate-assessments" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["locale","format"]);
}

/** (/:locale)/candidate-assessments/new(.:format) */
export function newCandidateAssessmentPath(options?: object): string {
  return ($hasPresentOwnProperty(options, "locale") ? "/" + (options as any).locale : "") + "/" + "candidate-assessments" + "/" + "new" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["locale","format"]);
}

/** (/:locale)/candidate-assessments/:id/edit(.:format) */
export function editCandidateAssessmentPath(id: ScalarType, options?: object): string {
  return ($hasPresentOwnProperty(options, "locale") ? "/" + (options as any).locale : "") + "/" + "candidate-assessments" + "/" + id + "/" + "edit" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["locale","id","format"]);
}

/** (/:locale)/candidate-assessments/:id(.:format) */
export function candidateAssessmentPath(id: ScalarType, options?: object): string {
  return ($hasPresentOwnProperty(options, "locale") ? "/" + (options as any).locale : "") + "/" + "candidate-assessments" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["locale","id","format"]);
}

/** (/:locale)/talent_pipeline(.:format) */
export function talentPipelinePath(options?: object): string {
  return ($hasPresentOwnProperty(options, "locale") ? "/" + (options as any).locale : "") + "/" + "talent_pipeline" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["locale","format"]);
}

/** (/:locale)/themes/:id/indeed_feed(.:format) */
export function indeedFeedThemePath(id: ScalarType, options?: object): string {
  return ($hasPresentOwnProperty(options, "locale") ? "/" + (options as any).locale : "") + "/" + "themes" + "/" + id + "/" + "indeed_feed" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["locale","id","format"]);
}

/** (/:locale)/themes/:id/privacy_policy(.:format) */
export function privacyPolicyThemePath(id: ScalarType, options?: object): string {
  return ($hasPresentOwnProperty(options, "locale") ? "/" + (options as any).locale : "") + "/" + "themes" + "/" + id + "/" + "privacy_policy" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["locale","id","format"]);
}

/** (/:locale)/themes/:theme_id/register-your-interest/thanks(.:format) */
export function thanksThemeJobSeekersPath(theme_id: ScalarType, options?: object): string {
  return ($hasPresentOwnProperty(options, "locale") ? "/" + (options as any).locale : "") + "/" + "themes" + "/" + theme_id + "/" + "register-your-interest" + "/" + "thanks" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["locale","theme_id","format"]);
}

/** (/:locale)/themes/:theme_id/register-your-interest(.:format) */
export function themeJobSeekersPath(theme_id: ScalarType, options?: object): string {
  return ($hasPresentOwnProperty(options, "locale") ? "/" + (options as any).locale : "") + "/" + "themes" + "/" + theme_id + "/" + "register-your-interest" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["locale","theme_id","format"]);
}

/** (/:locale)/themes/:theme_id/register-your-interest/new(.:format) */
export function newThemeJobSeekerPath(theme_id: ScalarType, options?: object): string {
  return ($hasPresentOwnProperty(options, "locale") ? "/" + (options as any).locale : "") + "/" + "themes" + "/" + theme_id + "/" + "register-your-interest" + "/" + "new" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["locale","theme_id","format"]);
}

/** (/:locale)/themes/:id(.:format) */
export function themePath(id: ScalarType, options?: object): string {
  return ($hasPresentOwnProperty(options, "locale") ? "/" + (options as any).locale : "") + "/" + "themes" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["locale","id","format"]);
}

/** (/:locale)/sitemap(.:format) */
export function sitemapPath(options?: object): string {
  return ($hasPresentOwnProperty(options, "locale") ? "/" + (options as any).locale : "") + "/" + "sitemap" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["locale","format"]);
}

/** (/:locale)/surveys/:token(.:format) */
export function surveyPath(token: ScalarType, options?: object): string {
  return ($hasPresentOwnProperty(options, "locale") ? "/" + (options as any).locale : "") + "/" + "surveys" + "/" + token + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["locale","token","format"]);
}

/** (/:locale)/offers/:token/accept(.:format) */
export function acceptOfferPath(token: ScalarType, options?: object): string {
  return ($hasPresentOwnProperty(options, "locale") ? "/" + (options as any).locale : "") + "/" + "offers" + "/" + token + "/" + "accept" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["locale","token","format"]);
}

/** (/:locale)/offers/:token/reject(.:format) */
export function rejectOfferPath(token: ScalarType, options?: object): string {
  return ($hasPresentOwnProperty(options, "locale") ? "/" + (options as any).locale : "") + "/" + "offers" + "/" + token + "/" + "reject" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["locale","token","format"]);
}

/** (/:locale)/offers/:offer_token/hellosign_sign_urls(.:format) */
export function offerHellosignSignUrlsPath(offer_token: ScalarType, options?: object): string {
  return ($hasPresentOwnProperty(options, "locale") ? "/" + (options as any).locale : "") + "/" + "offers" + "/" + offer_token + "/" + "hellosign_sign_urls" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["locale","offer_token","format"]);
}

/** (/:locale)/offers/:token(.:format) */
export function offerPath(token: ScalarType, options?: object): string {
  return ($hasPresentOwnProperty(options, "locale") ? "/" + (options as any).locale : "") + "/" + "offers" + "/" + token + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["locale","token","format"]);
}

/** (/:locale)/video-interview/:token(.:format) */
export function videoInterviewPath(token: ScalarType, options?: object): string {
  return ($hasPresentOwnProperty(options, "locale") ? "/" + (options as any).locale : "") + "/" + "video-interview" + "/" + token + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["locale","token","format"]);
}

/** (/:locale)/providers/linked_in/events(.:format) */
export function providersLinkedInEventsPath(options?: object): string {
  return ($hasPresentOwnProperty(options, "locale") ? "/" + (options as any).locale : "") + "/" + "providers" + "/" + "linked_in" + "/" + "events" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["locale","format"]);
}

/** (/:locale)/approval_workflow_stages_users/:token/approve(.:format) */
export function approveApprovalWorkflowStagesUserPath(token: ScalarType, options?: object): string {
  return ($hasPresentOwnProperty(options, "locale") ? "/" + (options as any).locale : "") + "/" + "approval_workflow_stages_users" + "/" + token + "/" + "approve" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["locale","token","format"]);
}

/** (/:locale)/approval_workflow_stages_users/:token/reject(.:format) */
export function rejectApprovalWorkflowStagesUserPath(token: ScalarType, options?: object): string {
  return ($hasPresentOwnProperty(options, "locale") ? "/" + (options as any).locale : "") + "/" + "approval_workflow_stages_users" + "/" + token + "/" + "reject" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["locale","token","format"]);
}

/** (/:locale)/approval_workflow_stages_users/:token/offer_letter_preview(.:format) */
export function offerLetterPreviewApprovalWorkflowStagesUserPath(token: ScalarType, options?: object): string {
  return ($hasPresentOwnProperty(options, "locale") ? "/" + (options as any).locale : "") + "/" + "approval_workflow_stages_users" + "/" + token + "/" + "offer_letter_preview" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["locale","token","format"]);
}

/** (/:locale)/approval_workflow_stages_users/:token/users(.:format) */
export function usersApprovalWorkflowStagesUserPath(token: ScalarType, options?: object): string {
  return ($hasPresentOwnProperty(options, "locale") ? "/" + (options as any).locale : "") + "/" + "approval_workflow_stages_users" + "/" + token + "/" + "users" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["locale","token","format"]);
}

/** (/:locale)/approval_workflow_stages_users/:token(.:format) */
export function approvalWorkflowStagesUserPath(token: ScalarType, options?: object): string {
  return ($hasPresentOwnProperty(options, "locale") ? "/" + (options as any).locale : "") + "/" + "approval_workflow_stages_users" + "/" + token + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["locale","token","format"]);
}

/** (/:locale)/careers_chatbot/conversations/history(.:format) */
export function historyCareersChatbotConversationsPath(options?: object): string {
  return ($hasPresentOwnProperty(options, "locale") ? "/" + (options as any).locale : "") + "/" + "careers_chatbot" + "/" + "conversations" + "/" + "history" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["locale","format"]);
}

/** (/:locale)/careers_chatbot/conversations/transcribe(.:format) */
export function transcribeCareersChatbotConversationsPath(options?: object): string {
  return ($hasPresentOwnProperty(options, "locale") ? "/" + (options as any).locale : "") + "/" + "careers_chatbot" + "/" + "conversations" + "/" + "transcribe" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["locale","format"]);
}

/** (/:locale)/careers_chatbot/conversations/apply_for_job(.:format) */
export function applyForJobCareersChatbotConversationsPath(options?: object): string {
  return ($hasPresentOwnProperty(options, "locale") ? "/" + (options as any).locale : "") + "/" + "careers_chatbot" + "/" + "conversations" + "/" + "apply_for_job" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["locale","format"]);
}

/** (/:locale)/careers_chatbot/conversations(.:format) */
export function careersChatbotConversationsPath(options?: object): string {
  return ($hasPresentOwnProperty(options, "locale") ? "/" + (options as any).locale : "") + "/" + "careers_chatbot" + "/" + "conversations" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["locale","format"]);
}

/** (/:locale)/ai_contexts/v1/companies/:company_id/live_jobs(.:format) */
export function aiContextsV1CompanyLiveJobsPath(company_id: ScalarType, options?: object): string {
  return ($hasPresentOwnProperty(options, "locale") ? "/" + (options as any).locale : "") + "/" + "ai_contexts" + "/" + "v1" + "/" + "companies" + "/" + company_id + "/" + "live_jobs" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["locale","company_id","format"]);
}

/** /refer/:hashid(.:format) */
export function referRedirectPath(hashid: ScalarType, options?: object): string {
  return "/" + "refer" + "/" + hashid + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["hashid","format"]);
}

/** /refer/:hashid/:job_id(/:job_posting_uuid)(.:format) */
export function referRedirectJobPath(hashid: ScalarType, job_id: ScalarType, options?: object): string {
  return "/" + "refer" + "/" + hashid + "/" + job_id + ($hasPresentOwnProperty(options, "job_posting_uuid") ? "/" + (options as any).job_posting_uuid : "") + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["hashid","job_id","job_posting_uuid","format"]);
}

/** /mapbox/autocomplete(.:format) */
export function mapboxAutocompleteIndexPath(options?: object): string {
  return "/" + "mapbox" + "/" + "autocomplete" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /onboarding(.:format) */
export function onboardingIndexPath(options?: object): string {
  return "/" + "onboarding" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /onboarding/candidate_responses(.:format) */
export function onboardingCandidateResponsesPath(options?: object): string {
  return "/" + "onboarding" + "/" + "candidate_responses" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /onboarding/workflow(.:format) */
export function onboardingWorkflowPath(options?: object): string {
  return "/" + "onboarding" + "/" + "workflow" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /onboarding/team_member_actions(.:format) */
export function onboardingTeamMemberActionsPath(options?: object): string {
  return "/" + "onboarding" + "/" + "team_member_actions" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /onboarding/team_member_forms(.:format) */
export function onboardingTeamMemberFormsPath(options?: object): string {
  return "/" + "onboarding" + "/" + "team_member_forms" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /onboarding/notifications(.:format) */
export function onboardingNotificationsPath(options?: object): string {
  return "/" + "onboarding" + "/" + "notifications" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /onboarding/docu_sign_envelopes/update_envelope(.:format) */
export function updateEnvelopeOnboardingDocuSignEnvelopesPath(options?: object): string {
  return "/" + "onboarding" + "/" + "docu_sign_envelopes" + "/" + "update_envelope" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /onboarding/docu_sign_envelopes/new(.:format) */
export function newOnboardingDocuSignEnvelopesPath(options?: object): string {
  return "/" + "onboarding" + "/" + "docu_sign_envelopes" + "/" + "new" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /onboarding/docu_sign_envelopes/edit(.:format) */
export function editOnboardingDocuSignEnvelopesPath(options?: object): string {
  return "/" + "onboarding" + "/" + "docu_sign_envelopes" + "/" + "edit" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /onboarding/docu_sign_envelopes(.:format) */
export function onboardingDocuSignEnvelopesPath(options?: object): string {
  return "/" + "onboarding" + "/" + "docu_sign_envelopes" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /onboarding/api/v2/onboarding_process_step_status_overrides(.:format) */
export function onboardingApiV2OnboardingProcessStepStatusOverridesPath(options?: object): string {
  return "/" + "onboarding" + "/" + "api" + "/" + "v2" + "/" + "onboarding_process_step_status_overrides" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /onboarding/api/v2/admin/edit_responses/update_answers(.:format) */
export function onboardingApiV2AdminEditResponsesUpdateAnswersPath(options?: object): string {
  return "/" + "onboarding" + "/" + "api" + "/" + "v2" + "/" + "admin" + "/" + "edit_responses" + "/" + "update_answers" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /onboarding/api/v2/onboarding/update_answers(.:format) */
export function onboardingApiV2OnboardingUpdateAnswersPath(options?: object): string {
  return "/" + "onboarding" + "/" + "api" + "/" + "v2" + "/" + "onboarding" + "/" + "update_answers" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /onboarding/api/v2/onboarding/next_step(.:format) */
export function onboardingApiV2OnboardingNextStepPath(options?: object): string {
  return "/" + "onboarding" + "/" + "api" + "/" + "v2" + "/" + "onboarding" + "/" + "next_step" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /onboarding/api/v2/onboarding/previous_step(.:format) */
export function onboardingApiV2OnboardingPreviousStepPath(options?: object): string {
  return "/" + "onboarding" + "/" + "api" + "/" + "v2" + "/" + "onboarding" + "/" + "previous_step" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /onboarding/api/v2/onboarding/send_reminder(.:format) */
export function onboardingApiV2OnboardingSendReminderPath(options?: object): string {
  return "/" + "onboarding" + "/" + "api" + "/" + "v2" + "/" + "onboarding" + "/" + "send_reminder" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /onboarding/api/v2/onboarding/update_current_stage(.:format) */
export function onboardingApiV2OnboardingUpdateCurrentStagePath(options?: object): string {
  return "/" + "onboarding" + "/" + "api" + "/" + "v2" + "/" + "onboarding" + "/" + "update_current_stage" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /onboarding/api/v2/onboarding/create_document_request(.:format) */
export function onboardingApiV2OnboardingCreateDocumentRequestPath(options?: object): string {
  return "/" + "onboarding" + "/" + "api" + "/" + "v2" + "/" + "onboarding" + "/" + "create_document_request" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /onboarding/api/v2/onboarding/preview_document_request(.:format) */
export function onboardingApiV2OnboardingPreviewDocumentRequestPath(options?: object): string {
  return "/" + "onboarding" + "/" + "api" + "/" + "v2" + "/" + "onboarding" + "/" + "preview_document_request" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /onboarding/api/v2/onboarding/update_document_request(.:format) */
export function onboardingApiV2OnboardingUpdateDocumentRequestPath(options?: object): string {
  return "/" + "onboarding" + "/" + "api" + "/" + "v2" + "/" + "onboarding" + "/" + "update_document_request" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /onboarding/api/v2/integrations/yoti/sessions(.:format) */
export function onboardingApiV2IntegrationsYotiSessionsPath(options?: object): string {
  return "/" + "onboarding" + "/" + "api" + "/" + "v2" + "/" + "integrations" + "/" + "yoti" + "/" + "sessions" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /extensions/chrome/admin/sourcing/check(.:format) */
export function checkExtensionsChromeAdminSourcingPath(options?: object): string {
  return "/" + "extensions" + "/" + "chrome" + "/" + "admin" + "/" + "sourcing" + "/" + "check" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /extensions/chrome/admin/sourcing(.:format) */
export function extensionsChromeAdminSourcingPath(options?: object): string {
  return "/" + "extensions" + "/" + "chrome" + "/" + "admin" + "/" + "sourcing" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /integrations/gusto_provisions/companies(.:format) */
export function integrationsGustoProvisionsCompaniesPath(options?: object): string {
  return "/" + "integrations" + "/" + "gusto_provisions" + "/" + "companies" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /integrations/providers/my_interview/events(.:format) */
export function integrationsProvidersMyInterviewEventsPath(options?: object): string {
  return "/" + "integrations" + "/" + "providers" + "/" + "my_interview" + "/" + "events" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /integrations/providers/only_office/events/:id(.:format) */
export function integrationsProvidersOnlyOfficePath(id: ScalarType, options?: object): string {
  return "/" + "integrations" + "/" + "providers" + "/" + "only_office" + "/" + "events" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /integrations/providers/scim/v2 */
export function integrationsProvidersScimV2ScimitarPath(options?: object): string {
  return "/" + "integrations" + "/" + "providers" + "/" + "scim" + "/" + "v2" + $buildOptions(options, []);
}

/** /integrations/providers/scim/v2/ServiceProviderConfig(.:format) */
export function integrationsProvidersScimV2ScimitarScimServiceProviderConfigurationPath(options?: object): string {
  return "/" + "integrations" + "/" + "providers" + "/" + "scim" + "/" + "v2" + "/" + "ServiceProviderConfig" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /integrations/providers/scim/v2/ResourceTypes(.:format) */
export function integrationsProvidersScimV2ScimitarScimResourceTypesPath(options?: object): string {
  return "/" + "integrations" + "/" + "providers" + "/" + "scim" + "/" + "v2" + "/" + "ResourceTypes" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /integrations/providers/scim/v2/ResourceTypes/:name(.:format) */
export function integrationsProvidersScimV2ScimitarScimResourceTypePath(name: ScalarType, options?: object): string {
  return "/" + "integrations" + "/" + "providers" + "/" + "scim" + "/" + "v2" + "/" + "ResourceTypes" + "/" + name + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["name","format"]);
}

/** /integrations/providers/scim/v2/Schemas(.:format) */
export function integrationsProvidersScimV2ScimitarScimSchemasPath(options?: object): string {
  return "/" + "integrations" + "/" + "providers" + "/" + "scim" + "/" + "v2" + "/" + "Schemas" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /integrations/providers/scim/v2/Users(.:format) */
export function integrationsProvidersScimV2UsersPath(options?: object): string {
  return "/" + "integrations" + "/" + "providers" + "/" + "scim" + "/" + "v2" + "/" + "Users" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /integrations/providers/scim/v2/Users/:id(.:format) */
export function integrationsProvidersScimV2Path(id: ScalarType, options?: object): string {
  return "/" + "integrations" + "/" + "providers" + "/" + "scim" + "/" + "v2" + "/" + "Users" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /integrations/providers/scim/v2/Groups(.:format) */
export function integrationsProvidersScimV2GroupsPath(options?: object): string {
  return "/" + "integrations" + "/" + "providers" + "/" + "scim" + "/" + "v2" + "/" + "Groups" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /employee-dashboard/jobs(.:format) */
export function referralsJobsPath(options?: object): string {
  return "/" + "employee-dashboard" + "/" + "jobs" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /employee-dashboard/referral_jobs(.:format) */
export function referralsReferralJobsPath(options?: object): string {
  return "/" + "employee-dashboard" + "/" + "referral_jobs" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /employee-dashboard/referrals(.:format) */
export function referralsReferralsPath(options?: object): string {
  return "/" + "employee-dashboard" + "/" + "referrals" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /employee-dashboard/settings(.:format) */
export function referralsSettingsPath(options?: object): string {
  return "/" + "employee-dashboard" + "/" + "settings" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /logos(.:format) */
export function logosPath(options?: object): string {
  return "/" + "logos" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /logout(.:format) */
export function logoutPath(options?: object): string {
  return "/" + "logout" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin(.:format) */
export function adminRootPath(options?: object): string {
  return "/" + "admin" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/applications/:application_id/scorecard_options/:scorecard_option_id/scorecard_rating(.:format) */
export function adminApplicationScorecardOptionScorecardRatingPath(application_id: ScalarType, scorecard_option_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "applications" + "/" + application_id + "/" + "scorecard_options" + "/" + scorecard_option_id + "/" + "scorecard_rating" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["application_id","scorecard_option_id","format"]);
}

/** /admin/applications/:application_id/rating(.:format) */
export function adminApplicationRatingPath(application_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "applications" + "/" + application_id + "/" + "rating" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["application_id","format"]);
}

/** /admin/applications/:application_id/scorecard_note(.:format) */
export function adminApplicationScorecardNotePath(application_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "applications" + "/" + application_id + "/" + "scorecard_note" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["application_id","format"]);
}

/** /admin/applications/custom_emails(.:format) */
export function adminApplicationsCustomEmailsPath(options?: object): string {
  return "/" + "admin" + "/" + "applications" + "/" + "custom_emails" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/job_seekers/:job_seeker_id/scorecard_options/:scorecard_option_id/scorecard_rating(.:format) */
export function adminJobSeekerScorecardOptionScorecardRatingPath(job_seeker_id: ScalarType, scorecard_option_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "job_seekers" + "/" + job_seeker_id + "/" + "scorecard_options" + "/" + scorecard_option_id + "/" + "scorecard_rating" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_seeker_id","scorecard_option_id","format"]);
}

/** /admin/job_seekers/:job_seeker_id/rating(.:format) */
export function adminJobSeekerRatingPath(job_seeker_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "job_seekers" + "/" + job_seeker_id + "/" + "rating" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_seeker_id","format"]);
}

/** /admin/job_seekers/:job_seeker_id/scorecard_note(.:format) */
export function adminJobSeekerScorecardNotePath(job_seeker_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "job_seekers" + "/" + job_seeker_id + "/" + "scorecard_note" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_seeker_id","format"]);
}

/** /admin/approvals/jobs(.:format) */
export function adminApprovalsJobsPath(options?: object): string {
  return "/" + "admin" + "/" + "approvals" + "/" + "jobs" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/approvals/offers(.:format) */
export function adminApprovalsOffersPath(options?: object): string {
  return "/" + "admin" + "/" + "approvals" + "/" + "offers" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/approvals/requisitions(.:format) */
export function adminApprovalsRequisitionsPath(options?: object): string {
  return "/" + "admin" + "/" + "approvals" + "/" + "requisitions" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/approvals/all_approvals_jobs(.:format) */
export function adminApprovalsAllApprovalsJobsPath(options?: object): string {
  return "/" + "admin" + "/" + "approvals" + "/" + "all_approvals_jobs" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/approvals/all_approvals_offers(.:format) */
export function adminApprovalsAllApprovalsOffersPath(options?: object): string {
  return "/" + "admin" + "/" + "approvals" + "/" + "all_approvals_offers" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/approvals/all_approvals_offers/:id(.:format) */
export function adminApprovalsAllApprovalsOfferPath(id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "approvals" + "/" + "all_approvals_offers" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /admin/approvals/all_approvals_requisitions(.:format) */
export function adminApprovalsAllApprovalsRequisitionsPath(options?: object): string {
  return "/" + "admin" + "/" + "approvals" + "/" + "all_approvals_requisitions" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/bulk_uploads/job_template(.:format) */
export function jobTemplateAdminBulkUploadsPath(options?: object): string {
  return "/" + "admin" + "/" + "bulk_uploads" + "/" + "job_template" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/bulk_uploads/position_template(.:format) */
export function positionTemplateAdminBulkUploadsPath(options?: object): string {
  return "/" + "admin" + "/" + "bulk_uploads" + "/" + "position_template" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/bulk_uploads/application_template(.:format) */
export function applicationTemplateAdminBulkUploadsPath(options?: object): string {
  return "/" + "admin" + "/" + "bulk_uploads" + "/" + "application_template" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/bulk_uploads/requisition_template(.:format) */
export function requisitionTemplateAdminBulkUploadsPath(options?: object): string {
  return "/" + "admin" + "/" + "bulk_uploads" + "/" + "requisition_template" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/bulk_uploads/job_seeker_template(.:format) */
export function jobSeekerTemplateAdminBulkUploadsPath(options?: object): string {
  return "/" + "admin" + "/" + "bulk_uploads" + "/" + "job_seeker_template" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/bulk_uploads(.:format) */
export function adminBulkUploadsPath(options?: object): string {
  return "/" + "admin" + "/" + "bulk_uploads" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/candidate_surveys/preview(.:format) */
export function adminCandidateSurveysPreviewPath(options?: object): string {
  return "/" + "admin" + "/" + "candidate_surveys" + "/" + "preview" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/careers_site/edit(.:format) */
export function editAdminCareersSitePath(options?: object): string {
  return "/" + "admin" + "/" + "careers_site" + "/" + "edit" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/careers_site(.:format) */
export function adminCareersSitePath(options?: object): string {
  return "/" + "admin" + "/" + "careers_site" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/draft_careers_site/edit(.:format) */
export function editAdminDraftCareersSitePath(options?: object): string {
  return "/" + "admin" + "/" + "draft_careers_site" + "/" + "edit" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/draft_careers_site(.:format) */
export function adminDraftCareersSitePath(options?: object): string {
  return "/" + "admin" + "/" + "draft_careers_site" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/careers_page/ai_audit(.:format) */
export function aiAuditAdminCareersPagePath(options?: object): string {
  return "/" + "admin" + "/" + "careers_page" + "/" + "ai_audit" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/careers_page/fetch_content(.:format) */
export function fetchContentAdminCareersPagePath(options?: object): string {
  return "/" + "admin" + "/" + "careers_page" + "/" + "fetch_content" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/websites(.:format) */
export function adminWebsitesPath(options?: object): string {
  return "/" + "admin" + "/" + "websites" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/company/details/edit(.:format) */
export function editAdminCompanyDetailsPath(options?: object): string {
  return "/" + "admin" + "/" + "company" + "/" + "details" + "/" + "edit" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/company/details(.:format) */
export function adminCompanyDetailsPath(options?: object): string {
  return "/" + "admin" + "/" + "company" + "/" + "details" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/company/equality_monitoring(.:format) */
export function adminCompanyEqualityMonitoringPath(options?: object): string {
  return "/" + "admin" + "/" + "company" + "/" + "equality_monitoring" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/company/limited_access_grants(.:format) */
export function adminCompanyLimitedAccessGrantsPath(options?: object): string {
  return "/" + "admin" + "/" + "company" + "/" + "limited_access_grants" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/company/integrations(.:format) */
export function adminCompanyIntegrationsPath(options?: object): string {
  return "/" + "admin" + "/" + "company" + "/" + "integrations" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/company/theme/edit(.:format) */
export function editAdminCompanyThemePath(options?: object): string {
  return "/" + "admin" + "/" + "company" + "/" + "theme" + "/" + "edit" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/company/theme(.:format) */
export function adminCompanyThemePath(options?: object): string {
  return "/" + "admin" + "/" + "company" + "/" + "theme" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/company/security(.:format) */
export function adminCompanySecurityPath(options?: object): string {
  return "/" + "admin" + "/" + "company" + "/" + "security" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/company/preferences(.:format) */
export function adminCompanyPreferencesPath(options?: object): string {
  return "/" + "admin" + "/" + "company" + "/" + "preferences" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/company/azure_active_directory/users(.:format) */
export function adminCompanyAzureActiveDirectoryUsersPath(options?: object): string {
  return "/" + "admin" + "/" + "company" + "/" + "azure_active_directory" + "/" + "users" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/gdpr/edit(.:format) */
export function editAdminDataProtectionPolicyPath(options?: object): string {
  return "/" + "admin" + "/" + "gdpr" + "/" + "edit" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/gdpr(.:format) */
export function adminDataProtectionPolicyPath(options?: object): string {
  return "/" + "admin" + "/" + "gdpr" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/cronofy_element_tokens(.:format) */
export function adminCronofyElementTokensPath(options?: object): string {
  return "/" + "admin" + "/" + "cronofy_element_tokens" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/custom_fields(.:format) */
export function adminCustomFieldsPath(options?: object): string {
  return "/" + "admin" + "/" + "custom_fields" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/ai_fields(.:format) */
export function adminAiFieldsPath(options?: object): string {
  return "/" + "admin" + "/" + "ai_fields" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/cvs/parses(.:format) */
export function adminCvsParsesPath(options?: object): string {
  return "/" + "admin" + "/" + "cvs" + "/" + "parses" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/docu_seal/tokens(.:format) */
export function adminDocuSealTokensPath(options?: object): string {
  return "/" + "admin" + "/" + "docu_seal" + "/" + "tokens" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/docu_seal/fields/:id(.:format) */
export function adminDocuSealFieldPath(id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "docu_seal" + "/" + "fields" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /admin/docu_seal/templates(.:format) */
export function adminDocuSealTemplatesPath(options?: object): string {
  return "/" + "admin" + "/" + "docu_seal" + "/" + "templates" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/docu_sign/templates(.:format) */
export function adminDocuSignTemplatesPath(options?: object): string {
  return "/" + "admin" + "/" + "docu_sign" + "/" + "templates" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/docu_sign/prefill_tabs(.:format) */
export function adminDocuSignPrefillTabsPath(options?: object): string {
  return "/" + "admin" + "/" + "docu_sign" + "/" + "prefill_tabs" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/equality_monitoring/survey/invite(.:format) */
export function inviteAdminEqualityMonitoringSurveyPath(options?: object): string {
  return "/" + "admin" + "/" + "equality_monitoring" + "/" + "survey" + "/" + "invite" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/group_assessments/:group_assessment_id/custom_emails(.:format) */
export function adminGroupAssessmentCustomEmailsPath(group_assessment_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "group_assessments" + "/" + group_assessment_id + "/" + "custom_emails" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["group_assessment_id","format"]);
}

/** /admin/group_assessments(.:format) */
export function adminGroupAssessmentsPath(options?: object): string {
  return "/" + "admin" + "/" + "group_assessments" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/group_assessments/:id(.:format) */
export function adminGroupAssessmentPath(id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "group_assessments" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /admin/webhooks(.:format) */
export function adminWebhooksPath(options?: object): string {
  return "/" + "admin" + "/" + "webhooks" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/webhooks/endpoints/:id(.:format) */
export function adminWebhooksEndpointPath(id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "webhooks" + "/" + "endpoints" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /admin/employee_dashboard/settings(.:format) */
export function adminEmployeeDashboardSettingsPath(options?: object): string {
  return "/" + "admin" + "/" + "employee_dashboard" + "/" + "settings" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/employee_dashboard/users(.:format) */
export function adminEmployeeDashboardUsersPath(options?: object): string {
  return "/" + "admin" + "/" + "employee_dashboard" + "/" + "users" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/facebook_adverts(.:format) */
export function adminFacebookAdvertsPath(options?: object): string {
  return "/" + "admin" + "/" + "facebook_adverts" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/facebook_configuration(.:format) */
export function adminFacebookConfigurationPath(options?: object): string {
  return "/" + "admin" + "/" + "facebook_configuration" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/facebook_configurations/access_tokens(.:format) */
export function adminFacebookConfigurationsAccessTokensPath(options?: object): string {
  return "/" + "admin" + "/" + "facebook_configurations" + "/" + "access_tokens" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/facebook_configurations/locations(.:format) */
export function adminFacebookConfigurationsLocationsPath(options?: object): string {
  return "/" + "admin" + "/" + "facebook_configurations" + "/" + "locations" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/facebook_configurations/options(.:format) */
export function adminFacebookConfigurationsOptionsPath(options?: object): string {
  return "/" + "admin" + "/" + "facebook_configurations" + "/" + "options" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/integration_marketplace(.:format) */
export function adminIntegrationMarketplaceIndexPath(options?: object): string {
  return "/" + "admin" + "/" + "integration_marketplace" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/integration_plugins(.:format) */
export function adminIntegrationPluginsPath(options?: object): string {
  return "/" + "admin" + "/" + "integration_plugins" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/integrations/:integration_id/adp_workforce_now_api_central/fields(.:format) */
export function adminIntegrationAdpWorkforceNowApiCentralFieldsPath(integration_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "integrations" + "/" + integration_id + "/" + "adp_workforce_now_api_central" + "/" + "fields" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["integration_id","format"]);
}

/** /admin/integrations/:integration_id/alva_labs/fields(.:format) */
export function adminIntegrationAlvaLabsFieldsPath(integration_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "integrations" + "/" + integration_id + "/" + "alva_labs" + "/" + "fields" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["integration_id","format"]);
}

/** /admin/integrations/:integration_id/criteria/fields(.:format) */
export function adminIntegrationCriteriaFieldsPath(integration_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "integrations" + "/" + integration_id + "/" + "criteria" + "/" + "fields" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["integration_id","format"]);
}

/** /admin/integrations/:integration_id/first_advantage/fields(.:format) */
export function adminIntegrationFirstAdvantageFieldsPath(integration_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "integrations" + "/" + integration_id + "/" + "first_advantage" + "/" + "fields" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["integration_id","format"]);
}

/** /admin/integrations/:integration_id/outmatch/job_codes(.:format) */
export function adminIntegrationOutmatchJobCodesPath(integration_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "integrations" + "/" + integration_id + "/" + "outmatch" + "/" + "job_codes" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["integration_id","format"]);
}

/** /admin/integrations/:integration_id/hireflix/fields(.:format) */
export function adminIntegrationHireflixFieldsPath(integration_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "integrations" + "/" + integration_id + "/" + "hireflix" + "/" + "fields" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["integration_id","format"]);
}

/** /admin/integrations/:integration_id/hire_right/fields(.:format) */
export function adminIntegrationHireRightFieldsPath(integration_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "integrations" + "/" + integration_id + "/" + "hire_right" + "/" + "fields" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["integration_id","format"]);
}

/** /admin/integrations/:integration_id/linked_in_companies/:linked_in_company_id/recruiter_system_connect/new(.:format) */
export function newAdminIntegrationLinkedInCompanyRecruiterSystemConnectPath(integration_id: ScalarType, linked_in_company_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "integrations" + "/" + integration_id + "/" + "linked_in_companies" + "/" + linked_in_company_id + "/" + "recruiter_system_connect" + "/" + "new" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["integration_id","linked_in_company_id","format"]);
}

/** /admin/integrations/:integration_id/linked_in_companies/:linked_in_company_id/recruiter_system_connect/edit(.:format) */
export function editAdminIntegrationLinkedInCompanyRecruiterSystemConnectPath(integration_id: ScalarType, linked_in_company_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "integrations" + "/" + integration_id + "/" + "linked_in_companies" + "/" + linked_in_company_id + "/" + "recruiter_system_connect" + "/" + "edit" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["integration_id","linked_in_company_id","format"]);
}

/** /admin/integrations/:integration_id/linked_in_companies/:linked_in_company_id/recruiter_system_connect(.:format) */
export function adminIntegrationLinkedInCompanyRecruiterSystemConnectPath(integration_id: ScalarType, linked_in_company_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "integrations" + "/" + integration_id + "/" + "linked_in_companies" + "/" + linked_in_company_id + "/" + "recruiter_system_connect" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["integration_id","linked_in_company_id","format"]);
}

/** /admin/integrations/:integration_id/linked_in_companies/:id(.:format) */
export function adminIntegrationLinkedInCompanyPath(integration_id: ScalarType, id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "integrations" + "/" + integration_id + "/" + "linked_in_companies" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["integration_id","id","format"]);
}

/** /admin/integrations/:integration_id/share_point/fields(.:format) */
export function adminIntegrationSharePointFieldsPath(integration_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "integrations" + "/" + integration_id + "/" + "share_point" + "/" + "fields" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["integration_id","format"]);
}

/** /admin/integrations/shl/packages(.:format) */
export function adminShlPackagesPath(options?: object): string {
  return "/" + "admin" + "/" + "integrations" + "/" + "shl" + "/" + "packages" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/integrations(.:format) */
export function adminIntegrationsPath(options?: object): string {
  return "/" + "admin" + "/" + "integrations" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/integrations/:id/edit(.:format) */
export function editAdminIntegrationPath(id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "integrations" + "/" + id + "/" + "edit" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /admin/interviews/:id(.:format) */
export function adminInterviewPath(id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "interviews" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /admin/interview_invites/previews(.:format) */
export function adminInterviewInvitesPreviewsPath(options?: object): string {
  return "/" + "admin" + "/" + "interview_invites" + "/" + "previews" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/job_board_postings(.:format) */
export function adminJobBoardPostingsPath(options?: object): string {
  return "/" + "admin" + "/" + "job_board_postings" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/question_collections/:question_collection_id/bulk_invites(.:format) */
export function adminQuestionCollectionBulkInvitesPath(question_collection_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "question_collections" + "/" + question_collection_id + "/" + "bulk_invites" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["question_collection_id","format"]);
}

/** /admin/referrals(.:format) */
export function adminReferralsPath(options?: object): string {
  return "/" + "admin" + "/" + "referrals" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/candidate_surveys_configuration(.:format) */
export function adminCandidateSurveysConfigurationIndexPath(options?: object): string {
  return "/" + "admin" + "/" + "candidate_surveys_configuration" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/organisation(.:format) */
export function adminOrganisationPath(options?: object): string {
  return "/" + "admin" + "/" + "organisation" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/organisation/permissions/filter_structure(.:format) */
export function filterStructureAdminOrganisationPermissionsPath(options?: object): string {
  return "/" + "admin" + "/" + "organisation" + "/" + "permissions" + "/" + "filter_structure" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/organisation/permissions(.:format) */
export function adminOrganisationPermissionsPath(options?: object): string {
  return "/" + "admin" + "/" + "organisation" + "/" + "permissions" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/organisation/structure(.:format) */
export function adminOrganisationStructurePath(options?: object): string {
  return "/" + "admin" + "/" + "organisation" + "/" + "structure" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/organisation/job_posting_locations(.:format) */
export function adminOrganisationJobPostingLocationsPath(options?: object): string {
  return "/" + "admin" + "/" + "organisation" + "/" + "job_posting_locations" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/job_seekers/bulk_import_cv(.:format) */
export function bulkImportCvAdminJobSeekersPath(options?: object): string {
  return "/" + "admin" + "/" + "job_seekers" + "/" + "bulk_import_cv" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/job_seekers/bulk_destroy(.:format) */
export function bulkDestroyAdminJobSeekersPath(options?: object): string {
  return "/" + "admin" + "/" + "job_seekers" + "/" + "bulk_destroy" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/applications/check_existing(.:format) */
export function checkExistingAdminApplicationsPath(options?: object): string {
  return "/" + "admin" + "/" + "applications" + "/" + "check_existing" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/applications(.:format) */
export function adminApplicationsPath(options?: object): string {
  return "/" + "admin" + "/" + "applications" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/settings(.:format) */
export function adminSettingsRootPath(options?: object): string {
  return "/" + "admin" + "/" + "settings" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/settings/account(.:format) */
export function adminSettingsAccountPath(options?: object): string {
  return "/" + "admin" + "/" + "settings" + "/" + "account" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/settings/availability(.:format) */
export function adminSettingsAvailabilityPath(options?: object): string {
  return "/" + "admin" + "/" + "settings" + "/" + "availability" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/settings/security/verify(.:format) */
export function verifyAdminSettingsSecurityPath(options?: object): string {
  return "/" + "admin" + "/" + "settings" + "/" + "security" + "/" + "verify" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/settings/security/reconfigure(.:format) */
export function reconfigureAdminSettingsSecurityPath(options?: object): string {
  return "/" + "admin" + "/" + "settings" + "/" + "security" + "/" + "reconfigure" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/settings/security/recovery_codes(.:format) */
export function recoveryCodesAdminSettingsSecurityPath(options?: object): string {
  return "/" + "admin" + "/" + "settings" + "/" + "security" + "/" + "recovery_codes" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/settings/security(.:format) */
export function adminSettingsSecurityPath(options?: object): string {
  return "/" + "admin" + "/" + "settings" + "/" + "security" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/settings/templates/job_requisitions(.:format) */
export function adminSettingsTemplatesJobRequisitionsPath(options?: object): string {
  return "/" + "admin" + "/" + "settings" + "/" + "templates" + "/" + "job_requisitions" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/settings/templates/email_templates(.:format) */
export function adminSettingsTemplatesEmailTemplatesPath(options?: object): string {
  return "/" + "admin" + "/" + "settings" + "/" + "templates" + "/" + "email_templates" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/settings/templates/document_templates(.:format) */
export function adminSettingsTemplatesDocumentTemplatesPath(options?: object): string {
  return "/" + "admin" + "/" + "settings" + "/" + "templates" + "/" + "document_templates" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/settings/templates/equality_monitoring_templates(.:format) */
export function adminSettingsTemplatesEqualityMonitoringTemplatesPath(options?: object): string {
  return "/" + "admin" + "/" + "settings" + "/" + "templates" + "/" + "equality_monitoring_templates" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/settings/templates/hiring_workflows(.:format) */
export function adminSettingsTemplatesHiringWorkflowsPath(options?: object): string {
  return "/" + "admin" + "/" + "settings" + "/" + "templates" + "/" + "hiring_workflows" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/settings/templates/interview_types(.:format) */
export function adminSettingsTemplatesInterviewTypesPath(options?: object): string {
  return "/" + "admin" + "/" + "settings" + "/" + "templates" + "/" + "interview_types" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/settings/templates/offer_templates/:offer_template_id/offer_letter(.:format) */
export function adminSettingsTemplatesOfferTemplateOfferLetterPath(offer_template_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "settings" + "/" + "templates" + "/" + "offer_templates" + "/" + offer_template_id + "/" + "offer_letter" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["offer_template_id","format"]);
}

/** /admin/settings/templates/offer_templates(.:format) */
export function adminSettingsTemplatesOfferTemplatesPath(options?: object): string {
  return "/" + "admin" + "/" + "settings" + "/" + "templates" + "/" + "offer_templates" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/settings/templates/job_groups(.:format) */
export function adminSettingsTemplatesJobGroupsPath(options?: object): string {
  return "/" + "admin" + "/" + "settings" + "/" + "templates" + "/" + "job_groups" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/settings/templates/job_templates(.:format) */
export function adminSettingsTemplatesJobTemplatesPath(options?: object): string {
  return "/" + "admin" + "/" + "settings" + "/" + "templates" + "/" + "job_templates" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/settings/templates/onboarding_email_templates(.:format) */
export function adminSettingsTemplatesOnboardingEmailTemplatesPath(options?: object): string {
  return "/" + "admin" + "/" + "settings" + "/" + "templates" + "/" + "onboarding_email_templates" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/settings/templates/onboarding_questions(.:format) */
export function adminSettingsTemplatesOnboardingQuestionsPath(options?: object): string {
  return "/" + "admin" + "/" + "settings" + "/" + "templates" + "/" + "onboarding_questions" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/settings/templates/question_bank(.:format) */
export function adminSettingsTemplatesQuestionBankIndexPath(options?: object): string {
  return "/" + "admin" + "/" + "settings" + "/" + "templates" + "/" + "question_bank" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/settings/templates/question_collections(.:format) */
export function adminSettingsTemplatesQuestionCollectionsPath(options?: object): string {
  return "/" + "admin" + "/" + "settings" + "/" + "templates" + "/" + "question_collections" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/settings/templates/reference_templates(.:format) */
export function adminSettingsTemplatesReferenceTemplatesPath(options?: object): string {
  return "/" + "admin" + "/" + "settings" + "/" + "templates" + "/" + "reference_templates" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/settings/templates/scorecards(.:format) */
export function adminSettingsTemplatesScorecardsPath(options?: object): string {
  return "/" + "admin" + "/" + "settings" + "/" + "templates" + "/" + "scorecards" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/settings/templates/sign_off_workflows(.:format) */
export function adminSettingsTemplatesSignOffWorkflowsPath(options?: object): string {
  return "/" + "admin" + "/" + "settings" + "/" + "templates" + "/" + "sign_off_workflows" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/settings/templates/structured_sections(.:format) */
export function adminSettingsTemplatesStructuredSectionsPath(options?: object): string {
  return "/" + "admin" + "/" + "settings" + "/" + "templates" + "/" + "structured_sections" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/settings/templates/sms_templates(.:format) */
export function adminSettingsTemplatesSmsTemplatesPath(options?: object): string {
  return "/" + "admin" + "/" + "settings" + "/" + "templates" + "/" + "sms_templates" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/settings/templates/workflow_automations(.:format) */
export function adminSettingsTemplatesWorkflowAutomationsPath(options?: object): string {
  return "/" + "admin" + "/" + "settings" + "/" + "templates" + "/" + "workflow_automations" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/settings/profile(.:format) */
export function adminSettingsProfilePath(options?: object): string {
  return "/" + "admin" + "/" + "settings" + "/" + "profile" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/settings/notifications(.:format) */
export function adminSettingsNotificationsPath(options?: object): string {
  return "/" + "admin" + "/" + "settings" + "/" + "notifications" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/settings/notifications/presets/apply(.:format) */
export function applyAdminSettingsNotificationsPresetsPath(options?: object): string {
  return "/" + "admin" + "/" + "settings" + "/" + "notifications" + "/" + "presets" + "/" + "apply" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/settings/notifications/presets/copy(.:format) */
export function copyAdminSettingsNotificationsPresetsPath(options?: object): string {
  return "/" + "admin" + "/" + "settings" + "/" + "notifications" + "/" + "presets" + "/" + "copy" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/settings/notifications/presets(.:format) */
export function adminSettingsNotificationsPresetsPath(options?: object): string {
  return "/" + "admin" + "/" + "settings" + "/" + "notifications" + "/" + "presets" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/settings/integrations(.:format) */
export function adminSettingsIntegrationsPath(options?: object): string {
  return "/" + "admin" + "/" + "settings" + "/" + "integrations" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/settings/integrations/slack/configure(.:format) */
export function configureAdminSettingsIntegrationsSlackPath(options?: object): string {
  return "/" + "admin" + "/" + "settings" + "/" + "integrations" + "/" + "slack" + "/" + "configure" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/settings/integrations/slack/request_verification(.:format) */
export function requestVerificationAdminSettingsIntegrationsSlackPath(options?: object): string {
  return "/" + "admin" + "/" + "settings" + "/" + "integrations" + "/" + "slack" + "/" + "request_verification" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/settings/integrations/slack/verify_email(.:format) */
export function verifyEmailAdminSettingsIntegrationsSlackPath(options?: object): string {
  return "/" + "admin" + "/" + "settings" + "/" + "integrations" + "/" + "slack" + "/" + "verify_email" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/settings/workflow_automations(.:format) */
export function adminSettingsWorkflowAutomationsPath(options?: object): string {
  return "/" + "admin" + "/" + "settings" + "/" + "workflow_automations" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/settings/workflow_automations/new(.:format) */
export function newAdminSettingsWorkflowAutomationPath(options?: object): string {
  return "/" + "admin" + "/" + "settings" + "/" + "workflow_automations" + "/" + "new" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/settings/workflow_automations/:id/edit(.:format) */
export function editAdminSettingsWorkflowAutomationPath(id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "settings" + "/" + "workflow_automations" + "/" + id + "/" + "edit" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /admin/settings/workflow_automations/:id(.:format) */
export function adminSettingsWorkflowAutomationPath(id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "settings" + "/" + "workflow_automations" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /admin/automations(.:format) */
export function adminAutomationsPath(options?: object): string {
  return "/" + "admin" + "/" + "automations" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/automations/*path(.:format) */
export function adminPath(path: ScalarType[], options?: object): string {
  return "/" + "admin" + "/" + "automations" + "/" + path.map((part) => $encode(part)).join("/") + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["path","format"]);
}

/** /admin/scorecards(.:format) */
export function adminScorecardsPath(options?: object): string {
  return "/" + "admin" + "/" + "scorecards" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/users/bulk_import(.:format) */
export function bulkImportAdminUsersPath(options?: object): string {
  return "/" + "admin" + "/" + "users" + "/" + "bulk_import" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/users/bulk_add_agency(.:format) */
export function bulkAddAgencyAdminUsersPath(options?: object): string {
  return "/" + "admin" + "/" + "users" + "/" + "bulk_add_agency" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/tags(.:format) */
export function adminTagsPath(options?: object): string {
  return "/" + "admin" + "/" + "tags" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/talent-pipeline/settings(.:format) */
export function adminTalentPipelinesSettingsPath(options?: object): string {
  return "/" + "admin" + "/" + "talent-pipeline" + "/" + "settings" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/talent-pipeline/interviews/configuration(.:format) */
export function adminTalentPipelinesInterviewsConfigurationPath(options?: object): string {
  return "/" + "admin" + "/" + "talent-pipeline" + "/" + "interviews" + "/" + "configuration" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/talent-pipeline/interviews/interview_openings/bulk_create(.:format) */
export function bulkCreateAdminTalentPipelinesInterviewsInterviewOpeningsPath(options?: object): string {
  return "/" + "admin" + "/" + "talent-pipeline" + "/" + "interviews" + "/" + "interview_openings" + "/" + "bulk_create" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/talent-pipeline/interviews/interview_openings(.:format) */
export function adminTalentPipelinesInterviewsInterviewOpeningsPath(options?: object): string {
  return "/" + "admin" + "/" + "talent-pipeline" + "/" + "interviews" + "/" + "interview_openings" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/talent-pipeline/interviews/interview_openings/:id(.:format) */
export function adminTalentPipelinesInterviewsInterviewOpeningPath(id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "talent-pipeline" + "/" + "interviews" + "/" + "interview_openings" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /admin/talent-pipeline/interviews/interview_team_members_availability/availability(.:format) */
export function availabilityAdminTalentPipelinesInterviewsInterviewTeamMembersAvailabilityPath(options?: object): string {
  return "/" + "admin" + "/" + "talent-pipeline" + "/" + "interviews" + "/" + "interview_team_members_availability" + "/" + "availability" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/talent-pipeline/interviews/interview_invites/availability(.:format) */
export function availabilityAdminTalentPipelinesInterviewsInterviewInvitesPath(options?: object): string {
  return "/" + "admin" + "/" + "talent-pipeline" + "/" + "interviews" + "/" + "interview_invites" + "/" + "availability" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/talent-pipeline/interviews/interview_invites(.:format) */
export function adminTalentPipelinesInterviewsInterviewInvitesPath(options?: object): string {
  return "/" + "admin" + "/" + "talent-pipeline" + "/" + "interviews" + "/" + "interview_invites" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/talent-pipeline/interviews/previews/interviews(.:format) */
export function adminTalentPipelinesInterviewsPreviewsInterviewsPath(options?: object): string {
  return "/" + "admin" + "/" + "talent-pipeline" + "/" + "interviews" + "/" + "previews" + "/" + "interviews" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/talent-pipeline/registered-candidates/invite(.:format) */
export function inviteAdminTalentPipelinesJobSeekersPath(options?: object): string {
  return "/" + "admin" + "/" + "talent-pipeline" + "/" + "registered-candidates" + "/" + "invite" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/talent-pipeline/registered-candidates/share(.:format) */
export function shareAdminTalentPipelinesJobSeekersPath(options?: object): string {
  return "/" + "admin" + "/" + "talent-pipeline" + "/" + "registered-candidates" + "/" + "share" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/talent-pipeline/registered-candidates/scorecards(.:format) */
export function scorecardsAdminTalentPipelinesJobSeekersPath(options?: object): string {
  return "/" + "admin" + "/" + "talent-pipeline" + "/" + "registered-candidates" + "/" + "scorecards" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/talent-pipeline/registered-candidates/scorecard_ratings(.:format) */
export function scorecardRatingsAdminTalentPipelinesJobSeekersPath(options?: object): string {
  return "/" + "admin" + "/" + "talent-pipeline" + "/" + "registered-candidates" + "/" + "scorecard_ratings" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/talent-pipeline/registered-candidates/:job_seeker_id/documents(.:format) */
export function adminTalentPipelinesJobSeekerDocumentsPath(job_seeker_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "talent-pipeline" + "/" + "registered-candidates" + "/" + job_seeker_id + "/" + "documents" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_seeker_id","format"]);
}

/** /admin/talent-pipeline/registered-candidates/:job_seeker_id/cv(.:format) */
export function adminTalentPipelinesJobSeekerCvPath(job_seeker_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "talent-pipeline" + "/" + "registered-candidates" + "/" + job_seeker_id + "/" + "cv" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_seeker_id","format"]);
}

/** /admin/talent-pipeline/registered-candidates/:job_seeker_id/scorecards(.:format) */
export function adminTalentPipelinesJobSeekerScorecardsPath(job_seeker_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "talent-pipeline" + "/" + "registered-candidates" + "/" + job_seeker_id + "/" + "scorecards" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_seeker_id","format"]);
}

/** /admin/talent-pipeline/registered-candidates/:job_seeker_id/comments(.:format) */
export function adminTalentPipelinesJobSeekerCommentsPath(job_seeker_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "talent-pipeline" + "/" + "registered-candidates" + "/" + job_seeker_id + "/" + "comments" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_seeker_id","format"]);
}

/** /admin/talent-pipeline/registered-candidates/:job_seeker_id/applications(.:format) */
export function adminTalentPipelinesJobSeekerApplicationsPath(job_seeker_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "talent-pipeline" + "/" + "registered-candidates" + "/" + job_seeker_id + "/" + "applications" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_seeker_id","format"]);
}

/** /admin/talent-pipeline/registered-candidates/:job_seeker_id/messages(.:format) */
export function adminTalentPipelinesJobSeekerMessagesPath(job_seeker_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "talent-pipeline" + "/" + "registered-candidates" + "/" + job_seeker_id + "/" + "messages" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_seeker_id","format"]);
}

/** /admin/talent-pipeline/registered-candidates/:job_seeker_id/interviews(.:format) */
export function adminTalentPipelinesJobSeekerInterviewsPath(job_seeker_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "talent-pipeline" + "/" + "registered-candidates" + "/" + job_seeker_id + "/" + "interviews" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_seeker_id","format"]);
}

/** /admin/talent-pipeline/registered-candidates/:job_seeker_id/resume(.:format) */
export function adminTalentPipelinesJobSeekerResumePath(job_seeker_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "talent-pipeline" + "/" + "registered-candidates" + "/" + job_seeker_id + "/" + "resume" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_seeker_id","format"]);
}

/** /admin/talent-pipeline/registered-candidates(.:format) */
export function adminTalentPipelinesJobSeekersPath(options?: object): string {
  return "/" + "admin" + "/" + "talent-pipeline" + "/" + "registered-candidates" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/talent-pipeline/registered-candidates/new(.:format) */
export function newAdminTalentPipelinesJobSeekerPath(options?: object): string {
  return "/" + "admin" + "/" + "talent-pipeline" + "/" + "registered-candidates" + "/" + "new" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/talent-pipeline/registered-candidates/:id(.:format) */
export function adminTalentPipelinesJobSeekerPath(id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "talent-pipeline" + "/" + "registered-candidates" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /admin/talent-pipeline/job_seekers/custom_emails(.:format) */
export function adminTalentPipelinesJobSeekersCustomEmailsPath(options?: object): string {
  return "/" + "admin" + "/" + "talent-pipeline" + "/" + "job_seekers" + "/" + "custom_emails" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/talent-pipeline/job_seekers/scorecard_downloads(.:format) */
export function adminTalentPipelinesJobSeekersScorecardDownloadsPath(options?: object): string {
  return "/" + "admin" + "/" + "talent-pipeline" + "/" + "job_seekers" + "/" + "scorecard_downloads" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/talent-pipeline/talent_pools/:talent_pool_id/bulk_job_seekers/remove(.:format) */
export function removeAdminTalentPipelinesTalentPoolBulkJobSeekersPath(talent_pool_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "talent-pipeline" + "/" + "talent_pools" + "/" + talent_pool_id + "/" + "bulk_job_seekers" + "/" + "remove" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["talent_pool_id","format"]);
}

/** /admin/talent-pipeline/talent_pools/:talent_pool_id/bulk_job_seekers(.:format) */
export function adminTalentPipelinesTalentPoolBulkJobSeekersPath(talent_pool_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "talent-pipeline" + "/" + "talent_pools" + "/" + talent_pool_id + "/" + "bulk_job_seekers" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["talent_pool_id","format"]);
}

/** /admin/talent-pipeline/talent_pools(.:format) */
export function adminTalentPipelinesTalentPoolsPath(options?: object): string {
  return "/" + "admin" + "/" + "talent-pipeline" + "/" + "talent_pools" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/talent-pipeline/talent_pools/new(.:format) */
export function newAdminTalentPipelinesTalentPoolPath(options?: object): string {
  return "/" + "admin" + "/" + "talent-pipeline" + "/" + "talent_pools" + "/" + "new" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/talent-pipeline/talent_pools/:id/edit(.:format) */
export function editAdminTalentPipelinesTalentPoolPath(id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "talent-pipeline" + "/" + "talent_pools" + "/" + id + "/" + "edit" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /admin/talent-pipeline/talent_pools/:id(.:format) */
export function adminTalentPipelinesTalentPoolPath(id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "talent-pipeline" + "/" + "talent_pools" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /admin/candidates/:candidate_id/linked_in_profiles(.:format) */
export function adminCandidateLinkedInProfilesPath(candidate_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "candidates" + "/" + candidate_id + "/" + "linked_in_profiles" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["candidate_id","format"]);
}

/** /admin/candidates(.:format) */
export function adminCandidatesPath(options?: object): string {
  return "/" + "admin" + "/" + "candidates" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/candidates/:id(.:format) */
export function adminCandidatePath(id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "candidates" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /admin/candidates/custom_emails(.:format) */
export function adminCandidatesCustomEmailsPath(options?: object): string {
  return "/" + "admin" + "/" + "candidates" + "/" + "custom_emails" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/candidates/jobs/bulk_create_applications(.:format) */
export function bulkCreateApplicationsAdminCandidatesJobsPath(options?: object): string {
  return "/" + "admin" + "/" + "candidates" + "/" + "jobs" + "/" + "bulk_create_applications" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/candidates/jobs/bulk_invite_apply(.:format) */
export function bulkInviteApplyAdminCandidatesJobsPath(options?: object): string {
  return "/" + "admin" + "/" + "candidates" + "/" + "jobs" + "/" + "bulk_invite_apply" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/candidates/jobs/bulk_send_equality_monitoring_survey(.:format) */
export function bulkSendEqualityMonitoringSurveyAdminCandidatesJobsPath(options?: object): string {
  return "/" + "admin" + "/" + "candidates" + "/" + "jobs" + "/" + "bulk_send_equality_monitoring_survey" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/user_management/access_groups(.:format) */
export function adminUserManagementAccessGroupsPath(options?: object): string {
  return "/" + "admin" + "/" + "user_management" + "/" + "access_groups" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/user_management/company_teams(.:format) */
export function adminUserManagementCompanyTeamsPath(options?: object): string {
  return "/" + "admin" + "/" + "user_management" + "/" + "company_teams" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/user_management/recruiters(.:format) */
export function adminUserManagementRecruitersPath(options?: object): string {
  return "/" + "admin" + "/" + "user_management" + "/" + "recruiters" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/user_management/recruiters/new(.:format) */
export function newAdminUserManagementRecruiterPath(options?: object): string {
  return "/" + "admin" + "/" + "user_management" + "/" + "recruiters" + "/" + "new" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/user_management/agencies(.:format) */
export function adminUserManagementAgenciesPath(options?: object): string {
  return "/" + "admin" + "/" + "user_management" + "/" + "agencies" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/user_management/agency_users(.:format) */
export function adminUserManagementAgencyUsersPath(options?: object): string {
  return "/" + "admin" + "/" + "user_management" + "/" + "agency_users" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/user_management/agency_users/new(.:format) */
export function newAdminUserManagementAgencyUserPath(options?: object): string {
  return "/" + "admin" + "/" + "user_management" + "/" + "agency_users" + "/" + "new" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/user_management/employees(.:format) */
export function adminUserManagementEmployeesPath(options?: object): string {
  return "/" + "admin" + "/" + "user_management" + "/" + "employees" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/user_management/employees/new(.:format) */
export function newAdminUserManagementEmployeePath(options?: object): string {
  return "/" + "admin" + "/" + "user_management" + "/" + "employees" + "/" + "new" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/user_management/employees/:id(.:format) */
export function adminUserManagementEmployeePath(id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "user_management" + "/" + "employees" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /admin/user_management/non_user_employees(.:format) */
export function adminUserManagementNonUserEmployeesPath(options?: object): string {
  return "/" + "admin" + "/" + "user_management" + "/" + "non_user_employees" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/user_management/approval_lists(.:format) */
export function adminUserManagementApprovalListsPath(options?: object): string {
  return "/" + "admin" + "/" + "user_management" + "/" + "approval_lists" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/team/access_groups(.:format) */
export function adminTeamAccessGroupsPath(options?: object): string {
  return "/" + "admin" + "/" + "team" + "/" + "access_groups" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/team/company_teams(.:format) */
export function adminTeamCompanyTeamsPath(options?: object): string {
  return "/" + "admin" + "/" + "team" + "/" + "company_teams" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/team/recruiters(.:format) */
export function adminTeamRecruitersPath(options?: object): string {
  return "/" + "admin" + "/" + "team" + "/" + "recruiters" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/team/recruiters/new(.:format) */
export function adminTeamRecruitersNewPath(options?: object): string {
  return "/" + "admin" + "/" + "team" + "/" + "recruiters" + "/" + "new" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/team/employees(.:format) */
export function adminTeamEmployeesPath(options?: object): string {
  return "/" + "admin" + "/" + "team" + "/" + "employees" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/team/employees/new(.:format) */
export function adminTeamEmployeesNewPath(options?: object): string {
  return "/" + "admin" + "/" + "team" + "/" + "employees" + "/" + "new" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/wizards/:id(.:format) */
export function adminWizardPath(id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "wizards" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /admin/onboarding(.:format) */
export function adminOnboardingRootPath(options?: object): string {
  return "/" + "admin" + "/" + "onboarding" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/onboarding/custom_emails(.:format) */
export function adminOnboardingCustomEmailsPath(options?: object): string {
  return "/" + "admin" + "/" + "onboarding" + "/" + "custom_emails" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/onboarding/portals(.:format) */
export function adminOnboardingPortalsPath(options?: object): string {
  return "/" + "admin" + "/" + "onboarding" + "/" + "portals" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/onboarding/preview_workflow(.:format) */
export function adminOnboardingPreviewWorkflowPath(options?: object): string {
  return "/" + "admin" + "/" + "onboarding" + "/" + "preview_workflow" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/onboarding/workflows(.:format) */
export function adminOnboardingWorkflowsPath(options?: object): string {
  return "/" + "admin" + "/" + "onboarding" + "/" + "workflows" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/onboarding/step_templates(.:format) */
export function adminOnboardingStepTemplatesPath(options?: object): string {
  return "/" + "admin" + "/" + "onboarding" + "/" + "step_templates" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/onboarding/processes/:process_id/step_previews(.:format) */
export function adminOnboardingProcessStepPreviewPath(process_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "onboarding" + "/" + "processes" + "/" + process_id + "/" + "step_previews" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["process_id","format"]);
}

/** /admin/onboarding/processes(.:format) */
export function adminOnboardingProcessesPath(options?: object): string {
  return "/" + "admin" + "/" + "onboarding" + "/" + "processes" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/onboarding/processes/:id(.:format) */
export function adminOnboardingProcessPath(id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "onboarding" + "/" + "processes" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /admin/onboarding/processes/candidates/bulk_send_reminders(.:format) */
export function adminOnboardingProcessesCandidatesBulkSendRemindersPath(options?: object): string {
  return "/" + "admin" + "/" + "onboarding" + "/" + "processes" + "/" + "candidates" + "/" + "bulk_send_reminders" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/onboarding/candidates/archived(.:format) */
export function archivedAdminOnboardingCandidatesPath(options?: object): string {
  return "/" + "admin" + "/" + "onboarding" + "/" + "candidates" + "/" + "archived" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/onboarding/candidates/settings(.:format) */
export function settingsAdminOnboardingCandidatesPath(options?: object): string {
  return "/" + "admin" + "/" + "onboarding" + "/" + "candidates" + "/" + "settings" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/onboarding/candidates/legacy(.:format) */
export function legacyAdminOnboardingCandidatesPath(options?: object): string {
  return "/" + "admin" + "/" + "onboarding" + "/" + "candidates" + "/" + "legacy" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/onboarding/candidates/stages(.:format) */
export function stagesAdminOnboardingCandidatesPath(options?: object): string {
  return "/" + "admin" + "/" + "onboarding" + "/" + "candidates" + "/" + "stages" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/onboarding/candidates/:candidate_id/comments(.:format) */
export function adminOnboardingCandidateCommentsPath(candidate_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "onboarding" + "/" + "candidates" + "/" + candidate_id + "/" + "comments" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["candidate_id","format"]);
}

/** /admin/onboarding/candidates/:candidate_id/exports(.:format) */
export function adminOnboardingCandidateExportsPath(candidate_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "onboarding" + "/" + "candidates" + "/" + candidate_id + "/" + "exports" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["candidate_id","format"]);
}

/** /admin/onboarding/candidates/:candidate_id/setup(.:format) */
export function adminOnboardingCandidateSetupPath(candidate_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "onboarding" + "/" + "candidates" + "/" + candidate_id + "/" + "setup" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["candidate_id","format"]);
}

/** /admin/onboarding/candidates/:candidate_id/review(.:format) */
export function adminOnboardingCandidateReviewPath(candidate_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "onboarding" + "/" + "candidates" + "/" + candidate_id + "/" + "review" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["candidate_id","format"]);
}

/** /admin/onboarding/candidates/:candidate_id/finish(.:format) */
export function adminOnboardingCandidateFinishPath(candidate_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "onboarding" + "/" + "candidates" + "/" + candidate_id + "/" + "finish" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["candidate_id","format"]);
}

/** /admin/onboarding/candidates/:candidate_id/messages(.:format) */
export function adminOnboardingCandidateMessagesPath(candidate_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "onboarding" + "/" + "candidates" + "/" + candidate_id + "/" + "messages" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["candidate_id","format"]);
}

/** /admin/onboarding/candidates/:candidate_id/tasks(.:format) */
export function adminOnboardingCandidateTasksPath(candidate_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "onboarding" + "/" + "candidates" + "/" + candidate_id + "/" + "tasks" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["candidate_id","format"]);
}

/** /admin/onboarding/candidates/:candidate_id/downloads/documents(.:format) */
export function documentsAdminOnboardingCandidateDownloadsPath(candidate_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "onboarding" + "/" + "candidates" + "/" + candidate_id + "/" + "downloads" + "/" + "documents" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["candidate_id","format"]);
}

/** /admin/onboarding/candidates/:candidate_id/downloads/responses(.:format) */
export function responsesAdminOnboardingCandidateDownloadsPath(candidate_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "onboarding" + "/" + "candidates" + "/" + candidate_id + "/" + "downloads" + "/" + "responses" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["candidate_id","format"]);
}

/** /admin/onboarding/candidates/:candidate_id/downloads(.:format) */
export function adminOnboardingCandidateDownloadsPath(candidate_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "onboarding" + "/" + "candidates" + "/" + candidate_id + "/" + "downloads" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["candidate_id","format"]);
}

/** /admin/onboarding/candidates/:candidate_id/downloads/new(.:format) */
export function newAdminOnboardingCandidateDownloadPath(candidate_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "onboarding" + "/" + "candidates" + "/" + candidate_id + "/" + "downloads" + "/" + "new" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["candidate_id","format"]);
}

/** /admin/onboarding/candidates/:candidate_id/downloads/:id/edit(.:format) */
export function editAdminOnboardingCandidateDownloadPath(candidate_id: ScalarType, id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "onboarding" + "/" + "candidates" + "/" + candidate_id + "/" + "downloads" + "/" + id + "/" + "edit" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["candidate_id","id","format"]);
}

/** /admin/onboarding/candidates/:candidate_id/downloads/:id(.:format) */
export function adminOnboardingCandidateDownloadPath(candidate_id: ScalarType, id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "onboarding" + "/" + "candidates" + "/" + candidate_id + "/" + "downloads" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["candidate_id","id","format"]);
}

/** /admin/onboarding/candidates/:candidate_id/actions/unarchive(.:format) */
export function unarchiveAdminOnboardingCandidateActionsPath(candidate_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "onboarding" + "/" + "candidates" + "/" + candidate_id + "/" + "actions" + "/" + "unarchive" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["candidate_id","format"]);
}

/** /admin/onboarding/candidates/:candidate_id/bob/employees(.:format) */
export function adminOnboardingCandidateBobEmployeesPath(candidate_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "onboarding" + "/" + "candidates" + "/" + candidate_id + "/" + "bob" + "/" + "employees" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["candidate_id","format"]);
}

/** /admin/onboarding/candidates/:candidate_id/peoplehr/employees(.:format) */
export function adminOnboardingCandidatePeoplehrEmployeesPath(candidate_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "onboarding" + "/" + "candidates" + "/" + candidate_id + "/" + "peoplehr" + "/" + "employees" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["candidate_id","format"]);
}

/** /admin/onboarding/candidates(.:format) */
export function adminOnboardingCandidatesPath(options?: object): string {
  return "/" + "admin" + "/" + "onboarding" + "/" + "candidates" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/onboarding/candidates/:id(.:format) */
export function adminOnboardingCandidatePath(id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "onboarding" + "/" + "candidates" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /admin/onboarding/integrations/providers/bryq/assessments(.:format) */
export function adminOnboardingIntegrationsProvidersBryqAssessmentsPath(options?: object): string {
  return "/" + "admin" + "/" + "onboarding" + "/" + "integrations" + "/" + "providers" + "/" + "bryq" + "/" + "assessments" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/onboarding/integrations/providers/canditech/assessments(.:format) */
export function adminOnboardingIntegrationsProvidersCanditechAssessmentsPath(options?: object): string {
  return "/" + "admin" + "/" + "onboarding" + "/" + "integrations" + "/" + "providers" + "/" + "canditech" + "/" + "assessments" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/onboarding/integrations/providers/cappfinity/assessments(.:format) */
export function adminOnboardingIntegrationsProvidersCappfinityAssessmentsPath(options?: object): string {
  return "/" + "admin" + "/" + "onboarding" + "/" + "integrations" + "/" + "providers" + "/" + "cappfinity" + "/" + "assessments" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/onboarding/integrations/providers/checkr/packages(.:format) */
export function adminOnboardingIntegrationsProvidersCheckrPackagesPath(options?: object): string {
  return "/" + "admin" + "/" + "onboarding" + "/" + "integrations" + "/" + "providers" + "/" + "checkr" + "/" + "packages" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/onboarding/integrations/providers/checkr/nodes(.:format) */
export function adminOnboardingIntegrationsProvidersCheckrNodesPath(options?: object): string {
  return "/" + "admin" + "/" + "onboarding" + "/" + "integrations" + "/" + "providers" + "/" + "checkr" + "/" + "nodes" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/onboarding/integrations/providers/codility/assessments(.:format) */
export function adminOnboardingIntegrationsProvidersCodilityAssessmentsPath(options?: object): string {
  return "/" + "admin" + "/" + "onboarding" + "/" + "integrations" + "/" + "providers" + "/" + "codility" + "/" + "assessments" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/onboarding/integrations/providers/creative_services_inc/background_checks(.:format) */
export function adminOnboardingIntegrationsProvidersCreativeServicesIncBackgroundChecksPath(options?: object): string {
  return "/" + "admin" + "/" + "onboarding" + "/" + "integrations" + "/" + "providers" + "/" + "creative_services_inc" + "/" + "background_checks" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/onboarding/integrations/providers/criteria/assessments(.:format) */
export function adminOnboardingIntegrationsProvidersCriteriaAssessmentsPath(options?: object): string {
  return "/" + "admin" + "/" + "onboarding" + "/" + "integrations" + "/" + "providers" + "/" + "criteria" + "/" + "assessments" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/onboarding/integrations/providers/first_advantage_kyp/fields(.:format) */
export function adminOnboardingIntegrationsProvidersFirstAdvantageKypFieldsPath(options?: object): string {
  return "/" + "admin" + "/" + "onboarding" + "/" + "integrations" + "/" + "providers" + "/" + "first_advantage_kyp" + "/" + "fields" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/onboarding/integrations/providers/sterling/fields(.:format) */
export function adminOnboardingIntegrationsProvidersSterlingFieldsPath(options?: object): string {
  return "/" + "admin" + "/" + "onboarding" + "/" + "integrations" + "/" + "providers" + "/" + "sterling" + "/" + "fields" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/onboarding/integrations/providers/zinc/background_checks(.:format) */
export function adminOnboardingIntegrationsProvidersZincBackgroundChecksPath(options?: object): string {
  return "/" + "admin" + "/" + "onboarding" + "/" + "integrations" + "/" + "providers" + "/" + "zinc" + "/" + "background_checks" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/onboarding/workflows/templates/create_workflow(.:format) */
export function createWorkflowAdminOnboardingWorkflowsTemplatesPath(options?: object): string {
  return "/" + "admin" + "/" + "onboarding" + "/" + "workflows" + "/" + "templates" + "/" + "create_workflow" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/onboarding/workflows/templates(.:format) */
export function adminOnboardingWorkflowsTemplatesPath(options?: object): string {
  return "/" + "admin" + "/" + "onboarding" + "/" + "workflows" + "/" + "templates" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/onboarding/workflows/templates/:id(.:format) */
export function adminOnboardingWorkflowsTemplatePath(id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "onboarding" + "/" + "workflows" + "/" + "templates" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /admin/position_management(.:format) */
export function adminPositionManagementRootPath(options?: object): string {
  return "/" + "admin" + "/" + "position_management" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/position_management/positions/archived(.:format) */
export function archivedAdminPositionManagementPositionsPath(options?: object): string {
  return "/" + "admin" + "/" + "position_management" + "/" + "positions" + "/" + "archived" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/position_management/positions(.:format) */
export function adminPositionManagementPositionsPath(options?: object): string {
  return "/" + "admin" + "/" + "position_management" + "/" + "positions" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/position_management/positions/new(.:format) */
export function newAdminPositionManagementPositionPath(options?: object): string {
  return "/" + "admin" + "/" + "position_management" + "/" + "positions" + "/" + "new" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/position_management/positions/:id/edit(.:format) */
export function editAdminPositionManagementPositionPath(id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "position_management" + "/" + "positions" + "/" + id + "/" + "edit" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /admin/position_management/positions/:id(.:format) */
export function adminPositionManagementPositionPath(id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "position_management" + "/" + "positions" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /admin/insights(.:format) */
export function adminInsightsRootPath(options?: object): string {
  return "/" + "admin" + "/" + "insights" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/insights/candidate_surveys(.:format) */
export function adminInsightsCandidateSurveysPath(options?: object): string {
  return "/" + "admin" + "/" + "insights" + "/" + "candidate_surveys" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/insights/candidate_surveys/exports(.:format) */
export function adminInsightsCandidateSurveysExportsPath(options?: object): string {
  return "/" + "admin" + "/" + "insights" + "/" + "candidate_surveys" + "/" + "exports" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/insights/insights_pages(.:format) */
export function adminInsightsInsightsPagesPath(options?: object): string {
  return "/" + "admin" + "/" + "insights" + "/" + "insights_pages" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/insights/insights_pages/:id(.:format) */
export function adminInsightsInsightsPagePath(id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "insights" + "/" + "insights_pages" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /admin/insights/candidates(.:format) */
export function adminInsightsCandidatesPath(options?: object): string {
  return "/" + "admin" + "/" + "insights" + "/" + "candidates" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/insights/interviews(.:format) */
export function adminInsightsInterviewsPath(options?: object): string {
  return "/" + "admin" + "/" + "insights" + "/" + "interviews" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/insights/jobs(.:format) */
export function adminInsightsJobsPath(options?: object): string {
  return "/" + "admin" + "/" + "insights" + "/" + "jobs" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/insights/users(.:format) */
export function adminInsightsUsersPath(options?: object): string {
  return "/" + "admin" + "/" + "insights" + "/" + "users" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/insights/equality_monitoring(.:format) */
export function adminInsightsEqualityMonitoringPath(options?: object): string {
  return "/" + "admin" + "/" + "insights" + "/" + "equality_monitoring" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/insights/reports(.:format) */
export function adminInsightsReportsPath(options?: object): string {
  return "/" + "admin" + "/" + "insights" + "/" + "reports" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/job_board_baskets/:job_board_basket_id/payment_intents(.:format) */
export function adminJobBoardBasketPaymentIntentsPath(job_board_basket_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "job_board_baskets" + "/" + job_board_basket_id + "/" + "payment_intents" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_board_basket_id","format"]);
}

/** /admin/job_board_baskets(.:format) */
export function adminJobBoardBasketsPath(options?: object): string {
  return "/" + "admin" + "/" + "job_board_baskets" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/job_board_baskets/new(.:format) */
export function newAdminJobBoardBasketPath(options?: object): string {
  return "/" + "admin" + "/" + "job_board_baskets" + "/" + "new" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/job_board_baskets/:id/edit(.:format) */
export function editAdminJobBoardBasketPath(id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "job_board_baskets" + "/" + id + "/" + "edit" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /admin/job_board_baskets/:id(.:format) */
export function adminJobBoardBasketPath(id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "job_board_baskets" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /admin/email_templates/fill_defaults(.:format) */
export function fillDefaultsAdminEmailTemplatesPath(options?: object): string {
  return "/" + "admin" + "/" + "email_templates" + "/" + "fill_defaults" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/email_previews/candidate_survey_mailer/survey_invitation(.:format) */
export function adminEmailPreviewsCandidateSurveyMailerSurveyInvitationPath(options?: object): string {
  return "/" + "admin" + "/" + "email_previews" + "/" + "candidate_survey_mailer" + "/" + "survey_invitation" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/email_previews/job_seeker_mailer/custom(.:format) */
export function adminEmailPreviewsJobSeekerMailerCustomPath(options?: object): string {
  return "/" + "admin" + "/" + "email_previews" + "/" + "job_seeker_mailer" + "/" + "custom" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/email_previews/job_seeker_mailer/registered_interest(.:format) */
export function adminEmailPreviewsJobSeekerMailerRegisteredInterestPath(options?: object): string {
  return "/" + "admin" + "/" + "email_previews" + "/" + "job_seeker_mailer" + "/" + "registered_interest" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/email_previews/job_seeker_mailer/talent_pipeline_consent(.:format) */
export function adminEmailPreviewsJobSeekerMailerTalentPipelineConsentPath(options?: object): string {
  return "/" + "admin" + "/" + "email_previews" + "/" + "job_seeker_mailer" + "/" + "talent_pipeline_consent" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/email_previews/job_seeker_mailer/invite_to_apply(.:format) */
export function adminEmailPreviewsJobSeekerMailerInviteToApplyPath(options?: object): string {
  return "/" + "admin" + "/" + "email_previews" + "/" + "job_seeker_mailer" + "/" + "invite_to_apply" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/email_previews/job_seeker_mailer/talent_pipeline_interview_invite(.:format) */
export function adminEmailPreviewsJobSeekerMailerTalentPipelineInterviewInvitePath(options?: object): string {
  return "/" + "admin" + "/" + "email_previews" + "/" + "job_seeker_mailer" + "/" + "talent_pipeline_interview_invite" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/email_previews/job_seeker_mailer/talent_pipeline_interview_cancel(.:format) */
export function adminEmailPreviewsJobSeekerMailerTalentPipelineInterviewCancelPath(options?: object): string {
  return "/" + "admin" + "/" + "email_previews" + "/" + "job_seeker_mailer" + "/" + "talent_pipeline_interview_cancel" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/email_previews/job_seeker_mailer/talent_pipeline_interview_confirm(.:format) */
export function adminEmailPreviewsJobSeekerMailerTalentPipelineInterviewConfirmPath(options?: object): string {
  return "/" + "admin" + "/" + "email_previews" + "/" + "job_seeker_mailer" + "/" + "talent_pipeline_interview_confirm" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/email_previews/job_seeker_mailer/rescheduled_interview_talent_pipeline(.:format) */
export function adminEmailPreviewsJobSeekerMailerRescheduledInterviewTalentPipelinePath(options?: object): string {
  return "/" + "admin" + "/" + "email_previews" + "/" + "job_seeker_mailer" + "/" + "rescheduled_interview_talent_pipeline" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/email_previews/job_seeker_mailer/talent_pipeline_reconsent(.:format) */
export function adminEmailPreviewsJobSeekerMailerTalentPipelineReconsentPath(options?: object): string {
  return "/" + "admin" + "/" + "email_previews" + "/" + "job_seeker_mailer" + "/" + "talent_pipeline_reconsent" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/email_previews/logged_application_mailer/custom(.:format) */
export function adminEmailPreviewsLoggedApplicationMailerCustomPath(options?: object): string {
  return "/" + "admin" + "/" + "email_previews" + "/" + "logged_application_mailer" + "/" + "custom" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/email_previews/logged_application_mailer/custom_onboarding(.:format) */
export function adminEmailPreviewsLoggedApplicationMailerCustomOnboardingPath(options?: object): string {
  return "/" + "admin" + "/" + "email_previews" + "/" + "logged_application_mailer" + "/" + "custom_onboarding" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/email_previews/logged_application_mailer/document_request(.:format) */
export function adminEmailPreviewsLoggedApplicationMailerDocumentRequestPath(options?: object): string {
  return "/" + "admin" + "/" + "email_previews" + "/" + "logged_application_mailer" + "/" + "document_request" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/email_previews/logged_application_mailer/duplicate_candidate(.:format) */
export function adminEmailPreviewsLoggedApplicationMailerDuplicateCandidatePath(options?: object): string {
  return "/" + "admin" + "/" + "email_previews" + "/" + "logged_application_mailer" + "/" + "duplicate_candidate" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/email_previews/logged_application_mailer/additional_information_request(.:format) */
export function adminEmailPreviewsLoggedApplicationMailerAdditionalInformationRequestPath(options?: object): string {
  return "/" + "admin" + "/" + "email_previews" + "/" + "logged_application_mailer" + "/" + "additional_information_request" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/email_previews/logged_application_mailer/additional_information_request_recruiter(.:format) */
export function adminEmailPreviewsLoggedApplicationMailerAdditionalInformationRequestRecruiterPath(options?: object): string {
  return "/" + "admin" + "/" + "email_previews" + "/" + "logged_application_mailer" + "/" + "additional_information_request_recruiter" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/email_previews/logged_application_mailer/interview_cancel(.:format) */
export function adminEmailPreviewsLoggedApplicationMailerInterviewCancelPath(options?: object): string {
  return "/" + "admin" + "/" + "email_previews" + "/" + "logged_application_mailer" + "/" + "interview_cancel" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/email_previews/logged_application_mailer/interview_cancel_recruiter(.:format) */
export function adminEmailPreviewsLoggedApplicationMailerInterviewCancelRecruiterPath(options?: object): string {
  return "/" + "admin" + "/" + "email_previews" + "/" + "logged_application_mailer" + "/" + "interview_cancel_recruiter" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/email_previews/logged_application_mailer/interview_invite(.:format) */
export function adminEmailPreviewsLoggedApplicationMailerInterviewInvitePath(options?: object): string {
  return "/" + "admin" + "/" + "email_previews" + "/" + "logged_application_mailer" + "/" + "interview_invite" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/email_previews/logged_application_mailer/interview_invite_recruiter(.:format) */
export function adminEmailPreviewsLoggedApplicationMailerInterviewInviteRecruiterPath(options?: object): string {
  return "/" + "admin" + "/" + "email_previews" + "/" + "logged_application_mailer" + "/" + "interview_invite_recruiter" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/email_previews/logged_application_mailer/rescheduled_interview_invite(.:format) */
export function adminEmailPreviewsLoggedApplicationMailerRescheduledInterviewInvitePath(options?: object): string {
  return "/" + "admin" + "/" + "email_previews" + "/" + "logged_application_mailer" + "/" + "rescheduled_interview_invite" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/email_previews/logged_application_mailer/rescheduled_interview_invite_recruiter(.:format) */
export function adminEmailPreviewsLoggedApplicationMailerRescheduledInterviewInviteRecruiterPath(options?: object): string {
  return "/" + "admin" + "/" + "email_previews" + "/" + "logged_application_mailer" + "/" + "rescheduled_interview_invite_recruiter" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/email_previews/logged_application_mailer/thanks(.:format) */
export function adminEmailPreviewsLoggedApplicationMailerThanksPath(options?: object): string {
  return "/" + "admin" + "/" + "email_previews" + "/" + "logged_application_mailer" + "/" + "thanks" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/email_previews/logged_application_mailer/interview_confirm(.:format) */
export function adminEmailPreviewsLoggedApplicationMailerInterviewConfirmPath(options?: object): string {
  return "/" + "admin" + "/" + "email_previews" + "/" + "logged_application_mailer" + "/" + "interview_confirm" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/email_previews/logged_application_mailer/interview_confirm_recruiter(.:format) */
export function adminEmailPreviewsLoggedApplicationMailerInterviewConfirmRecruiterPath(options?: object): string {
  return "/" + "admin" + "/" + "email_previews" + "/" + "logged_application_mailer" + "/" + "interview_confirm_recruiter" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/email_previews/logged_application_mailer/invite_to_talent_pipeline(.:format) */
export function adminEmailPreviewsLoggedApplicationMailerInviteToTalentPipelinePath(options?: object): string {
  return "/" + "admin" + "/" + "email_previews" + "/" + "logged_application_mailer" + "/" + "invite_to_talent_pipeline" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/email_previews/logged_application_mailer/video_interview_invite(.:format) */
export function adminEmailPreviewsLoggedApplicationMailerVideoInterviewInvitePath(options?: object): string {
  return "/" + "admin" + "/" + "email_previews" + "/" + "logged_application_mailer" + "/" + "video_interview_invite" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/email_previews/logged_application_mailer/video_interview_invite_recruiter(.:format) */
export function adminEmailPreviewsLoggedApplicationMailerVideoInterviewInviteRecruiterPath(options?: object): string {
  return "/" + "admin" + "/" + "email_previews" + "/" + "logged_application_mailer" + "/" + "video_interview_invite_recruiter" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/email_previews/logged_application_mailer/invite_to_onboarding(.:format) */
export function adminEmailPreviewsLoggedApplicationMailerInviteToOnboardingPath(options?: object): string {
  return "/" + "admin" + "/" + "email_previews" + "/" + "logged_application_mailer" + "/" + "invite_to_onboarding" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/email_previews/logged_application_mailer/reinvite_to_onboarding(.:format) */
export function adminEmailPreviewsLoggedApplicationMailerReinviteToOnboardingPath(options?: object): string {
  return "/" + "admin" + "/" + "email_previews" + "/" + "logged_application_mailer" + "/" + "reinvite_to_onboarding" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/email_previews/logged_application_mailer/offer_esignature_confirmation(.:format) */
export function adminEmailPreviewsLoggedApplicationMailerOfferEsignatureConfirmationPath(options?: object): string {
  return "/" + "admin" + "/" + "email_previews" + "/" + "logged_application_mailer" + "/" + "offer_esignature_confirmation" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/email_previews/logged_application_mailer/accepted_offer_confirmation(.:format) */
export function adminEmailPreviewsLoggedApplicationMailerAcceptedOfferConfirmationPath(options?: object): string {
  return "/" + "admin" + "/" + "email_previews" + "/" + "logged_application_mailer" + "/" + "accepted_offer_confirmation" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/email_previews/logged_application_mailer/offer_retracted(.:format) */
export function adminEmailPreviewsLoggedApplicationMailerOfferRetractedPath(options?: object): string {
  return "/" + "admin" + "/" + "email_previews" + "/" + "logged_application_mailer" + "/" + "offer_retracted" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/email_previews/logged_application_mailer/onboarding_complete(.:format) */
export function adminEmailPreviewsLoggedApplicationMailerOnboardingCompletePath(options?: object): string {
  return "/" + "admin" + "/" + "email_previews" + "/" + "logged_application_mailer" + "/" + "onboarding_complete" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/email_previews/logged_application_mailer/max_applications_rejection(.:format) */
export function adminEmailPreviewsLoggedApplicationMailerMaxApplicationsRejectionPath(options?: object): string {
  return "/" + "admin" + "/" + "email_previews" + "/" + "logged_application_mailer" + "/" + "max_applications_rejection" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/email_previews/logged_application_mailer/question_collection_invitation(.:format) */
export function adminEmailPreviewsLoggedApplicationMailerQuestionCollectionInvitationPath(options?: object): string {
  return "/" + "admin" + "/" + "email_previews" + "/" + "logged_application_mailer" + "/" + "question_collection_invitation" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/email_previews/logged_application_mailer/group_interview_invite(.:format) */
export function adminEmailPreviewsLoggedApplicationMailerGroupInterviewInvitePath(options?: object): string {
  return "/" + "admin" + "/" + "email_previews" + "/" + "logged_application_mailer" + "/" + "group_interview_invite" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/email_previews/logged_application_mailer/group_interview_invite_recruiter(.:format) */
export function adminEmailPreviewsLoggedApplicationMailerGroupInterviewInviteRecruiterPath(options?: object): string {
  return "/" + "admin" + "/" + "email_previews" + "/" + "logged_application_mailer" + "/" + "group_interview_invite_recruiter" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/email_previews/logged_application_mailer/group_interview_confirm(.:format) */
export function adminEmailPreviewsLoggedApplicationMailerGroupInterviewConfirmPath(options?: object): string {
  return "/" + "admin" + "/" + "email_previews" + "/" + "logged_application_mailer" + "/" + "group_interview_confirm" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/email_previews/logged_application_mailer/group_interview_confirm_recruiter(.:format) */
export function adminEmailPreviewsLoggedApplicationMailerGroupInterviewConfirmRecruiterPath(options?: object): string {
  return "/" + "admin" + "/" + "email_previews" + "/" + "logged_application_mailer" + "/" + "group_interview_confirm_recruiter" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/email_previews/logged_application_mailer/reference_check_request(.:format) */
export function adminEmailPreviewsLoggedApplicationMailerReferenceCheckRequestPath(options?: object): string {
  return "/" + "admin" + "/" + "email_previews" + "/" + "logged_application_mailer" + "/" + "reference_check_request" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/email_previews/logged_application_mailer/custom_application_received(.:format) */
export function adminEmailPreviewsLoggedApplicationMailerCustomApplicationReceivedPath(options?: object): string {
  return "/" + "admin" + "/" + "email_previews" + "/" + "logged_application_mailer" + "/" + "custom_application_received" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/email_previews/offer_mailer/offer_letter(.:format) */
export function adminEmailPreviewsOfferMailerOfferLetterPath(options?: object): string {
  return "/" + "admin" + "/" + "email_previews" + "/" + "offer_mailer" + "/" + "offer_letter" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/email_previews/onboarding_mailer/custom(.:format) */
export function adminEmailPreviewsOnboardingMailerCustomPath(options?: object): string {
  return "/" + "admin" + "/" + "email_previews" + "/" + "onboarding_mailer" + "/" + "custom" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/email_previews/equality_monitoring_mailer/equality_monitoring_survey(.:format) */
export function adminEmailPreviewsEqualityMonitoringMailerEqualityMonitoringSurveyPath(options?: object): string {
  return "/" + "admin" + "/" + "email_previews" + "/" + "equality_monitoring_mailer" + "/" + "equality_monitoring_survey" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/email_previews/resume_application_link_mailer/resume_application_link(.:format) */
export function adminEmailPreviewsResumeApplicationLinkMailerResumeApplicationLinkPath(options?: object): string {
  return "/" + "admin" + "/" + "email_previews" + "/" + "resume_application_link_mailer" + "/" + "resume_application_link" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/email_previews/internal_reminder_mailer/custom(.:format) */
export function adminEmailPreviewsInternalReminderMailerCustomPath(options?: object): string {
  return "/" + "admin" + "/" + "email_previews" + "/" + "internal_reminder_mailer" + "/" + "custom" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/email_previews/referee_mailer/confirm_reference(.:format) */
export function adminEmailPreviewsRefereeMailerConfirmReferencePath(options?: object): string {
  return "/" + "admin" + "/" + "email_previews" + "/" + "referee_mailer" + "/" + "confirm_reference" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/email_previews/referee_mailer/confirm_reference_reminder(.:format) */
export function adminEmailPreviewsRefereeMailerConfirmReferenceReminderPath(options?: object): string {
  return "/" + "admin" + "/" + "email_previews" + "/" + "referee_mailer" + "/" + "confirm_reference_reminder" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/jobs/:id/share(.:format) */
export function shareAdminJobPath(id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + id + "/" + "share" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /admin/jobs/:id/qrcode(.:format) */
export function qrcodeAdminJobPath(id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + id + "/" + "qrcode" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /admin/jobs/:job_id/additional_information_requests/bulk_invites(.:format) */
export function adminJobAdditionalInformationRequestsBulkInvitesPath(job_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "additional_information_requests" + "/" + "bulk_invites" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","format"]);
}

/** /admin/jobs/:job_id/adverts/:id/configure(.:format) */
export function configureAdminJobAdvertPath(job_id: ScalarType, id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "adverts" + "/" + id + "/" + "configure" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","id","format"]);
}

/** /admin/jobs/:job_id/adverts(.:format) */
export function adminJobAdvertsPath(job_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "adverts" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","format"]);
}

/** /admin/jobs/:job_id/adverts/:id/edit(.:format) */
export function editAdminJobAdvertPath(job_id: ScalarType, id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "adverts" + "/" + id + "/" + "edit" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","id","format"]);
}

/** /admin/jobs/:job_id/adverts/:id(.:format) */
export function adminJobAdvertPath(job_id: ScalarType, id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "adverts" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","id","format"]);
}

/** /admin/jobs/:job_id/insights(.:format) */
export function adminJobInsightsPath(job_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "insights" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","format"]);
}

/** /admin/jobs/:job_id/team(.:format) */
export function adminJobTeamPath(job_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "team" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","format"]);
}

/** /admin/jobs/:job_id/linked_in_postings(.:format) */
export function adminJobLinkedInPostingsPath(job_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "linked_in_postings" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","format"]);
}

/** /admin/jobs/:job_id/job_boards(.:format) */
export function adminJobJobBoardsPath(job_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "job_boards" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","format"]);
}

/** /admin/jobs/:job_id/job_boards/vonq/industries(.:format) */
export function adminJobJobBoardsVonqIndustriesPath(job_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "job_boards" + "/" + "vonq" + "/" + "industries" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","format"]);
}

/** /admin/jobs/:job_id/job_boards/vonq/job_functions(.:format) */
export function adminJobJobBoardsVonqJobFunctionsPath(job_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "job_boards" + "/" + "vonq" + "/" + "job_functions" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","format"]);
}

/** /admin/jobs/:job_id/job_boards/vonq/locations(.:format) */
export function adminJobJobBoardsVonqLocationsPath(job_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "job_boards" + "/" + "vonq" + "/" + "locations" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","format"]);
}

/** /admin/jobs/:job_id/job_board_postings/naukri_posting/new(.:format) */
export function newAdminJobJobBoardPostingsNaukriPostingPath(job_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "job_board_postings" + "/" + "naukri_posting" + "/" + "new" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","format"]);
}

/** /admin/jobs/:job_id/job_board_postings/naukri_posting/edit(.:format) */
export function editAdminJobJobBoardPostingsNaukriPostingPath(job_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "job_board_postings" + "/" + "naukri_posting" + "/" + "edit" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","format"]);
}

/** /admin/jobs/:job_id/job_board_postings/naukri/functional_areas(.:format) */
export function adminJobJobBoardPostingsNaukriFunctionalAreasPath(job_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "job_board_postings" + "/" + "naukri" + "/" + "functional_areas" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","format"]);
}

/** /admin/jobs/:job_id/job_board_postings/naukri/industries(.:format) */
export function adminJobJobBoardPostingsNaukriIndustriesPath(job_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "job_board_postings" + "/" + "naukri" + "/" + "industries" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","format"]);
}

/** /admin/jobs/:job_id/job_board_postings/naukri/international_locations(.:format) */
export function adminJobJobBoardPostingsNaukriInternationalLocationsPath(job_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "job_board_postings" + "/" + "naukri" + "/" + "international_locations" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","format"]);
}

/** /admin/jobs/:job_id/job_board_postings/naukri/national_locations(.:format) */
export function adminJobJobBoardPostingsNaukriNationalLocationsPath(job_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "job_board_postings" + "/" + "naukri" + "/" + "national_locations" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","format"]);
}

/** /admin/jobs/:job_id/job_board_postings/naukri/workmodes(.:format) */
export function adminJobJobBoardPostingsNaukriWorkmodesPath(job_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "job_board_postings" + "/" + "naukri" + "/" + "workmodes" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","format"]);
}

/** /admin/jobs/:job_id/job_board_postings/nhs_jobs_posting/new(.:format) */
export function newAdminJobJobBoardPostingsNhsJobsPostingPath(job_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "job_board_postings" + "/" + "nhs_jobs_posting" + "/" + "new" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","format"]);
}

/** /admin/jobs/:job_id/job_board_postings/nhs_jobs_posting/edit(.:format) */
export function editAdminJobJobBoardPostingsNhsJobsPostingPath(job_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "job_board_postings" + "/" + "nhs_jobs_posting" + "/" + "edit" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","format"]);
}

/** /admin/jobs/:job_id/job_board_postings/nhs_jobs/fields(.:format) */
export function adminJobJobBoardPostingsNhsJobsFieldsPath(job_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "job_board_postings" + "/" + "nhs_jobs" + "/" + "fields" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","format"]);
}

/** /admin/jobs/:job_id/job_postings(.:format) */
export function adminJobJobPostingsPath(job_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "job_postings" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","format"]);
}

/** /admin/jobs/:job_id/positions(.:format) */
export function adminJobPositionsPath(job_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "positions" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","format"]);
}

/** /admin/jobs/:job_id/facebook_campaigns/:facebook_campaign_id/facebook_adsets(.:format) */
export function adminJobFacebookCampaignFacebookAdsetsPath(job_id: ScalarType, facebook_campaign_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "facebook_campaigns" + "/" + facebook_campaign_id + "/" + "facebook_adsets" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","facebook_campaign_id","format"]);
}

/** /admin/jobs/:job_id/facebook_campaigns/:facebook_campaign_id/facebook_adsets/new(.:format) */
export function newAdminJobFacebookCampaignFacebookAdsetPath(job_id: ScalarType, facebook_campaign_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "facebook_campaigns" + "/" + facebook_campaign_id + "/" + "facebook_adsets" + "/" + "new" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","facebook_campaign_id","format"]);
}

/** /admin/jobs/:job_id/facebook_campaigns(.:format) */
export function adminJobFacebookCampaignsPath(job_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "facebook_campaigns" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","format"]);
}

/** /admin/jobs/:job_id/facebook_campaigns/:id(.:format) */
export function adminJobFacebookCampaignPath(job_id: ScalarType, id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "facebook_campaigns" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","id","format"]);
}

/** /admin/jobs/:job_id/facebook_adsets/:facebook_adset_id/facebook_adverts/new(.:format) */
export function newAdminJobFacebookAdsetFacebookAdvertPath(job_id: ScalarType, facebook_adset_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "facebook_adsets" + "/" + facebook_adset_id + "/" + "facebook_adverts" + "/" + "new" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","facebook_adset_id","format"]);
}

/** /admin/jobs/:job_id/facebook_adsets/:id/edit(.:format) */
export function editAdminJobFacebookAdsetPath(job_id: ScalarType, id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "facebook_adsets" + "/" + id + "/" + "edit" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","id","format"]);
}

/** /admin/jobs/:job_id/facebook_adsets/:id(.:format) */
export function adminJobFacebookAdsetPath(job_id: ScalarType, id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "facebook_adsets" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","id","format"]);
}

/** /admin/jobs/:job_id/facebook_adverts/:facebook_advert_id/creatives(.:format) */
export function adminJobFacebookAdvertCreativesPath(job_id: ScalarType, facebook_advert_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "facebook_adverts" + "/" + facebook_advert_id + "/" + "creatives" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","facebook_advert_id","format"]);
}

/** /admin/jobs/:job_id/facebook_adverts/:facebook_advert_id/preview(.:format) */
export function adminJobFacebookAdvertPreviewPath(job_id: ScalarType, facebook_advert_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "facebook_adverts" + "/" + facebook_advert_id + "/" + "preview" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","facebook_advert_id","format"]);
}

/** /admin/jobs/:job_id/facebook_adverts/:facebook_advert_id/statuses(.:format) */
export function adminJobFacebookAdvertStatusesPath(job_id: ScalarType, facebook_advert_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "facebook_adverts" + "/" + facebook_advert_id + "/" + "statuses" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","facebook_advert_id","format"]);
}

/** /admin/jobs/:job_id/facebook_adverts/:id/edit(.:format) */
export function editAdminJobFacebookAdvertPath(job_id: ScalarType, id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "facebook_adverts" + "/" + id + "/" + "edit" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","id","format"]);
}

/** /admin/jobs/:job_id/facebook_adverts/:id(.:format) */
export function adminJobFacebookAdvertPath(job_id: ScalarType, id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "facebook_adverts" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","id","format"]);
}

/** /admin/jobs/:job_id/integrations(.:format) */
export function adminJobIntegrationsPath(job_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "integrations" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","format"]);
}

/** /admin/jobs/:job_id/interviews(.:format) */
export function adminJobInterviewsPath(job_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "interviews" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","format"]);
}

/** /admin/jobs/:job_id/group_interviews/:group_interview_id/candidates(.:format) */
export function adminJobGroupInterviewCandidatesPath(job_id: ScalarType, group_interview_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "group_interviews" + "/" + group_interview_id + "/" + "candidates" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","group_interview_id","format"]);
}

/** /admin/jobs/:job_id/group_interviews/:group_interview_id/sessions(.:format) */
export function adminJobGroupInterviewSessionsPath(job_id: ScalarType, group_interview_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "group_interviews" + "/" + group_interview_id + "/" + "sessions" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","group_interview_id","format"]);
}

/** /admin/jobs/:job_id/group_interviews(.:format) */
export function adminJobGroupInterviewsPath(job_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "group_interviews" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","format"]);
}

/** /admin/jobs/:job_id/group_interviews/:id(.:format) */
export function adminJobGroupInterviewPath(job_id: ScalarType, id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "group_interviews" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","id","format"]);
}

/** /admin/jobs/:job_id/integrations/seek_posting/new(.:format) */
export function newAdminJobIntegrationsSeekPostingPath(job_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "integrations" + "/" + "seek_posting" + "/" + "new" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","format"]);
}

/** /admin/jobs/:job_id/integrations/seek_posting/edit(.:format) */
export function editAdminJobIntegrationsSeekPostingPath(job_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "integrations" + "/" + "seek_posting" + "/" + "edit" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","format"]);
}

/** /admin/jobs/:job_id/integrations/reed_posting/new(.:format) */
export function newAdminJobIntegrationsReedPostingPath(job_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "integrations" + "/" + "reed_posting" + "/" + "new" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","format"]);
}

/** /admin/jobs/:job_id/integrations/reed_posting/edit(.:format) */
export function editAdminJobIntegrationsReedPostingPath(job_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "integrations" + "/" + "reed_posting" + "/" + "edit" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","format"]);
}

/** /admin/jobs/:job_id/integrations/total_jobs_posting/new(.:format) */
export function newAdminJobIntegrationsTotalJobsPostingPath(job_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "integrations" + "/" + "total_jobs_posting" + "/" + "new" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","format"]);
}

/** /admin/jobs/:job_id/integrations/total_jobs_posting/edit(.:format) */
export function editAdminJobIntegrationsTotalJobsPostingPath(job_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "integrations" + "/" + "total_jobs_posting" + "/" + "edit" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","format"]);
}

/** /admin/jobs/:job_id/integrations/cv_library_posting/new(.:format) */
export function newAdminJobIntegrationsCvLibraryPostingPath(job_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "integrations" + "/" + "cv_library_posting" + "/" + "new" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","format"]);
}

/** /admin/jobs/:job_id/integrations/cv_library_posting/edit(.:format) */
export function editAdminJobIntegrationsCvLibraryPostingPath(job_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "integrations" + "/" + "cv_library_posting" + "/" + "edit" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","format"]);
}

/** /admin/jobs/:job_id/integrations/seek/brandings(.:format) */
export function adminJobIntegrationsSeekBrandingsPath(job_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "integrations" + "/" + "seek" + "/" + "brandings" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","format"]);
}

/** /admin/jobs/:job_id/integrations/seek/locations(.:format) */
export function adminJobIntegrationsSeekLocationsPath(job_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "integrations" + "/" + "seek" + "/" + "locations" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","format"]);
}

/** /admin/jobs/:job_id/integrations/seek/job_categories(.:format) */
export function adminJobIntegrationsSeekJobCategoriesPath(job_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "integrations" + "/" + "seek" + "/" + "job_categories" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","format"]);
}

/** /admin/jobs/:job_id/integrations/seek/currencies(.:format) */
export function adminJobIntegrationsSeekCurrenciesPath(job_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "integrations" + "/" + "seek" + "/" + "currencies" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","format"]);
}

/** /admin/jobs/:job_id/integrations/interns_programme/jobs(.:format) */
export function adminJobIntegrationsInternsProgrammeJobsPath(job_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "integrations" + "/" + "interns_programme" + "/" + "jobs" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","format"]);
}

/** /admin/jobs/:job_id/bulk_application_template(.:format) */
export function adminJobBulkApplicationTemplateIndexPath(job_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "bulk_application_template" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","format"]);
}

/** /admin/jobs/:job_id/applications/custom_emails(.:format) */
export function adminJobApplicationsCustomEmailsPath(job_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "applications" + "/" + "custom_emails" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","format"]);
}

/** /admin/jobs/:job_id/applications/downloads(.:format) */
export function adminJobApplicationsDownloadsPath(job_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "applications" + "/" + "downloads" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","format"]);
}

/** /admin/jobs/:job_id/applications/job_seekers/bulk_invite(.:format) */
export function bulkInviteAdminJobApplicationsJobSeekersPath(job_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "applications" + "/" + "job_seekers" + "/" + "bulk_invite" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","format"]);
}

/** /admin/jobs/:job_id/applications/job_seekers/bulk_add(.:format) */
export function bulkAddAdminJobApplicationsJobSeekersPath(job_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "applications" + "/" + "job_seekers" + "/" + "bulk_add" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","format"]);
}

/** /admin/jobs/:job_id/applications/talent_pools/job_seekers/bulk_invite(.:format) */
export function bulkInviteAdminJobApplicationsTalentPoolsJobSeekersPath(job_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "applications" + "/" + "talent_pools" + "/" + "job_seekers" + "/" + "bulk_invite" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","format"]);
}

/** /admin/jobs/:job_id/applications/talent_pools/job_seekers/bulk_add(.:format) */
export function bulkAddAdminJobApplicationsTalentPoolsJobSeekersPath(job_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "applications" + "/" + "talent_pools" + "/" + "job_seekers" + "/" + "bulk_add" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","format"]);
}

/** /admin/jobs/:job_id/applications/bulk_import(.:format) */
export function bulkImportAdminJobApplicationsPath(job_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "applications" + "/" + "bulk_import" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","format"]);
}

/** /admin/jobs/:job_id/applications/bulk_import_cv(.:format) */
export function bulkImportCvAdminJobApplicationsPath(job_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "applications" + "/" + "bulk_import_cv" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","format"]);
}

/** /admin/jobs/:job_id/applications/bulk_pool(.:format) */
export function bulkPoolAdminJobApplicationsPath(job_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "applications" + "/" + "bulk_pool" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","format"]);
}

/** /admin/jobs/:job_id/applications/bulk_update(.:format) */
export function bulkUpdateAdminJobApplicationsPath(job_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "applications" + "/" + "bulk_update" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","format"]);
}

/** /admin/jobs/:job_id/applications/bulk_send_onboarding(.:format) */
export function bulkSendOnboardingAdminJobApplicationsPath(job_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "applications" + "/" + "bulk_send_onboarding" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","format"]);
}

/** /admin/jobs/:job_id/applications/lanes(.:format) */
export function lanesAdminJobApplicationsPath(job_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "applications" + "/" + "lanes" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","format"]);
}

/** /admin/jobs/:job_id/applications/:application_id/background_checks(.:format) */
export function adminJobApplicationBackgroundChecksPath(job_id: ScalarType, application_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "applications" + "/" + application_id + "/" + "background_checks" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","application_id","format"]);
}

/** /admin/jobs/:job_id/applications/:application_id/comments(.:format) */
export function adminJobApplicationCommentsPath(job_id: ScalarType, application_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "applications" + "/" + application_id + "/" + "comments" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","application_id","format"]);
}

/** /admin/jobs/:job_id/applications/:application_id/cv(.:format) */
export function adminJobApplicationCvPath(job_id: ScalarType, application_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "applications" + "/" + application_id + "/" + "cv" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","application_id","format"]);
}

/** /admin/jobs/:job_id/applications/:application_id/documents(.:format) */
export function adminJobApplicationDocumentsPath(job_id: ScalarType, application_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "applications" + "/" + application_id + "/" + "documents" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","application_id","format"]);
}

/** /admin/jobs/:job_id/applications/:application_id/candidate_assessments(.:format) */
export function adminJobApplicationCandidateAssessmentsPath(job_id: ScalarType, application_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "applications" + "/" + application_id + "/" + "candidate_assessments" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","application_id","format"]);
}

/** /admin/jobs/:job_id/applications/:application_id/reference_check_submissions(.:format) */
export function adminJobApplicationReferenceCheckSubmissionsPath(job_id: ScalarType, application_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "applications" + "/" + application_id + "/" + "reference_check_submissions" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","application_id","format"]);
}

/** /admin/jobs/:job_id/applications/:application_id/document_requests(.:format) */
export function adminJobApplicationDocumentRequestsPath(job_id: ScalarType, application_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "applications" + "/" + application_id + "/" + "document_requests" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","application_id","format"]);
}

/** /admin/jobs/:job_id/applications/:application_id/duplicates(.:format) */
export function adminJobApplicationDuplicatesPath(job_id: ScalarType, application_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "applications" + "/" + application_id + "/" + "duplicates" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","application_id","format"]);
}

/** /admin/jobs/:job_id/applications/:application_id/history(.:format) */
export function adminJobApplicationHistoryPath(job_id: ScalarType, application_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "applications" + "/" + application_id + "/" + "history" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","application_id","format"]);
}

/** /admin/jobs/:job_id/applications/:application_id/interviews(.:format) */
export function adminJobApplicationInterviewsPath(job_id: ScalarType, application_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "applications" + "/" + application_id + "/" + "interviews" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","application_id","format"]);
}

/** /admin/jobs/:job_id/applications/:application_id/messages(.:format) */
export function adminJobApplicationMessagesPath(job_id: ScalarType, application_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "applications" + "/" + application_id + "/" + "messages" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","application_id","format"]);
}

/** /admin/jobs/:job_id/applications/:application_id/moves(.:format) */
export function adminJobApplicationMovesPath(job_id: ScalarType, application_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "applications" + "/" + application_id + "/" + "moves" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","application_id","format"]);
}

/** /admin/jobs/:job_id/applications/:application_id/offers/previews/docx(.:format) */
export function docxAdminJobApplicationOffersPreviewsPath(job_id: ScalarType, application_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "applications" + "/" + application_id + "/" + "offers" + "/" + "previews" + "/" + "docx" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","application_id","format"]);
}

/** /admin/jobs/:job_id/applications/:application_id/offers/previews/pdf(.:format) */
export function pdfAdminJobApplicationOffersPreviewsPath(job_id: ScalarType, application_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "applications" + "/" + application_id + "/" + "offers" + "/" + "previews" + "/" + "pdf" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","application_id","format"]);
}

/** /admin/jobs/:job_id/applications/:application_id/offers/:offer_id/sign_off/request_approval_emails(.:format) */
export function adminJobApplicationOfferSignOffRequestApprovalEmailsPath(job_id: ScalarType, application_id: ScalarType, offer_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "applications" + "/" + application_id + "/" + "offers" + "/" + offer_id + "/" + "sign_off" + "/" + "request_approval_emails" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","application_id","offer_id","format"]);
}

/** /admin/jobs/:job_id/applications/:application_id/offers(.:format) */
export function adminJobApplicationOffersPath(job_id: ScalarType, application_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "applications" + "/" + application_id + "/" + "offers" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","application_id","format"]);
}

/** /admin/jobs/:job_id/applications/:application_id/offers/:id(.:format) */
export function adminJobApplicationOfferPath(job_id: ScalarType, application_id: ScalarType, id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "applications" + "/" + application_id + "/" + "offers" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","application_id","id","format"]);
}

/** /admin/jobs/:job_id/applications/:application_id/other_applications(.:format) */
export function adminJobApplicationOtherApplicationsPath(job_id: ScalarType, application_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "applications" + "/" + application_id + "/" + "other_applications" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","application_id","format"]);
}

/** /admin/jobs/:job_id/applications/:application_id/resume(.:format) */
export function adminJobApplicationResumePath(job_id: ScalarType, application_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "applications" + "/" + application_id + "/" + "resume" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","application_id","format"]);
}

/** /admin/jobs/:job_id/applications/:application_id/cover_letter(.:format) */
export function adminJobApplicationCoverLetterPath(job_id: ScalarType, application_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "applications" + "/" + application_id + "/" + "cover_letter" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","application_id","format"]);
}

/** /admin/jobs/:job_id/applications/:application_id/onboarding(.:format) */
export function adminJobApplicationOnboardingPath(job_id: ScalarType, application_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "applications" + "/" + application_id + "/" + "onboarding" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","application_id","format"]);
}

/** /admin/jobs/:job_id/applications/:application_id/peoplehr/employees(.:format) */
export function adminJobApplicationPeoplehrEmployeesPath(job_id: ScalarType, application_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "applications" + "/" + application_id + "/" + "peoplehr" + "/" + "employees" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","application_id","format"]);
}

/** /admin/jobs/:job_id/applications/:application_id/adp_workforce_now_api_central/employees(.:format) */
export function adminJobApplicationAdpWorkforceNowApiCentralEmployeesPath(job_id: ScalarType, application_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "applications" + "/" + application_id + "/" + "adp_workforce_now_api_central" + "/" + "employees" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","application_id","format"]);
}

/** /admin/jobs/:job_id/applications/:application_id/alva_labs/assessments(.:format) */
export function adminJobApplicationAlvaLabsAssessmentsPath(job_id: ScalarType, application_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "applications" + "/" + application_id + "/" + "alva_labs" + "/" + "assessments" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","application_id","format"]);
}

/** /admin/jobs/:job_id/applications/:application_id/bamboohr/employees(.:format) */
export function adminJobApplicationBamboohrEmployeesPath(job_id: ScalarType, application_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "applications" + "/" + application_id + "/" + "bamboohr" + "/" + "employees" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","application_id","format"]);
}

/** /admin/jobs/:job_id/applications/:application_id/bamboohr/employees/:id(.:format) */
export function adminJobApplicationBamboohrEmployeePath(job_id: ScalarType, application_id: ScalarType, id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "applications" + "/" + application_id + "/" + "bamboohr" + "/" + "employees" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","application_id","id","format"]);
}

/** /admin/jobs/:job_id/applications/:application_id/bamboohr/employee_directories(.:format) */
export function adminJobApplicationBamboohrEmployeeDirectoriesPath(job_id: ScalarType, application_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "applications" + "/" + application_id + "/" + "bamboohr" + "/" + "employee_directories" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","application_id","format"]);
}

/** /admin/jobs/:job_id/applications/:application_id/bamboohr/fields(.:format) */
export function adminJobApplicationBamboohrFieldsPath(job_id: ScalarType, application_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "applications" + "/" + application_id + "/" + "bamboohr" + "/" + "fields" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","application_id","format"]);
}

/** /admin/jobs/:job_id/applications/:application_id/bizimply/employees(.:format) */
export function adminJobApplicationBizimplyEmployeesPath(job_id: ScalarType, application_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "applications" + "/" + application_id + "/" + "bizimply" + "/" + "employees" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","application_id","format"]);
}

/** /admin/jobs/:job_id/applications/:application_id/bizimply/locations(.:format) */
export function adminJobApplicationBizimplyLocationsPath(job_id: ScalarType, application_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "applications" + "/" + application_id + "/" + "bizimply" + "/" + "locations" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","application_id","format"]);
}

/** /admin/jobs/:job_id/applications/:application_id/bizimply/positions(.:format) */
export function adminJobApplicationBizimplyPositionsPath(job_id: ScalarType, application_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "applications" + "/" + application_id + "/" + "bizimply" + "/" + "positions" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","application_id","format"]);
}

/** /admin/jobs/:job_id/applications/:application_id/bizimply/schedules(.:format) */
export function adminJobApplicationBizimplySchedulesPath(job_id: ScalarType, application_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "applications" + "/" + application_id + "/" + "bizimply" + "/" + "schedules" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","application_id","format"]);
}

/** /admin/jobs/:job_id/applications/:application_id/bob/employees(.:format) */
export function adminJobApplicationBobEmployeesPath(job_id: ScalarType, application_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "applications" + "/" + application_id + "/" + "bob" + "/" + "employees" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","application_id","format"]);
}

/** /admin/jobs/:job_id/applications/:application_id/breathe/employees(.:format) */
export function adminJobApplicationBreatheEmployeesPath(job_id: ScalarType, application_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "applications" + "/" + application_id + "/" + "breathe" + "/" + "employees" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","application_id","format"]);
}

/** /admin/jobs/:job_id/applications/:application_id/bryq/assessments(.:format) */
export function adminJobApplicationBryqAssessmentsPath(job_id: ScalarType, application_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "applications" + "/" + application_id + "/" + "bryq" + "/" + "assessments" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","application_id","format"]);
}

/** /admin/jobs/:job_id/applications/:application_id/bryq/available_assessments(.:format) */
export function adminJobApplicationBryqAvailableAssessmentsPath(job_id: ScalarType, application_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "applications" + "/" + application_id + "/" + "bryq" + "/" + "available_assessments" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","application_id","format"]);
}

/** /admin/jobs/:job_id/applications/:application_id/canditech/assessments(.:format) */
export function adminJobApplicationCanditechAssessmentsPath(job_id: ScalarType, application_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "applications" + "/" + application_id + "/" + "canditech" + "/" + "assessments" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","application_id","format"]);
}

/** /admin/jobs/:job_id/applications/:application_id/canditech/fields(.:format) */
export function adminJobApplicationCanditechFieldsPath(job_id: ScalarType, application_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "applications" + "/" + application_id + "/" + "canditech" + "/" + "fields" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","application_id","format"]);
}

/** /admin/jobs/:job_id/applications/:application_id/cappfinity/assessments(.:format) */
export function adminJobApplicationCappfinityAssessmentsPath(job_id: ScalarType, application_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "applications" + "/" + application_id + "/" + "cappfinity" + "/" + "assessments" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","application_id","format"]);
}

/** /admin/jobs/:job_id/applications/:application_id/certn/employees(.:format) */
export function adminJobApplicationCertnEmployeesPath(job_id: ScalarType, application_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "applications" + "/" + application_id + "/" + "certn" + "/" + "employees" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","application_id","format"]);
}

/** /admin/jobs/:job_id/applications/:application_id/checkr/background_checks(.:format) */
export function adminJobApplicationCheckrBackgroundChecksPath(job_id: ScalarType, application_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "applications" + "/" + application_id + "/" + "checkr" + "/" + "background_checks" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","application_id","format"]);
}

/** /admin/jobs/:job_id/applications/:application_id/checkr/nodes(.:format) */
export function adminJobApplicationCheckrNodesPath(job_id: ScalarType, application_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "applications" + "/" + application_id + "/" + "checkr" + "/" + "nodes" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","application_id","format"]);
}

/** /admin/jobs/:job_id/applications/:application_id/checkr/packages(.:format) */
export function adminJobApplicationCheckrPackagesPath(job_id: ScalarType, application_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "applications" + "/" + application_id + "/" + "checkr" + "/" + "packages" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","application_id","format"]);
}

/** /admin/jobs/:job_id/applications/:application_id/care_planner/employees(.:format) */
export function adminJobApplicationCarePlannerEmployeesPath(job_id: ScalarType, application_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "applications" + "/" + application_id + "/" + "care_planner" + "/" + "employees" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","application_id","format"]);
}

/** /admin/jobs/:job_id/applications/:application_id/cascade/employees(.:format) */
export function adminJobApplicationCascadeEmployeesPath(job_id: ScalarType, application_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "applications" + "/" + application_id + "/" + "cascade" + "/" + "employees" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","application_id","format"]);
}

/** /admin/jobs/:job_id/applications/:application_id/cezanne/employees(.:format) */
export function adminJobApplicationCezanneEmployeesPath(job_id: ScalarType, application_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "applications" + "/" + application_id + "/" + "cezanne" + "/" + "employees" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","application_id","format"]);
}

/** /admin/jobs/:job_id/applications/:application_id/cezanne/fields(.:format) */
export function adminJobApplicationCezanneFieldsPath(job_id: ScalarType, application_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "applications" + "/" + application_id + "/" + "cezanne" + "/" + "fields" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","application_id","format"]);
}

/** /admin/jobs/:job_id/applications/:application_id/cintra/employees(.:format) */
export function adminJobApplicationCintraEmployeesPath(job_id: ScalarType, application_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "applications" + "/" + application_id + "/" + "cintra" + "/" + "employees" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","application_id","format"]);
}

/** /admin/jobs/:job_id/applications/:application_id/cintra/employers(.:format) */
export function adminJobApplicationCintraEmployersPath(job_id: ScalarType, application_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "applications" + "/" + application_id + "/" + "cintra" + "/" + "employers" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","application_id","format"]);
}

/** /admin/jobs/:job_id/applications/:application_id/codility/assessments(.:format) */
export function adminJobApplicationCodilityAssessmentsPath(job_id: ScalarType, application_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "applications" + "/" + application_id + "/" + "codility" + "/" + "assessments" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","application_id","format"]);
}

/** /admin/jobs/:job_id/applications/:application_id/compas/employees(.:format) */
export function adminJobApplicationCompasEmployeesPath(job_id: ScalarType, application_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "applications" + "/" + application_id + "/" + "compas" + "/" + "employees" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","application_id","format"]);
}

/** /admin/jobs/:job_id/applications/:application_id/compas/fields(.:format) */
export function adminJobApplicationCompasFieldsPath(job_id: ScalarType, application_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "applications" + "/" + application_id + "/" + "compas" + "/" + "fields" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","application_id","format"]);
}

/** /admin/jobs/:job_id/applications/:application_id/criteria/assessments(.:format) */
export function adminJobApplicationCriteriaAssessmentsPath(job_id: ScalarType, application_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "applications" + "/" + application_id + "/" + "criteria" + "/" + "assessments" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","application_id","format"]);
}

/** /admin/jobs/:job_id/applications/:application_id/deel/candidates(.:format) */
export function adminJobApplicationDeelCandidatesPath(job_id: ScalarType, application_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "applications" + "/" + application_id + "/" + "deel" + "/" + "candidates" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","application_id","format"]);
}

/** /admin/jobs/:job_id/applications/:application_id/docu_sign/envelopes/bulk_update(.:format) */
export function bulkUpdateAdminJobApplicationDocuSignEnvelopesPath(job_id: ScalarType, application_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "applications" + "/" + application_id + "/" + "docu_sign" + "/" + "envelopes" + "/" + "bulk_update" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","application_id","format"]);
}

/** /admin/jobs/:job_id/applications/:application_id/docu_sign/envelopes(.:format) */
export function adminJobApplicationDocuSignEnvelopesPath(job_id: ScalarType, application_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "applications" + "/" + application_id + "/" + "docu_sign" + "/" + "envelopes" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","application_id","format"]);
}

/** /admin/jobs/:job_id/applications/:application_id/docu_sign/envelopes/:id(.:format) */
export function adminJobApplicationDocuSignEnvelopePath(job_id: ScalarType, application_id: ScalarType, id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "applications" + "/" + application_id + "/" + "docu_sign" + "/" + "envelopes" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","application_id","id","format"]);
}

/** /admin/jobs/:job_id/applications/:application_id/first_advantage/background_checks(.:format) */
export function adminJobApplicationFirstAdvantageBackgroundChecksPath(job_id: ScalarType, application_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "applications" + "/" + application_id + "/" + "first_advantage" + "/" + "background_checks" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","application_id","format"]);
}

/** /admin/jobs/:job_id/applications/:application_id/first_advantage_kyp/background_checks(.:format) */
export function adminJobApplicationFirstAdvantageKypBackgroundChecksPath(job_id: ScalarType, application_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "applications" + "/" + application_id + "/" + "first_advantage_kyp" + "/" + "background_checks" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","application_id","format"]);
}

/** /admin/jobs/:job_id/applications/:application_id/first_advantage_kyp/fields(.:format) */
export function adminJobApplicationFirstAdvantageKypFieldsPath(job_id: ScalarType, application_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "applications" + "/" + application_id + "/" + "first_advantage_kyp" + "/" + "fields" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","application_id","format"]);
}

/** /admin/jobs/:job_id/applications/:application_id/gusto/employees(.:format) */
export function adminJobApplicationGustoEmployeesPath(job_id: ScalarType, application_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "applications" + "/" + application_id + "/" + "gusto" + "/" + "employees" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","application_id","format"]);
}

/** /admin/jobs/:job_id/applications/:application_id/gusto/locations(.:format) */
export function adminJobApplicationGustoLocationsPath(job_id: ScalarType, application_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "applications" + "/" + application_id + "/" + "gusto" + "/" + "locations" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","application_id","format"]);
}

/** /admin/jobs/:job_id/applications/:application_id/itrent/employees(.:format) */
export function adminJobApplicationItrentEmployeesPath(job_id: ScalarType, application_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "applications" + "/" + application_id + "/" + "itrent" + "/" + "employees" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","application_id","format"]);
}

/** /admin/jobs/:job_id/applications/:application_id/itrent/fields(.:format) */
export function adminJobApplicationItrentFieldsPath(job_id: ScalarType, application_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "applications" + "/" + application_id + "/" + "itrent" + "/" + "fields" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","application_id","format"]);
}

/** /admin/jobs/:job_id/applications/:application_id/ucheck/background_checks(.:format) */
export function adminJobApplicationUcheckBackgroundChecksPath(job_id: ScalarType, application_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "applications" + "/" + application_id + "/" + "ucheck" + "/" + "background_checks" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","application_id","format"]);
}

/** /admin/jobs/:job_id/applications/:application_id/workday/employees(.:format) */
export function adminJobApplicationWorkdayEmployeesPath(job_id: ScalarType, application_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "applications" + "/" + application_id + "/" + "workday" + "/" + "employees" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","application_id","format"]);
}

/** /admin/jobs/:job_id/applications/:application_id/workday/rescind_or_cancel_hires(.:format) */
export function adminJobApplicationWorkdayRescindOrCancelHiresPath(job_id: ScalarType, application_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "applications" + "/" + application_id + "/" + "workday" + "/" + "rescind_or_cancel_hires" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","application_id","format"]);
}

/** /admin/jobs/:job_id/applications/:application_id/humaans/employees(.:format) */
export function adminJobApplicationHumaansEmployeesPath(job_id: ScalarType, application_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "applications" + "/" + application_id + "/" + "humaans" + "/" + "employees" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","application_id","format"]);
}

/** /admin/jobs/:job_id/applications/:application_id/humaans/fields(.:format) */
export function adminJobApplicationHumaansFieldsPath(job_id: ScalarType, application_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "applications" + "/" + application_id + "/" + "humaans" + "/" + "fields" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","application_id","format"]);
}

/** /admin/jobs/:job_id/applications/:application_id/hire_right/background_checks/generate_check_result_url(.:format) */
export function generateCheckResultUrlAdminJobApplicationHireRightBackgroundChecksPath(job_id: ScalarType, application_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "applications" + "/" + application_id + "/" + "hire_right" + "/" + "background_checks" + "/" + "generate_check_result_url" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","application_id","format"]);
}

/** /admin/jobs/:job_id/applications/:application_id/hire_right/background_checks(.:format) */
export function adminJobApplicationHireRightBackgroundChecksPath(job_id: ScalarType, application_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "applications" + "/" + application_id + "/" + "hire_right" + "/" + "background_checks" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","application_id","format"]);
}

/** /admin/jobs/:job_id/applications/:application_id/oracle/employees/line_manager_assignment(.:format) */
export function lineManagerAssignmentAdminJobApplicationOracleEmployeesPath(job_id: ScalarType, application_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "applications" + "/" + application_id + "/" + "oracle" + "/" + "employees" + "/" + "line_manager_assignment" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","application_id","format"]);
}

/** /admin/jobs/:job_id/applications/:application_id/oracle/employees(.:format) */
export function adminJobApplicationOracleEmployeesPath(job_id: ScalarType, application_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "applications" + "/" + application_id + "/" + "oracle" + "/" + "employees" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","application_id","format"]);
}

/** /admin/jobs/:job_id/applications/:application_id/outmatch/assessments(.:format) */
export function adminJobApplicationOutmatchAssessmentsPath(job_id: ScalarType, application_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "applications" + "/" + application_id + "/" + "outmatch" + "/" + "assessments" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","application_id","format"]);
}

/** /admin/jobs/:job_id/applications/:application_id/creative_services_inc/background_checks(.:format) */
export function adminJobApplicationCreativeServicesIncBackgroundChecksPath(job_id: ScalarType, application_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "applications" + "/" + application_id + "/" + "creative_services_inc" + "/" + "background_checks" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","application_id","format"]);
}

/** /admin/jobs/:job_id/applications/:application_id/hacker_rank/assessments(.:format) */
export function adminJobApplicationHackerRankAssessmentsPath(job_id: ScalarType, application_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "applications" + "/" + application_id + "/" + "hacker_rank" + "/" + "assessments" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","application_id","format"]);
}

/** /admin/jobs/:job_id/applications/:application_id/intellihr/employees(.:format) */
export function adminJobApplicationIntellihrEmployeesPath(job_id: ScalarType, application_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "applications" + "/" + application_id + "/" + "intellihr" + "/" + "employees" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","application_id","format"]);
}

/** /admin/jobs/:job_id/applications/:application_id/intellihr/custom_fields(.:format) */
export function adminJobApplicationIntellihrCustomFieldsPath(job_id: ScalarType, application_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "applications" + "/" + application_id + "/" + "intellihr" + "/" + "custom_fields" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","application_id","format"]);
}

/** /admin/jobs/:job_id/applications/:application_id/intellihr/fields(.:format) */
export function adminJobApplicationIntellihrFieldsPath(job_id: ScalarType, application_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "applications" + "/" + application_id + "/" + "intellihr" + "/" + "fields" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","application_id","format"]);
}

/** /admin/jobs/:job_id/applications/:application_id/predictive_index/assessments(.:format) */
export function adminJobApplicationPredictiveIndexAssessmentsPath(job_id: ScalarType, application_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "applications" + "/" + application_id + "/" + "predictive_index" + "/" + "assessments" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","application_id","format"]);
}

/** /admin/jobs/:job_id/applications/:application_id/ref_now/employees(.:format) */
export function adminJobApplicationRefNowEmployeesPath(job_id: ScalarType, application_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "applications" + "/" + application_id + "/" + "ref_now" + "/" + "employees" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","application_id","format"]);
}

/** /admin/jobs/:job_id/applications/:application_id/ref_now/available_question_profiles(.:format) */
export function adminJobApplicationRefNowAvailableQuestionProfilesPath(job_id: ScalarType, application_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "applications" + "/" + application_id + "/" + "ref_now" + "/" + "available_question_profiles" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","application_id","format"]);
}

/** /admin/jobs/:job_id/applications/:application_id/rippling/candidates(.:format) */
export function adminJobApplicationRipplingCandidatesPath(job_id: ScalarType, application_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "applications" + "/" + application_id + "/" + "rippling" + "/" + "candidates" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","application_id","format"]);
}

/** /admin/jobs/:job_id/applications/:application_id/rippling/fields(.:format) */
export function adminJobApplicationRipplingFieldsPath(job_id: ScalarType, application_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "applications" + "/" + application_id + "/" + "rippling" + "/" + "fields" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","application_id","format"]);
}

/** /admin/jobs/:job_id/applications/:application_id/sage_people/employees(.:format) */
export function adminJobApplicationSagePeopleEmployeesPath(job_id: ScalarType, application_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "applications" + "/" + application_id + "/" + "sage_people" + "/" + "employees" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","application_id","format"]);
}

/** /admin/jobs/:job_id/applications/:application_id/sapling/employees(.:format) */
export function adminJobApplicationSaplingEmployeesPath(job_id: ScalarType, application_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "applications" + "/" + application_id + "/" + "sapling" + "/" + "employees" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","application_id","format"]);
}

/** /admin/jobs/:job_id/applications/:application_id/sapling/fields(.:format) */
export function adminJobApplicationSaplingFieldsPath(job_id: ScalarType, application_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "applications" + "/" + application_id + "/" + "sapling" + "/" + "fields" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","application_id","format"]);
}

/** /admin/jobs/:job_id/applications/:application_id/sftp_csv_transfer/employees(.:format) */
export function adminJobApplicationSftpCsvTransferEmployeesPath(job_id: ScalarType, application_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "applications" + "/" + application_id + "/" + "sftp_csv_transfer" + "/" + "employees" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","application_id","format"]);
}

/** /admin/jobs/:job_id/applications/:application_id/sftp_csv_transfer/fields(.:format) */
export function adminJobApplicationSftpCsvTransferFieldsPath(job_id: ScalarType, application_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "applications" + "/" + application_id + "/" + "sftp_csv_transfer" + "/" + "fields" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","application_id","format"]);
}

/** /admin/jobs/:job_id/applications/:application_id/sterling/background_checks(.:format) */
export function adminJobApplicationSterlingBackgroundChecksPath(job_id: ScalarType, application_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "applications" + "/" + application_id + "/" + "sterling" + "/" + "background_checks" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","application_id","format"]);
}

/** /admin/jobs/:job_id/applications/:application_id/sterling/fields(.:format) */
export function adminJobApplicationSterlingFieldsPath(job_id: ScalarType, application_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "applications" + "/" + application_id + "/" + "sterling" + "/" + "fields" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","application_id","format"]);
}

/** /admin/jobs/:job_id/applications/:application_id/shl/assessments(.:format) */
export function adminJobApplicationShlAssessmentsPath(job_id: ScalarType, application_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "applications" + "/" + application_id + "/" + "shl" + "/" + "assessments" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","application_id","format"]);
}

/** /admin/jobs/:job_id/applications/:application_id/scorecards(.:format) */
export function adminJobApplicationScorecardsPath(job_id: ScalarType, application_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "applications" + "/" + application_id + "/" + "scorecards" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","application_id","format"]);
}

/** /admin/jobs/:job_id/applications/:application_id/trust_id/background_checks(.:format) */
export function adminJobApplicationTrustIdBackgroundChecksPath(job_id: ScalarType, application_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "applications" + "/" + application_id + "/" + "trust_id" + "/" + "background_checks" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","application_id","format"]);
}

/** /admin/jobs/:job_id/applications/:application_id/test_gorilla/assessments(.:format) */
export function adminJobApplicationTestGorillaAssessmentsPath(job_id: ScalarType, application_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "applications" + "/" + application_id + "/" + "test_gorilla" + "/" + "assessments" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","application_id","format"]);
}

/** /admin/jobs/:job_id/applications/:application_id/video_interviews(.:format) */
export function adminJobApplicationVideoInterviewsPath(job_id: ScalarType, application_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "applications" + "/" + application_id + "/" + "video_interviews" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","application_id","format"]);
}

/** /admin/jobs/:job_id/applications/:application_id/zinc/background_checks(.:format) */
export function adminJobApplicationZincBackgroundChecksPath(job_id: ScalarType, application_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "applications" + "/" + application_id + "/" + "zinc" + "/" + "background_checks" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","application_id","format"]);
}

/** /admin/jobs/:job_id/applications/:application_id/zinc/results/:id(.:format) */
export function adminJobApplicationZincResultPath(job_id: ScalarType, application_id: ScalarType, id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "applications" + "/" + application_id + "/" + "zinc" + "/" + "results" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","application_id","id","format"]);
}

/** /admin/jobs/:job_id/applications(.:format) */
export function adminJobApplicationsPath(job_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "applications" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","format"]);
}

/** /admin/jobs/:job_id/applications/new(.:format) */
export function newAdminJobApplicationPath(job_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "applications" + "/" + "new" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","format"]);
}

/** /admin/jobs/:job_id/applications/:id(.:format) */
export function adminJobApplicationPath(job_id: ScalarType, id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "applications" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","id","format"]);
}

/** /admin/jobs/:job_id/job_seekers/invite_emails(.:format) */
export function adminJobJobSeekersInviteEmailsPath(job_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "job_seekers" + "/" + "invite_emails" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","format"]);
}

/** /admin/jobs/:job_id/sign_off/request_approval_emails(.:format) */
export function adminJobSignOffRequestApprovalEmailsPath(job_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "sign_off" + "/" + "request_approval_emails" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","format"]);
}

/** /admin/jobs/:job_id/registered-candidates(.:format) */
export function adminJobJobSeekersPath(job_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "registered-candidates" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","format"]);
}

/** /admin/jobs/:job_id/sign_off(.:format) */
export function adminJobSignOffIndexPath(job_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "sign_off" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","format"]);
}

/** /admin/jobs/:job_id/scorecard_ratings(.:format) */
export function adminJobScorecardRatingsPath(job_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "scorecard_ratings" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","format"]);
}

/** /admin/jobs/:job_id/bulk_offers_previews/pdf(.:format) */
export function pdfAdminJobBulkOffersPreviewsPath(job_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "bulk_offers_previews" + "/" + "pdf" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","format"]);
}

/** /admin/jobs/:job_id/offer_letter/edit(.:format) */
export function editAdminJobOfferLetterPath(job_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "offer_letter" + "/" + "edit" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","format"]);
}

/** /admin/jobs/:job_id/offer_letter(.:format) */
export function adminJobOfferLetterPath(job_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "offer_letter" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","format"]);
}

/** /admin/jobs/:job_id/stages/edit(.:format) */
export function editAdminJobStagesPath(job_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "stages" + "/" + "edit" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","format"]);
}

/** /admin/jobs/:job_id/stages/:stage_id/applications(.:format) */
export function adminJobStageApplicationsPath(job_id: ScalarType, stage_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "stages" + "/" + stage_id + "/" + "applications" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","stage_id","format"]);
}

/** /admin/jobs/:job_id/stages/:stage_id/configuration(.:format) */
export function adminJobStageConfigurationPath(job_id: ScalarType, stage_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "stages" + "/" + stage_id + "/" + "configuration" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","stage_id","format"]);
}

/** /admin/jobs/:job_id/stages/:stage_id/hireflix/video_interviews/invite(.:format) */
export function inviteAdminJobStageHireflixVideoInterviewsPath(job_id: ScalarType, stage_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "stages" + "/" + stage_id + "/" + "hireflix" + "/" + "video_interviews" + "/" + "invite" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","stage_id","format"]);
}

/** /admin/jobs/:job_id/stages/:stage_id/hireflix/video_interviews/revoke_invitation(.:format) */
export function revokeInvitationAdminJobStageHireflixVideoInterviewsPath(job_id: ScalarType, stage_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "stages" + "/" + stage_id + "/" + "hireflix" + "/" + "video_interviews" + "/" + "revoke_invitation" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","stage_id","format"]);
}

/** /admin/jobs/:job_id/stages/:stage_id/hireflix/video_interviews(.:format) */
export function adminJobStageHireflixVideoInterviewsPath(job_id: ScalarType, stage_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "stages" + "/" + stage_id + "/" + "hireflix" + "/" + "video_interviews" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","stage_id","format"]);
}

/** /admin/jobs/:job_id/stages/:stage_id/willo/video_interviews/invite(.:format) */
export function inviteAdminJobStageWilloVideoInterviewsPath(job_id: ScalarType, stage_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "stages" + "/" + stage_id + "/" + "willo" + "/" + "video_interviews" + "/" + "invite" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","stage_id","format"]);
}

/** /admin/jobs/:job_id/stages/:stage_id/willo/video_interviews(.:format) */
export function adminJobStageWilloVideoInterviewsPath(job_id: ScalarType, stage_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "stages" + "/" + stage_id + "/" + "willo" + "/" + "video_interviews" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","stage_id","format"]);
}

/** /admin/jobs/:job_id/stages/:stage_id/interview_invites(.:format) */
export function adminJobStageInterviewInvitesPath(job_id: ScalarType, stage_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "stages" + "/" + stage_id + "/" + "interview_invites" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","stage_id","format"]);
}

/** /admin/jobs/:job_id/stages/:stage_id/video_interview_invites(.:format) */
export function adminJobStageVideoInterviewInvitesPath(job_id: ScalarType, stage_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "stages" + "/" + stage_id + "/" + "video_interview_invites" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","stage_id","format"]);
}

/** /admin/jobs/:job_id/stages/:stage_id/video_interview_invites/:id(.:format) */
export function adminJobStageVideoInterviewInvitePath(job_id: ScalarType, stage_id: ScalarType, id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "stages" + "/" + stage_id + "/" + "video_interview_invites" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","stage_id","id","format"]);
}

/** /admin/jobs/:job_id/stages/:stage_id/interview_openings/bulk_create(.:format) */
export function bulkCreateAdminJobStageInterviewOpeningsPath(job_id: ScalarType, stage_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "stages" + "/" + stage_id + "/" + "interview_openings" + "/" + "bulk_create" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","stage_id","format"]);
}

/** /admin/jobs/:job_id/stages/:stage_id/interview_openings(.:format) */
export function adminJobStageInterviewOpeningsPath(job_id: ScalarType, stage_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "stages" + "/" + stage_id + "/" + "interview_openings" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","stage_id","format"]);
}

/** /admin/jobs/:job_id/stages/:stage_id/interview_openings/:id(.:format) */
export function adminJobStageInterviewOpeningPath(job_id: ScalarType, stage_id: ScalarType, id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "stages" + "/" + stage_id + "/" + "interview_openings" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","stage_id","id","format"]);
}

/** /admin/jobs/:job_id/stages/:stage_id/interview_team_members_availability/availability(.:format) */
export function availabilityAdminJobStageInterviewTeamMembersAvailabilityPath(job_id: ScalarType, stage_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "stages" + "/" + stage_id + "/" + "interview_team_members_availability" + "/" + "availability" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","stage_id","format"]);
}

/** /admin/jobs/:job_id/stages(.:format) */
export function adminJobStagesPath(job_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "stages" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","format"]);
}

/** /admin/jobs/:job_id/sharing_links(.:format) */
export function adminJobSharingLinksPath(job_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "sharing_links" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","format"]);
}

/** /admin/jobs/:job_id/scorecard_downloads(.:format) */
export function adminJobScorecardDownloadsPath(job_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "scorecard_downloads" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","format"]);
}

/** /admin/jobs/:job_id/status(.:format) */
export function adminJobStatusPath(job_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "status" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","format"]);
}

/** /admin/jobs/:job_id/applications/:id/update_stage(.:format) */
export function updateStageAdminJobApplicationPath(job_id: ScalarType, id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + job_id + "/" + "applications" + "/" + id + "/" + "update_stage" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["job_id","id","format"]);
}

/** /admin/jobs(.:format) */
export function adminJobsPath(options?: object): string {
  return "/" + "admin" + "/" + "jobs" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/jobs/new(.:format) */
export function newAdminJobPath(options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + "new" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/jobs/:id/edit(.:format) */
export function editAdminJobPath(id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + id + "/" + "edit" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /admin/jobs/:id(.:format) */
export function adminJobPath(id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "jobs" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /admin/job_posting_previews/:id/application_form(.:format) */
export function applicationFormAdminJobPostingPreviewPath(id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "job_posting_previews" + "/" + id + "/" + "application_form" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /admin/job_posting_previews(.:format) */
export function adminJobPostingPreviewsPath(options?: object): string {
  return "/" + "admin" + "/" + "job_posting_previews" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/job_posting_previews/:id(.:format) */
export function adminJobPostingPreviewPath(id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "job_posting_previews" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /admin/requisitions(.:format) */
export function adminRequisitionsPath(options?: object): string {
  return "/" + "admin" + "/" + "requisitions" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/requisitions/new(.:format) */
export function newAdminRequisitionPath(options?: object): string {
  return "/" + "admin" + "/" + "requisitions" + "/" + "new" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/requisitions/:id/edit(.:format) */
export function editAdminRequisitionPath(id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "requisitions" + "/" + id + "/" + "edit" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /admin/requisitions/:id(.:format) */
export function adminRequisitionPath(id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "requisitions" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /admin/notifications(.:format) */
export function adminNotificationsPath(options?: object): string {
  return "/" + "admin" + "/" + "notifications" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/tasks/:id(.:format) */
export function adminTaskPath(id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "tasks" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /admin/users/users_notifications/bulk_update(.:format) */
export function bulkUpdateAdminUsersUsersNotificationsPath(options?: object): string {
  return "/" + "admin" + "/" + "users" + "/" + "users_notifications" + "/" + "bulk_update" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/reference_checks/preview_referee_form(.:format) */
export function adminReferenceChecksPreviewRefereeFormPath(options?: object): string {
  return "/" + "admin" + "/" + "reference_checks" + "/" + "preview_referee_form" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/reference_check_submissions/:reference_check_submission_id/documents(.:format) */
export function adminReferenceCheckSubmissionDocumentsPath(reference_check_submission_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "reference_check_submissions" + "/" + reference_check_submission_id + "/" + "documents" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["reference_check_submission_id","format"]);
}

/** /load_testing/rails(.:format) */
export function loadTestingRailsPath(options?: object): string {
  return "/" + "load_testing" + "/" + "rails" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /load_testing/postgres(.:format) */
export function loadTestingPostgresPath(options?: object): string {
  return "/" + "load_testing" + "/" + "postgres" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /load_testing/mysql(.:format) */
export function loadTestingMysqlPath(options?: object): string {
  return "/" + "load_testing" + "/" + "mysql" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /ci_slack/interaction(.:format) */
export function ciSlackInteractionPath(options?: object): string {
  return "/" + "ci_slack" + "/" + "interaction" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** / */
export function rootPath(options?: object): string {
  return "/" + $buildOptions(options, []);
}

/** /robots.txt(.:format) */
export function robotsPath(options?: object): string {
  return "/" + "robots" + "." + "txt" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /rails/active_storage/direct_uploads(.:format) */
export function customRailsDirectUploadsPath(options?: object): string {
  return "/" + "rails" + "/" + "active_storage" + "/" + "direct_uploads" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /mydata/gdpr_access_tokens/new(.:format) */
export function mydataGdprAccessTokensNewPath(options?: object): string {
  return "/" + "mydata" + "/" + "gdpr_access_tokens" + "/" + "new" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /dev/prosopite(.:format) */
export function devProsopitePath(options?: object): string {
  return "/" + "dev" + "/" + "prosopite" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /rails/action_mailbox/postmark/inbound_emails(.:format) */
export function railsPostmarkInboundEmailsPath(options?: object): string {
  return "/" + "rails" + "/" + "action_mailbox" + "/" + "postmark" + "/" + "inbound_emails" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /rails/action_mailbox/relay/inbound_emails(.:format) */
export function railsRelayInboundEmailsPath(options?: object): string {
  return "/" + "rails" + "/" + "action_mailbox" + "/" + "relay" + "/" + "inbound_emails" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /rails/action_mailbox/sendgrid/inbound_emails(.:format) */
export function railsSendgridInboundEmailsPath(options?: object): string {
  return "/" + "rails" + "/" + "action_mailbox" + "/" + "sendgrid" + "/" + "inbound_emails" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /rails/action_mailbox/mandrill/inbound_emails(.:format) */
export function railsMandrillInboundHealthCheckPath(options?: object): string {
  return "/" + "rails" + "/" + "action_mailbox" + "/" + "mandrill" + "/" + "inbound_emails" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /rails/action_mailbox/mandrill/inbound_emails(.:format) */
export function railsMandrillInboundEmailsPath(options?: object): string {
  return "/" + "rails" + "/" + "action_mailbox" + "/" + "mandrill" + "/" + "inbound_emails" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /rails/action_mailbox/mailgun/inbound_emails/mime(.:format) */
export function railsMailgunInboundEmailsPath(options?: object): string {
  return "/" + "rails" + "/" + "action_mailbox" + "/" + "mailgun" + "/" + "inbound_emails" + "/" + "mime" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /rails/conductor/action_mailbox/inbound_emails(.:format) */
export function railsConductorInboundEmailsPath(options?: object): string {
  return "/" + "rails" + "/" + "conductor" + "/" + "action_mailbox" + "/" + "inbound_emails" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /rails/conductor/action_mailbox/inbound_emails/new(.:format) */
export function newRailsConductorInboundEmailPath(options?: object): string {
  return "/" + "rails" + "/" + "conductor" + "/" + "action_mailbox" + "/" + "inbound_emails" + "/" + "new" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /rails/conductor/action_mailbox/inbound_emails/:id/edit(.:format) */
export function editRailsConductorInboundEmailPath(id: ScalarType, options?: object): string {
  return "/" + "rails" + "/" + "conductor" + "/" + "action_mailbox" + "/" + "inbound_emails" + "/" + id + "/" + "edit" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /rails/conductor/action_mailbox/inbound_emails/:id(.:format) */
export function railsConductorInboundEmailPath(id: ScalarType, options?: object): string {
  return "/" + "rails" + "/" + "conductor" + "/" + "action_mailbox" + "/" + "inbound_emails" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /rails/conductor/action_mailbox/:inbound_email_id/reroute(.:format) */
export function railsConductorInboundEmailReroutePath(inbound_email_id: ScalarType, options?: object): string {
  return "/" + "rails" + "/" + "conductor" + "/" + "action_mailbox" + "/" + inbound_email_id + "/" + "reroute" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["inbound_email_id","format"]);
}

/** /rails/active_storage/blobs/:signed_id/*filename(.:format) */
export function railsServiceBlobPath(signed_id: ScalarType, filename: ScalarType[], options?: object): string {
  return "/" + "rails" + "/" + "active_storage" + "/" + "blobs" + "/" + signed_id + "/" + filename.map((part) => $encode(part)).join("/") + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["signed_id","filename","format"]);
}

/** /rails/active_storage/representations/:signed_blob_id/:variation_key/*filename(.:format) */
export function railsBlobRepresentationPath(signed_blob_id: ScalarType, variation_key: ScalarType, filename: ScalarType[], options?: object): string {
  return "/" + "rails" + "/" + "active_storage" + "/" + "representations" + "/" + signed_blob_id + "/" + variation_key + "/" + filename.map((part) => $encode(part)).join("/") + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["signed_blob_id","variation_key","filename","format"]);
}

/** /rails/active_storage/disk/:encoded_key/*filename(.:format) */
export function railsDiskServicePath(encoded_key: ScalarType, filename: ScalarType[], options?: object): string {
  return "/" + "rails" + "/" + "active_storage" + "/" + "disk" + "/" + encoded_key + "/" + filename.map((part) => $encode(part)).join("/") + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["encoded_key","filename","format"]);
}

/** /rails/active_storage/disk/:encoded_token(.:format) */
export function updateRailsDiskServicePath(encoded_token: ScalarType, options?: object): string {
  return "/" + "rails" + "/" + "active_storage" + "/" + "disk" + "/" + encoded_token + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["encoded_token","format"]);
}

/** /rails/active_storage/direct_uploads(.:format) */
export function railsDirectUploadsPath(options?: object): string {
  return "/" + "rails" + "/" + "active_storage" + "/" + "direct_uploads" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}
